(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
(function (global){
( function( root, factory ) {
	// UMD wrapper.
	if ( typeof define === 'function' && define.amd ) {
		// AMD
		define( [ 'underscore', 'backbone', 'jquery' ], factory );
	} else if ( typeof exports !== 'undefined' ) {
		// Node/CommonJS
		module.exports = factory( (typeof window !== "undefined" ? window['_'] : typeof global !== "undefined" ? global['_'] : null), (typeof window !== "undefined" ? window['Backbone'] : typeof global !== "undefined" ? global['Backbone'] : null), (typeof window !== "undefined" ? window['Backbone'] : typeof global !== "undefined" ? global['Backbone'] : null).$ );
	} else {
		// Browser globals
		factory( root._, root.Backbone, ( root.jQuery || root.Zepto || root.$ ) );
	}
}( this, function( _, Backbone, $ ) {
	var delegateEventSplitter = /^(\S+)\s*(.*)$/;
	var lastPossibleViewElement = _.isFunction( $ ) ? $( "body" )[ 0 ] : null;

	Backbone.Courier = {};

	Backbone.Courier.add = function( view ) {
		var overriddenViewMethods = {
			setElement : view.setElement
		};

		// ****************** Public Courier functions ****************** 

		view.spawn = function( message, data ) {
			// can be called with message argument as an object, in which case message.name is required,
			// or can be called with message as a string that represents the name of the message and
			// data object which will be added to message object at message.data
			if( _.isString( message ) ) {
				message = {
					name : message,
					data : data
				};
			} else if( _.isUndefined( message.name ) ) throw new Error( "Undefined message name." );

			message.source = view;
			message.data = _.isUndefined( message.data ) ? {} : message.data;

			this.trigger( message.name, message.data );

			var isRoundTripMessage = message.name.charAt(message.name.length - 1) === "!";

			var curParent = this._getParentView();
			var messageShouldBePassed;
			var value;

			if( message.name === 'removeButtonClicked' ) console.log( 'gotit' ); // REMOVEME
	
			while( curParent ) {
				// check to see if curParent has an action to perform when this message is received.
				if( _.isObject( curParent.onMessages ) ) {
					value = getValueOfBestMatchingHashEntry( curParent.onMessages, message, curParent );
					if( value !== null ) {
						var method = value;
						if( ! _.isFunction( method ) ) method = curParent[ value ];
						if( ! method ) throw new Error( "Method \"" + value + "\" does not exist" );

						var returnValue = method.call( curParent, message.data, message.source, message.name );
						if( isRoundTripMessage ) return returnValue;
					}
				}

				messageShouldBePassed = isRoundTripMessage;

				// execute `passMessages` if its configured as a function
				var passMessages = _.result( curParent, "passMessages" );
				// check to see if this message should be passed up a level
				if( _.isObject( passMessages ) ) {
					value = getValueOfBestMatchingHashEntry( passMessages, message, curParent );
					if( value !== null ) {
						

						if( value === "." )
							; // noop - pass this message through exactly as-is
						else if( _.isString( value ) ) {
							// if value is a string, we pass the existing message but
							// change the name to the supplied string
							message.name = value;
						}
						else throw new TypeError( "Values of passMessages hash should be strings." );

						messageShouldBePassed = true;
					}
				}

				if( ! messageShouldBePassed ) break; // if this message should not be passed, then we are done

				message.source = curParent; // keep the source of the message current as the message bubbles up the view hierarchy
				curParent = curParent._getParentView();
			}

			if( isRoundTripMessage ) return undefined;
		};

		// supply your own _getParentView function on your view objects
		// if you would like to use custom means to determine a view's
		// "parent". The default means is to traverse the DOM tree and return
		// the closest parent element that has a view object attached in el.data( "view" )
		if( ! _.isFunction( view._getParentView ) )
			view._getParentView = function() {
				var parent = null;
				var curElement = this.$el.parent();
				while( curElement.length > 0 && curElement[0] !== lastPossibleViewElement ) {
					var view = curElement.data( "view" );
					if( view && _.isFunction( view.render ) ) {
						parent = view;
						break;
					}

					curElement = curElement.parent();
				}

				return parent;
			};

		// supply your own _getChildViewNamed function on your view objects
		// if you would like to use another means to test the source of your
		// messages (used for keys of onMessages and passMessages of the form
		// { "message source" : handler }). By default, child views are looked
		// up by name in view.subviews[ childViewName ] (and then tested against message.source)
		if( ! _.isFunction( view._getChildViewNamed ) )
			view._getChildViewNamed = function( childViewName ) {
				if( ! _.isObject( this.subviews ) ) return null;
				return this.subviews[ childViewName ];
			};

		// ****************** Overridden Backbone.View functions ****************** 

		view.setElement = function( element, delegate ) {
			var retval = overriddenViewMethods.setElement.call( this, element, delegate );
			prepareViewElement( view );
			return retval;
		};

		// ****************** Body of Backbone.Courier.add() function ****************** 

		if( view.$el ) prepareViewElement( view ); // otherwise this will be done when #setElement is called

		// ****************** Private Utility Functions ****************** 

		function prepareViewElement( view ) {
			// store a reference to the view object in the DOM element's jQuery data. Make sure it is supported.
			if( _.isFunction( view.$el.data ) && ! view.$el.data( "view" ) ) view.$el.data( "view", view );
		}

		function getValueOfBestMatchingHashEntry( hash, message, view ) {
			// return the value of the entry in a onMessages or passMessages hash that is the 
			// "most specific" match for this message, or null, if there are no matches.

			var matchingEntries = [];

			for( var key in hash ) {
				// We are looking for keys in the hash that have the `message` argument
				// as the first word of their key. If we find one, they either need
				// no source qualifier as the second word of the key (in which case
				// we will pass this message regardless of where it comes from),
				// or we need this the name of the subview that is the source of the
				// message second word of the key.

				var match = key.match( delegateEventSplitter );

				var eventName = match[ 1 ], subviewName = match[ 2 ];
				var eventNameRegEx = new RegExp( '^' + eventName.replace( /\*/g, "[\\w]*" ) + '$' );
				if( ! eventNameRegEx.test( message.name ) ) continue;

				if( subviewName !== "" && view._getChildViewNamed( subviewName ) !== message.source ) continue;

				matchingEntries.push( { eventName : eventName, subviewName : subviewName, value : hash[ key ] } );
			}

			// if more than one hash keys match, order them by specificity, that is,
			// in descending order of how many non-wild card characters they contain,
			// so that entry with most specificity is at index 0. Also, consider any
			// entries that have subview qualifier more specific than those that do not.
			if( matchingEntries.length > 1 )
				matchingEntries = _.sortBy( matchingEntries, function( thisEntry ) {
					var nonWildcardCharactersInEventName = thisEntry.eventName.replace( "*", "" );
					var hasSubviewQualifier = thisEntry.subviewName !== "";

					// promote all entries with subview qualifiers to a higher level of specificity.
					// Figure there will never, ever be a 1000 character long event name
					var specificity = ( hasSubviewQualifier ? 1000 : 0 ) + nonWildcardCharactersInEventName.length;

					// negate to sort in descending order
					return( - specificity );
				} );

			return matchingEntries.length ? matchingEntries[ 0 ].value : null;
		}
	};

	return Backbone.Courier;
} ) );

}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})

},{}],2:[function(require,module,exports){
(function (global){
var delegateEventSplitter = /^(\S+)\s*(.*)$/;

/*
 * Backbone.Handle, v0.1
 * Copyright (c)2014 Rotunda Software, LLC.
 * Parts adapted from Backbone.Marionette, Copyright (c)2014 Derick Bailey, Muted Solutions, LLC.
 * Distributed under MIT license
 * http://github.com/rotundasoftware/backbone.handle
 */

( function( root, factory ) {
	// UMD wrapper.
	if ( typeof define === 'function' && define.amd ) {
		// AMD
		define( [ 'underscore', 'backbone', 'jquery' ], factory );
	} else if ( typeof exports !== 'undefined' ) {
		// Node/CommonJS
		module.exports = factory( (typeof window !== "undefined" ? window['_'] : typeof global !== "undefined" ? global['_'] : null), (typeof window !== "undefined" ? window['Backbone'] : typeof global !== "undefined" ? global['Backbone'] : null), (typeof window !== "undefined" ? window['Backbone'] : typeof global !== "undefined" ? global['Backbone'] : null).$ );
	} else {
		// Browser globals
		factory( root._, root.Backbone, ( root.jQuery || root.Zepto || root.$ ) );
	}
}( this, function( _, Backbone, $ ) {
	Backbone.Handle = {};

	Backbone.Handle.add = function( view ) {
		var overriddenViewMethods = {
			delegateEvents : view.delegateEvents
		};

		view.resolveHandles = function() {
			var _this = this;

			if( this.ui ) {
				if( ! this.uiBindings ) {
					// We want to store a copy of the ui hash in uiBindings, since afterwards the values 
					// in the ui hash will be overridden with jQuery selectors, and we may need then again.
					this.uiBindings = _.result( this, "ui" );
				}

				// refreshing the associated selectors since they should point to the newly rendered elements.
				this.ui = {};
				_.each( _.keys( this.uiBindings ), function( key ) {
					var selector = _this.uiBindings[ key ];

					// if the selector ends with "!", we assert that there is exactly one DOM element that matches
					// the selector. That is, we through an error if the number of matches elements != 1.
					var assertOneAndOnlyOne = selector[ selector.length - 1 ] === "!";
					if( assertOneAndOnlyOne ) selector = selector.slice( 0, selector.length - 1 );
					_this.ui[ key ] = _this.$( selector );
					if( assertOneAndOnlyOne ) {
						if( _this.ui[ key ].length !== 1 )
							throw new Error( "Expected selector \"" + selector + "\" to match 1 element, but " + _this.ui[ key ].length + " found." );
						_this.uiBindings[ key ] = selector;
					}
				} );
			}
		};

		view.delegateEvents = function( events ) {
			var _this = this;

			if( _.isFunction( this.events ) ) this.events = this.events.call( this.events );
			events = events || _.clone( this.events ) || {};

			events = this._exapandUIHandlesInHash.call( this, events );

			return overriddenViewMethods.delegateEvents.call( this, events );
		};

		view._exapandUIHandlesInHash = function( events ) {
			var newEvents = {};

			var uiBindings = this.uiBindings || _.result( this, "ui" );
			if( ! uiBindings ) { return events; }

			_.each( events, function( value, key ) {
				var match = key.match( delegateEventSplitter );
				var eventName = match[ 1 ], uiElName = match[ 2 ];

				if( uiElName !== "" && ! _.isUndefined( uiBindings[ uiElName ] ) ) {
					var selector = uiBindings[ uiElName ];
					if( selector[ selector.length - 1 ] === "!" )
					selector = selector.slice( 0, selector.length - 1 );

					key = eventName + " " + selector;
				}

				newEvents[ key ] = value;
			} );

			return newEvents;
		};
	};

	return Backbone.Handle;
} ) );
}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})

},{}],3:[function(require,module,exports){
(function (global){
/*
 * Backbone.Subviews, v1.1.0
 * Copyright (c)2013-2017 Rotunda Software, LLC.
 * Distributed under MIT license
 * http://github.com/rotundasoftware/backbone.subviews
*/
( function( root, factory ) {
	// UMD wrapper
	if ( typeof define === 'function' && define.amd ) {
		// AMD
		define( [ 'underscore', 'backbone', 'jquery' ], factory );
	} else if ( typeof exports !== 'undefined' ) {
		// Node/CommonJS
		module.exports = factory( (typeof window !== "undefined" ? window['_'] : typeof global !== "undefined" ? global['_'] : null), (typeof window !== "undefined" ? window['Backbone'] : typeof global !== "undefined" ? global['Backbone'] : null), (typeof window !== "undefined" ? window['Backbone'] : typeof global !== "undefined" ? global['Backbone'] : null).$ );
	} else {
		// Browser globals
		factory( root._, root.Backbone, ( root.jQuery || root.Zepto || root.$ ) );
	}
}( this, function( _, Backbone, $ ) {
	Backbone.Subviews = {};

	Backbone.Subviews.add = function( view ) {
		var overriddenViewMethods = {
			render : view.render,
			remove : view.remove
		};

		// ****************** Overridden Backbone.View methods ****************** 

		view.render = function() {
			var args = Array.prototype.slice.call( arguments );

			_prerender.call( this );
			var returnValue = overriddenViewMethods.render.apply( this, args );
			_postrender.call( this );

			return returnValue;
		};

		view.remove = function() {
			this.removeSubviews();
			return overriddenViewMethods.remove.call( this );
		};

		// ****************** Additional public methods ****************** 

		view.removeSubviews = function() {
			// Removes all subviews and cleans up references in this.subviews.

			if( this.subviews ) {
				_.each( this.subviews, function( thisSubview ) {
					thisSubview.remove();
				} );

				delete this.subviews;
			}
		};

		// ****************** Additional private methods ****************** 

		view._createSubview = function( subviewName, placeHolderDiv ) {
			// Return a new subview instance given a subview name and its placeHolderDiv.
			// Implemented as instance method so that this behavior may be customized / overridden.
			var subviewCreator = this.subviewCreators[ subviewName ];
			if( _.isUndefined( subviewCreator ) ) throw new Error( "Can not find subview creator for subview named: " + subviewName );

			return subviewCreator.apply( this );
		};
	};

	// ****************** Private utility functions ****************** 

	function _prerender() {
		if( ! this.subviews ) this.subviews = {};

		// Detach each of our subviews that we have already created during previous
		// renders from the DOM, so that they do not loose their DOM events when
		// we re-render the contents of this view's DOM element.
		_.each( this.subviews, function( thisSubview ) {
			thisSubview.$el.detach();
		} );
	}

	function _postrender() {
		var _this = this;
		this.subviewCreators = this.subviewCreators || {};

		// Support subviewCreators as both objects and functions.
		if( _.isFunction( this.subviewCreators ) ) this.subviewCreators = this.subviewCreators();
		
		this.$( "[data-subview]" ).each( function() {
			var thisPlaceHolderDiv = $( this );
			var subviewName = thisPlaceHolderDiv.attr( "data-subview" );
			var newSubview;

			if( _.isUndefined( _this.subviews[ subviewName ] ) ) {
				newSubview = _this._createSubview( subviewName, thisPlaceHolderDiv );
				if( newSubview === null ) return;  // subview creators can return null to indicate that the subview should not be created
				_this.subviews[ subviewName ] = newSubview;
			}
			else {
				// If the subview is already defined, then use the existing subview instead
				// of creating a new one. This allows us to re-render a parent view without
				// loosing any dynamic state data on the existing subview objects. To force
				// re-initialization of subviews, call view.removeSubviews before re-rendering.

				newSubview = _this.subviews[ subviewName ];
			}

			thisPlaceHolderDiv.replaceWith( newSubview.$el );
		} );

		if( _.isFunction( this.onSubviewsCreated ) ) this.onSubviewsCreated.call( this );
		if( _.isFunction( this._onSubviewsCreated ) ) this._onSubviewsCreated.call( this );

		// Now that all subviews have been created, render them one at a time, in the
		// order they occur in the DOM.
		_.each( this.subviews, function( thisSubview ) {
			thisSubview.render();
		} );

		// Call this.onSubviewsRendered after everything is done (hook for application defined logic)
		if( _.isFunction( this.onSubviewsRendered ) ) this.onSubviewsRendered.call( this );
		if( _.isFunction( this._onSubviewsRendered ) ) this._onSubviewsRendered.call( this );
	}

	return Backbone.Subviews;
} ) );

}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})

},{}],4:[function(require,module,exports){
(function (global){
/*
 * Backbone.ViewOptions, v0.2.4
 * Copyright (c)2014 Rotunda Software, LLC.
 * Distributed under MIT license
 * http://github.com/rotundasoftware/backbone.viewOptions
*/

( function( root, factory ) {
	if ( typeof define === 'function' && define.amd ) {
		// AMD
		define([ 'underscore', 'backbone' ], factory );
	} else if (typeof exports === 'object') {
		// Node
		module.exports = factory( (typeof window !== "undefined" ? window['_'] : typeof global !== "undefined" ? global['_'] : null), (typeof window !== "undefined" ? window['Backbone'] : typeof global !== "undefined" ? global['Backbone'] : null) );
	} else {
		// Browser globals
		root.returnExports = factory( root._, root.Backbone );
	}
} ( this, function( _, Backbone ) {
	Backbone.ViewOptions = {};

	Backbone.ViewOptions.add = function( view, optionsDeclarationsProperty ) {
		if( _.isUndefined( optionsDeclarationsProperty ) ) optionsDeclarationsProperty = "options";

		// ****************** Public methods added to view ******************

		view.setOptions = function( options ) {
			var _this = this;
			var optionsThatWereChanged = {};
			var optionsThatWereChangedPreviousValues = {};

			var optionDeclarations = _.result( this, optionsDeclarationsProperty );

			if( _.isString( options ) ) {
				var optionsAsObject = {};
				optionsAsObject[ arguments[ 0 ] ] = arguments[ 1 ];
				options = optionsAsObject;
			}

			if( ! _.isUndefined( optionDeclarations ) ) {
				var normalizedOptionDeclarations = _normalizeOptionDeclarations( optionDeclarations );

				_.each( normalizedOptionDeclarations, function( thisOptionProperties, thisOptionName ) {
					var thisOptionRequired = thisOptionProperties.required;
					var thisOptionDefaultValue = thisOptionProperties.defaultValue;

					if( thisOptionRequired ) {
						// note we do not throw an error if a required option is not supplied, but it is
						// found on the object itself (due to a prior call of view.setOptions, most likely)

						if( ( ! options || ! _.contains( _.keys( options ), thisOptionName ) ) && _.isUndefined( _this[ thisOptionName ] ) )
							throw new Error( "Required option \"" + thisOptionName + "\" was not supplied." );

						if( options && _.contains( _.keys( options ), thisOptionName ) && _.isUndefined( options[ thisOptionName ] ) )
							throw new Error( "Required option \"" + thisOptionName + "\" can not be set to undefined." );
					}

					// attach the supplied value of this option, or the appropriate default value, to the view object
					if( options && thisOptionName in options && ! _.isUndefined( options[ thisOptionName ] ) ) {
						var oldValue = _this[ thisOptionName ];
						var newValue = options[ thisOptionName ];
						// if this option already exists on the view, and the new value is different,
						// make a note that we will be changing it
						if( ! _.isUndefined( oldValue ) && oldValue !== newValue ) {
							optionsThatWereChangedPreviousValues[ thisOptionName ] = oldValue;
							optionsThatWereChanged[ thisOptionName ] = newValue;
						}
						_this[ thisOptionName ] = newValue;
						// note we do NOT delete the option off the options object here so that
						// multiple views can be passed the same options object without issue.
					}
					else if( _.isUndefined( _this[ thisOptionName ] ) ) {
						// note defaults do not write over any existing properties on the view itself.
						_this[ thisOptionName ] = thisOptionDefaultValue;
					}
				} );
			}

			if( _.keys( optionsThatWereChanged ).length > 0 ) {
				if( _.isFunction( _this.onOptionsChanged ) )
					_this.onOptionsChanged( optionsThatWereChanged, optionsThatWereChangedPreviousValues );
				else if( _.isFunction( _this._onOptionsChanged ) )
					_this._onOptionsChanged( optionsThatWereChanged, optionsThatWereChangedPreviousValues );
			}
		};

		view.getOptions = function( whichOptions ) {
			var optionDeclarations = _.result( this, optionsDeclarationsProperty );
			if( _.isUndefined( optionDeclarations ) ) return {};

			var normalizedOptionDeclarations = _normalizeOptionDeclarations( optionDeclarations );
			var optionsNames = _.keys( normalizedOptionDeclarations );

			if( _.isUndefined( whichOptions ) ) whichOptions = optionsNames;
			else if( _.isString( whichOptions ) ) whichOptions = [ whichOptions ];

			return _.pick( this, optionsNames );
		};
	};

	// ****************** Private Utility Functions ******************

	function _normalizeOptionDeclarations( optionDeclarations ) {
		// convert our short-hand option syntax (with exclamation marks, etc.)
		// to a simple array of standard option declaration objects.

		var normalizedOptionDeclarations = {};

		if( ! _.isArray( optionDeclarations ) ) throw new Error( "Option declarations must be an array." );

		_.each( optionDeclarations, function( thisOptionDeclaration ) {
			var thisOptionName, thisOptionRequired, thisOptionDefaultValue;

			thisOptionRequired = false;
			thisOptionDefaultValue = undefined;

			if( _.isString( thisOptionDeclaration ) )
				thisOptionName = thisOptionDeclaration;
			else if( _.isObject( thisOptionDeclaration ) ) {
				thisOptionName = _.first( _.keys( thisOptionDeclaration ) );
				if( _.isFunction( thisOptionDeclaration[ thisOptionName ] ) || _.isRegExp( thisOptionDeclaration[ thisOptionName ] ) )
					thisOptionDefaultValue = thisOptionDeclaration[ thisOptionName ];
				else
					thisOptionDefaultValue = _.clone( thisOptionDeclaration[ thisOptionName ] );
			}
			else throw new Error( "Each element in the option declarations array must be either a string or an object." );

			if( thisOptionName[ thisOptionName.length - 1 ] === "!" ) {
				thisOptionRequired = true;
				thisOptionName = thisOptionName.slice( 0, thisOptionName.length - 1 );
			}

			normalizedOptionDeclarations[ thisOptionName ] = normalizedOptionDeclarations[ thisOptionName ] || {};
			normalizedOptionDeclarations[ thisOptionName ].required = thisOptionRequired;
			if( ! _.isUndefined( thisOptionDefaultValue ) ) normalizedOptionDeclarations[ thisOptionName ].defaultValue = thisOptionDefaultValue;
		} );

		return normalizedOptionDeclarations;
	}

	return Backbone.ViewOptions;

} ) );

}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})

},{}],5:[function(require,module,exports){
(function (global){
// Backbone.BabySitter
// -------------------
// v0.1.11
//
// Copyright (c)2016 Derick Bailey, Muted Solutions, LLC.
// Distributed under MIT license
//
// http://github.com/marionettejs/backbone.babysitter

(function(root, factory) {

  if (typeof define === 'function' && define.amd) {
    define(['backbone', 'underscore'], function(Backbone, _) {
      return factory(Backbone, _);
    });
  } else if (typeof exports !== 'undefined') {
    var Backbone = (typeof window !== "undefined" ? window['Backbone'] : typeof global !== "undefined" ? global['Backbone'] : null);
    var _ = (typeof window !== "undefined" ? window['_'] : typeof global !== "undefined" ? global['_'] : null);
    module.exports = factory(Backbone, _);
  } else {
    factory(root.Backbone, root._);
  }

}(this, function(Backbone, _) {
  'use strict';

  var previousChildViewContainer = Backbone.ChildViewContainer;

  // BabySitter.ChildViewContainer
  // -----------------------------
  //
  // Provide a container to store, retrieve and
  // shut down child views.
  
  Backbone.ChildViewContainer = (function (Backbone, _) {
  
    // Container Constructor
    // ---------------------
  
    var Container = function(views){
      this._views = {};
      this._indexByModel = {};
      this._indexByCustom = {};
      this._updateLength();
  
      _.each(views, this.add, this);
    };
  
    // Container Methods
    // -----------------
  
    _.extend(Container.prototype, {
  
      // Add a view to this container. Stores the view
      // by `cid` and makes it searchable by the model
      // cid (and model itself). Optionally specify
      // a custom key to store an retrieve the view.
      add: function(view, customIndex){
        var viewCid = view.cid;
  
        // store the view
        this._views[viewCid] = view;
  
        // index it by model
        if (view.model){
          this._indexByModel[view.model.cid] = viewCid;
        }
  
        // index by custom
        if (customIndex){
          this._indexByCustom[customIndex] = viewCid;
        }
  
        this._updateLength();
        return this;
      },
  
      // Find a view by the model that was attached to
      // it. Uses the model's `cid` to find it.
      findByModel: function(model){
        return this.findByModelCid(model.cid);
      },
  
      // Find a view by the `cid` of the model that was attached to
      // it. Uses the model's `cid` to find the view `cid` and
      // retrieve the view using it.
      findByModelCid: function(modelCid){
        var viewCid = this._indexByModel[modelCid];
        return this.findByCid(viewCid);
      },
  
      // Find a view by a custom indexer.
      findByCustom: function(index){
        var viewCid = this._indexByCustom[index];
        return this.findByCid(viewCid);
      },
  
      // Find by index. This is not guaranteed to be a
      // stable index.
      findByIndex: function(index){
        return _.values(this._views)[index];
      },
  
      // retrieve a view by its `cid` directly
      findByCid: function(cid){
        return this._views[cid];
      },
  
      // Remove a view
      remove: function(view){
        var viewCid = view.cid;
  
        // delete model index
        if (view.model){
          delete this._indexByModel[view.model.cid];
        }
  
        // delete custom index
        _.any(this._indexByCustom, function(cid, key) {
          if (cid === viewCid) {
            delete this._indexByCustom[key];
            return true;
          }
        }, this);
  
        // remove the view from the container
        delete this._views[viewCid];
  
        // update the length
        this._updateLength();
        return this;
      },
  
      // Call a method on every view in the container,
      // passing parameters to the call method one at a
      // time, like `function.call`.
      call: function(method){
        this.apply(method, _.tail(arguments));
      },
  
      // Apply a method on every view in the container,
      // passing parameters to the call method one at a
      // time, like `function.apply`.
      apply: function(method, args){
        _.each(this._views, function(view){
          if (_.isFunction(view[method])){
            view[method].apply(view, args || []);
          }
        });
      },
  
      // Update the `.length` attribute on this container
      _updateLength: function(){
        this.length = _.size(this._views);
      }
    });
  
    // Borrowing this code from Backbone.Collection:
    // http://backbonejs.org/docs/backbone.html#section-106
    //
    // Mix in methods from Underscore, for iteration, and other
    // collection related features.
    var methods = ['forEach', 'each', 'map', 'find', 'detect', 'filter',
      'select', 'reject', 'every', 'all', 'some', 'any', 'include',
      'contains', 'invoke', 'toArray', 'first', 'initial', 'rest',
      'last', 'without', 'isEmpty', 'pluck', 'reduce'];
  
    _.each(methods, function(method) {
      Container.prototype[method] = function() {
        var views = _.values(this._views);
        var args = [views].concat(_.toArray(arguments));
        return _[method].apply(_, args);
      };
    });
  
    // return the public API
    return Container;
  })(Backbone, _);
  

  Backbone.ChildViewContainer.VERSION = '0.1.11';

  Backbone.ChildViewContainer.noConflict = function () {
    Backbone.ChildViewContainer = previousChildViewContainer;
    return this;
  };

  return Backbone.ChildViewContainer;

}));

}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})

},{}],6:[function(require,module,exports){
(function (global){
// MarionetteJS (Backbone.Marionette)
// ----------------------------------
// v2.4.7
//
// Copyright (c)2016 Derick Bailey, Muted Solutions, LLC.
// Distributed under MIT license
//
// http://marionettejs.com

(function(root, factory) {

  if (typeof define === 'function' && define.amd) {
    define(['backbone', 'underscore', 'backbone.wreqr', 'backbone.babysitter'], function(Backbone, _) {
      return (root.Marionette = root.Mn = factory(root, Backbone, _));
    });
  } else if (typeof exports !== 'undefined') {
    var Backbone = (typeof window !== "undefined" ? window['Backbone'] : typeof global !== "undefined" ? global['Backbone'] : null);
    var _ = (typeof window !== "undefined" ? window['_'] : typeof global !== "undefined" ? global['_'] : null);
    var Wreqr = require('backbone.wreqr');
    var BabySitter = require('backbone.babysitter');
    module.exports = factory(root, Backbone, _);
  } else {
    root.Marionette = root.Mn = factory(root, root.Backbone, root._);
  }

}(this, function(root, Backbone, _) {
  'use strict';

  var previousMarionette = root.Marionette;
  var previousMn = root.Mn;

  var Marionette = Backbone.Marionette = {};

  Marionette.VERSION = '2.4.7';

  Marionette.noConflict = function() {
    root.Marionette = previousMarionette;
    root.Mn = previousMn;
    return this;
  };

  // Get the Deferred creator for later use
  Marionette.Deferred = Backbone.$.Deferred;

  Marionette.FEATURES = {
  };
  
  Marionette.isEnabled = function(name) {
    return !!Marionette.FEATURES[name];
  };
  
  /* jshint unused: false *//* global console */
  
  // Helpers
  // -------
  
  // Marionette.extend
  // -----------------
  
  // Borrow the Backbone `extend` method so we can use it as needed
  Marionette.extend = Backbone.Model.extend;
  
  // Marionette.isNodeAttached
  // -------------------------
  
  // Determine if `el` is a child of the document
  Marionette.isNodeAttached = function(el) {
    return Backbone.$.contains(document.documentElement, el);
  };
  
  // Merge `keys` from `options` onto `this`
  Marionette.mergeOptions = function(options, keys) {
    if (!options) { return; }
    _.extend(this, _.pick(options, keys));
  };
  
  // Marionette.getOption
  // --------------------
  
  // Retrieve an object, function or other value from a target
  // object or its `options`, with `options` taking precedence.
  Marionette.getOption = function(target, optionName) {
    if (!target || !optionName) { return; }
    if (target.options && (target.options[optionName] !== undefined)) {
      return target.options[optionName];
    } else {
      return target[optionName];
    }
  };
  
  // Proxy `Marionette.getOption`
  Marionette.proxyGetOption = function(optionName) {
    return Marionette.getOption(this, optionName);
  };
  
  // Similar to `_.result`, this is a simple helper
  // If a function is provided we call it with context
  // otherwise just return the value. If the value is
  // undefined return a default value
  Marionette._getValue = function(value, context, params) {
    if (_.isFunction(value)) {
      value = params ? value.apply(context, params) : value.call(context);
    }
    return value;
  };
  
  // Marionette.normalizeMethods
  // ----------------------
  
  // Pass in a mapping of events => functions or function names
  // and return a mapping of events => functions
  Marionette.normalizeMethods = function(hash) {
    return _.reduce(hash, function(normalizedHash, method, name) {
      if (!_.isFunction(method)) {
        method = this[method];
      }
      if (method) {
        normalizedHash[name] = method;
      }
      return normalizedHash;
    }, {}, this);
  };
  
  // utility method for parsing @ui. syntax strings
  // into associated selector
  Marionette.normalizeUIString = function(uiString, ui) {
    return uiString.replace(/@ui\.[a-zA-Z-_$0-9]*/g, function(r) {
      return ui[r.slice(4)];
    });
  };
  
  // allows for the use of the @ui. syntax within
  // a given key for triggers and events
  // swaps the @ui with the associated selector.
  // Returns a new, non-mutated, parsed events hash.
  Marionette.normalizeUIKeys = function(hash, ui) {
    return _.reduce(hash, function(memo, val, key) {
      var normalizedKey = Marionette.normalizeUIString(key, ui);
      memo[normalizedKey] = val;
      return memo;
    }, {});
  };
  
  // allows for the use of the @ui. syntax within
  // a given value for regions
  // swaps the @ui with the associated selector
  Marionette.normalizeUIValues = function(hash, ui, properties) {
    _.each(hash, function(val, key) {
      if (_.isString(val)) {
        hash[key] = Marionette.normalizeUIString(val, ui);
      } else if (_.isObject(val) && _.isArray(properties)) {
        _.extend(val, Marionette.normalizeUIValues(_.pick(val, properties), ui));
        /* Value is an object, and we got an array of embedded property names to normalize. */
        _.each(properties, function(property) {
          var propertyVal = val[property];
          if (_.isString(propertyVal)) {
            val[property] = Marionette.normalizeUIString(propertyVal, ui);
          }
        });
      }
    });
    return hash;
  };
  
  // Mix in methods from Underscore, for iteration, and other
  // collection related features.
  // Borrowing this code from Backbone.Collection:
  // http://backbonejs.org/docs/backbone.html#section-121
  Marionette.actAsCollection = function(object, listProperty) {
    var methods = ['forEach', 'each', 'map', 'find', 'detect', 'filter',
      'select', 'reject', 'every', 'all', 'some', 'any', 'include',
      'contains', 'invoke', 'toArray', 'first', 'initial', 'rest',
      'last', 'without', 'isEmpty', 'pluck'];
  
    _.each(methods, function(method) {
      object[method] = function() {
        var list = _.values(_.result(this, listProperty));
        var args = [list].concat(_.toArray(arguments));
        return _[method].apply(_, args);
      };
    });
  };
  
  var deprecate = Marionette.deprecate = function(message, test) {
    if (_.isObject(message)) {
      message = (
        message.prev + ' is going to be removed in the future. ' +
        'Please use ' + message.next + ' instead.' +
        (message.url ? ' See: ' + message.url : '')
      );
    }
  
    if ((test === undefined || !test) && !deprecate._cache[message]) {
      deprecate._warn('Deprecation warning: ' + message);
      deprecate._cache[message] = true;
    }
  };
  
  deprecate._console = typeof console !== 'undefined' ? console : {};
  deprecate._warn = function() {
    var warn = deprecate._console.warn || deprecate._console.log || function() {};
    return warn.apply(deprecate._console, arguments);
  };
  deprecate._cache = {};
  
  /* jshint maxstatements: 14, maxcomplexity: 7 */
  
  // Trigger Method
  // --------------
  
  Marionette._triggerMethod = (function() {
    // split the event name on the ":"
    var splitter = /(^|:)(\w)/gi;
  
    // take the event section ("section1:section2:section3")
    // and turn it in to uppercase name
    function getEventName(match, prefix, eventName) {
      return eventName.toUpperCase();
    }
  
    return function(context, event, args) {
      var noEventArg = arguments.length < 3;
      if (noEventArg) {
        args = event;
        event = args[0];
      }
  
      // get the method name from the event name
      var methodName = 'on' + event.replace(splitter, getEventName);
      var method = context[methodName];
      var result;
  
      // call the onMethodName if it exists
      if (_.isFunction(method)) {
        // pass all args, except the event name
        result = method.apply(context, noEventArg ? _.rest(args) : args);
      }
  
      // trigger the event, if a trigger method exists
      if (_.isFunction(context.trigger)) {
        if (noEventArg + args.length > 1) {
          context.trigger.apply(context, noEventArg ? args : [event].concat(_.drop(args, 0)));
        } else {
          context.trigger(event);
        }
      }
  
      return result;
    };
  })();
  
  // Trigger an event and/or a corresponding method name. Examples:
  //
  // `this.triggerMethod("foo")` will trigger the "foo" event and
  // call the "onFoo" method.
  //
  // `this.triggerMethod("foo:bar")` will trigger the "foo:bar" event and
  // call the "onFooBar" method.
  Marionette.triggerMethod = function(event) {
    return Marionette._triggerMethod(this, arguments);
  };
  
  // triggerMethodOn invokes triggerMethod on a specific context
  //
  // e.g. `Marionette.triggerMethodOn(view, 'show')`
  // will trigger a "show" event or invoke onShow the view.
  Marionette.triggerMethodOn = function(context) {
    var fnc = _.isFunction(context.triggerMethod) ?
                  context.triggerMethod :
                  Marionette.triggerMethod;
  
    return fnc.apply(context, _.rest(arguments));
  };
  
  // DOM Refresh
  // -----------
  
  // Monitor a view's state, and after it has been rendered and shown
  // in the DOM, trigger a "dom:refresh" event every time it is
  // re-rendered.
  
  Marionette.MonitorDOMRefresh = function(view) {
    if (view._isDomRefreshMonitored) { return; }
    view._isDomRefreshMonitored = true;
  
    // track when the view has been shown in the DOM,
    // using a Marionette.Region (or by other means of triggering "show")
    function handleShow() {
      view._isShown = true;
      triggerDOMRefresh();
    }
  
    // track when the view has been rendered
    function handleRender() {
      view._isRendered = true;
      triggerDOMRefresh();
    }
  
    // Trigger the "dom:refresh" event and corresponding "onDomRefresh" method
    function triggerDOMRefresh() {
      if (view._isShown && view._isRendered && Marionette.isNodeAttached(view.el)) {
        Marionette.triggerMethodOn(view, 'dom:refresh', view);
      }
    }
  
    view.on({
      show: handleShow,
      render: handleRender
    });
  };
  
  /* jshint maxparams: 5 */
  
  // Bind Entity Events & Unbind Entity Events
  // -----------------------------------------
  //
  // These methods are used to bind/unbind a backbone "entity" (e.g. collection/model)
  // to methods on a target object.
  //
  // The first parameter, `target`, must have the Backbone.Events module mixed in.
  //
  // The second parameter is the `entity` (Backbone.Model, Backbone.Collection or
  // any object that has Backbone.Events mixed in) to bind the events from.
  //
  // The third parameter is a hash of { "event:name": "eventHandler" }
  // configuration. Multiple handlers can be separated by a space. A
  // function can be supplied instead of a string handler name.
  
  (function(Marionette) {
    'use strict';
  
    // Bind the event to handlers specified as a string of
    // handler names on the target object
    function bindFromStrings(target, entity, evt, methods) {
      var methodNames = methods.split(/\s+/);
  
      _.each(methodNames, function(methodName) {
  
        var method = target[methodName];
        if (!method) {
          throw new Marionette.Error('Method "' + methodName +
            '" was configured as an event handler, but does not exist.');
        }
  
        target.listenTo(entity, evt, method);
      });
    }
  
    // Bind the event to a supplied callback function
    function bindToFunction(target, entity, evt, method) {
      target.listenTo(entity, evt, method);
    }
  
    // Bind the event to handlers specified as a string of
    // handler names on the target object
    function unbindFromStrings(target, entity, evt, methods) {
      var methodNames = methods.split(/\s+/);
  
      _.each(methodNames, function(methodName) {
        var method = target[methodName];
        target.stopListening(entity, evt, method);
      });
    }
  
    // Bind the event to a supplied callback function
    function unbindToFunction(target, entity, evt, method) {
      target.stopListening(entity, evt, method);
    }
  
    // generic looping function
    function iterateEvents(target, entity, bindings, functionCallback, stringCallback) {
      if (!entity || !bindings) { return; }
  
      // type-check bindings
      if (!_.isObject(bindings)) {
        throw new Marionette.Error({
          message: 'Bindings must be an object or function.',
          url: 'marionette.functions.html#marionettebindentityevents'
        });
      }
  
      // allow the bindings to be a function
      bindings = Marionette._getValue(bindings, target);
  
      // iterate the bindings and bind them
      _.each(bindings, function(methods, evt) {
  
        // allow for a function as the handler,
        // or a list of event names as a string
        if (_.isFunction(methods)) {
          functionCallback(target, entity, evt, methods);
        } else {
          stringCallback(target, entity, evt, methods);
        }
  
      });
    }
  
    // Export Public API
    Marionette.bindEntityEvents = function(target, entity, bindings) {
      iterateEvents(target, entity, bindings, bindToFunction, bindFromStrings);
    };
  
    Marionette.unbindEntityEvents = function(target, entity, bindings) {
      iterateEvents(target, entity, bindings, unbindToFunction, unbindFromStrings);
    };
  
    // Proxy `bindEntityEvents`
    Marionette.proxyBindEntityEvents = function(entity, bindings) {
      return Marionette.bindEntityEvents(this, entity, bindings);
    };
  
    // Proxy `unbindEntityEvents`
    Marionette.proxyUnbindEntityEvents = function(entity, bindings) {
      return Marionette.unbindEntityEvents(this, entity, bindings);
    };
  })(Marionette);
  

  // Error
  // -----
  
  var errorProps = ['description', 'fileName', 'lineNumber', 'name', 'message', 'number'];
  
  Marionette.Error = Marionette.extend.call(Error, {
    urlRoot: 'http://marionettejs.com/docs/v' + Marionette.VERSION + '/',
  
    constructor: function(message, options) {
      if (_.isObject(message)) {
        options = message;
        message = options.message;
      } else if (!options) {
        options = {};
      }
  
      var error = Error.call(this, message);
      _.extend(this, _.pick(error, errorProps), _.pick(options, errorProps));
  
      this.captureStackTrace();
  
      if (options.url) {
        this.url = this.urlRoot + options.url;
      }
    },
  
    captureStackTrace: function() {
      if (Error.captureStackTrace) {
        Error.captureStackTrace(this, Marionette.Error);
      }
    },
  
    toString: function() {
      return this.name + ': ' + this.message + (this.url ? ' See: ' + this.url : '');
    }
  });
  
  Marionette.Error.extend = Marionette.extend;
  
  // Callbacks
  // ---------
  
  // A simple way of managing a collection of callbacks
  // and executing them at a later point in time, using jQuery's
  // `Deferred` object.
  Marionette.Callbacks = function() {
    this._deferred = Marionette.Deferred();
    this._callbacks = [];
  };
  
  _.extend(Marionette.Callbacks.prototype, {
  
    // Add a callback to be executed. Callbacks added here are
    // guaranteed to execute, even if they are added after the
    // `run` method is called.
    add: function(callback, contextOverride) {
      var promise = _.result(this._deferred, 'promise');
  
      this._callbacks.push({cb: callback, ctx: contextOverride});
  
      promise.then(function(args) {
        if (contextOverride) { args.context = contextOverride; }
        callback.call(args.context, args.options);
      });
    },
  
    // Run all registered callbacks with the context specified.
    // Additional callbacks can be added after this has been run
    // and they will still be executed.
    run: function(options, context) {
      this._deferred.resolve({
        options: options,
        context: context
      });
    },
  
    // Resets the list of callbacks to be run, allowing the same list
    // to be run multiple times - whenever the `run` method is called.
    reset: function() {
      var callbacks = this._callbacks;
      this._deferred = Marionette.Deferred();
      this._callbacks = [];
  
      _.each(callbacks, function(cb) {
        this.add(cb.cb, cb.ctx);
      }, this);
    }
  });
  
  // Controller
  // ----------
  
  // A multi-purpose object to use as a controller for
  // modules and routers, and as a mediator for workflow
  // and coordination of other objects, views, and more.
  Marionette.Controller = function(options) {
    this.options = options || {};
  
    if (_.isFunction(this.initialize)) {
      this.initialize(this.options);
    }
  };
  
  Marionette.Controller.extend = Marionette.extend;
  
  // Controller Methods
  // --------------
  
  // Ensure it can trigger events with Backbone.Events
  _.extend(Marionette.Controller.prototype, Backbone.Events, {
    destroy: function() {
      Marionette._triggerMethod(this, 'before:destroy', arguments);
      Marionette._triggerMethod(this, 'destroy', arguments);
  
      this.stopListening();
      this.off();
      return this;
    },
  
    // import the `triggerMethod` to trigger events with corresponding
    // methods if the method exists
    triggerMethod: Marionette.triggerMethod,
  
    // A handy way to merge options onto the instance
    mergeOptions: Marionette.mergeOptions,
  
    // Proxy `getOption` to enable getting options from this or this.options by name.
    getOption: Marionette.proxyGetOption
  
  });
  
  // Object
  // ------
  
  // A Base Class that other Classes should descend from.
  // Object borrows many conventions and utilities from Backbone.
  Marionette.Object = function(options) {
    this.options = _.extend({}, _.result(this, 'options'), options);
  
    this.initialize.apply(this, arguments);
  };
  
  Marionette.Object.extend = Marionette.extend;
  
  // Object Methods
  // --------------
  
  // Ensure it can trigger events with Backbone.Events
  _.extend(Marionette.Object.prototype, Backbone.Events, {
  
    //this is a noop method intended to be overridden by classes that extend from this base
    initialize: function() {},
  
    destroy: function(options) {
      options = options || {};
  
      this.triggerMethod('before:destroy', options);
      this.triggerMethod('destroy', options);
      this.stopListening();
  
      return this;
    },
  
    // Import the `triggerMethod` to trigger events with corresponding
    // methods if the method exists
    triggerMethod: Marionette.triggerMethod,
  
    // A handy way to merge options onto the instance
    mergeOptions: Marionette.mergeOptions,
  
    // Proxy `getOption` to enable getting options from this or this.options by name.
    getOption: Marionette.proxyGetOption,
  
    // Proxy `bindEntityEvents` to enable binding view's events from another entity.
    bindEntityEvents: Marionette.proxyBindEntityEvents,
  
    // Proxy `unbindEntityEvents` to enable unbinding view's events from another entity.
    unbindEntityEvents: Marionette.proxyUnbindEntityEvents
  });
  
  /* jshint maxcomplexity: 16, maxstatements: 45, maxlen: 120 */
  
  // Region
  // ------
  
  // Manage the visual regions of your composite application. See
  // http://lostechies.com/derickbailey/2011/12/12/composite-js-apps-regions-and-region-managers/
  
  Marionette.Region = Marionette.Object.extend({
    constructor: function(options) {
  
      // set options temporarily so that we can get `el`.
      // options will be overriden by Object.constructor
      this.options = options || {};
      this.el = this.getOption('el');
  
      // Handle when this.el is passed in as a $ wrapped element.
      this.el = this.el instanceof Backbone.$ ? this.el[0] : this.el;
  
      if (!this.el) {
        throw new Marionette.Error({
          name: 'NoElError',
          message: 'An "el" must be specified for a region.'
        });
      }
  
      this.$el = this.getEl(this.el);
      Marionette.Object.call(this, options);
    },
  
    // Displays a backbone view instance inside of the region.
    // Handles calling the `render` method for you. Reads content
    // directly from the `el` attribute. Also calls an optional
    // `onShow` and `onDestroy` method on your view, just after showing
    // or just before destroying the view, respectively.
    // The `preventDestroy` option can be used to prevent a view from
    // the old view being destroyed on show.
    // The `forceShow` option can be used to force a view to be
    // re-rendered if it's already shown in the region.
    show: function(view, options) {
      if (!this._ensureElement()) {
        return;
      }
  
      this._ensureViewIsIntact(view);
      Marionette.MonitorDOMRefresh(view);
  
      var showOptions     = options || {};
      var isDifferentView = view !== this.currentView;
      var preventDestroy  = !!showOptions.preventDestroy;
      var forceShow       = !!showOptions.forceShow;
  
      // We are only changing the view if there is a current view to change to begin with
      var isChangingView = !!this.currentView;
  
      // Only destroy the current view if we don't want to `preventDestroy` and if
      // the view given in the first argument is different than `currentView`
      var _shouldDestroyView = isDifferentView && !preventDestroy;
  
      // Only show the view given in the first argument if it is different than
      // the current view or if we want to re-show the view. Note that if
      // `_shouldDestroyView` is true, then `_shouldShowView` is also necessarily true.
      var _shouldShowView = isDifferentView || forceShow;
  
      if (isChangingView) {
        this.triggerMethod('before:swapOut', this.currentView, this, options);
      }
  
      if (this.currentView && isDifferentView) {
        delete this.currentView._parent;
      }
  
      if (_shouldDestroyView) {
        this.empty();
  
      // A `destroy` event is attached to the clean up manually removed views.
      // We need to detach this event when a new view is going to be shown as it
      // is no longer relevant.
      } else if (isChangingView && _shouldShowView) {
        this.currentView.off('destroy', this.empty, this);
      }
  
      if (_shouldShowView) {
  
        // We need to listen for if a view is destroyed
        // in a way other than through the region.
        // If this happens we need to remove the reference
        // to the currentView since once a view has been destroyed
        // we can not reuse it.
        view.once('destroy', this.empty, this);
  
        // make this region the view's parent,
        // It's important that this parent binding happens before rendering
        // so that any events the child may trigger during render can also be
        // triggered on the child's ancestor views
        view._parent = this;
        this._renderView(view);
  
        if (isChangingView) {
          this.triggerMethod('before:swap', view, this, options);
        }
  
        this.triggerMethod('before:show', view, this, options);
        Marionette.triggerMethodOn(view, 'before:show', view, this, options);
  
        if (isChangingView) {
          this.triggerMethod('swapOut', this.currentView, this, options);
        }
  
        // An array of views that we're about to display
        var attachedRegion = Marionette.isNodeAttached(this.el);
  
        // The views that we're about to attach to the document
        // It's important that we prevent _getNestedViews from being executed unnecessarily
        // as it's a potentially-slow method
        var displayedViews = [];
  
        var attachOptions = _.extend({
          triggerBeforeAttach: this.triggerBeforeAttach,
          triggerAttach: this.triggerAttach
        }, showOptions);
  
        if (attachedRegion && attachOptions.triggerBeforeAttach) {
          displayedViews = this._displayedViews(view);
          this._triggerAttach(displayedViews, 'before:');
        }
  
        this.attachHtml(view);
        this.currentView = view;
  
        if (attachedRegion && attachOptions.triggerAttach) {
          displayedViews = this._displayedViews(view);
          this._triggerAttach(displayedViews);
        }
  
        if (isChangingView) {
          this.triggerMethod('swap', view, this, options);
        }
  
        this.triggerMethod('show', view, this, options);
        Marionette.triggerMethodOn(view, 'show', view, this, options);
  
        return this;
      }
  
      return this;
    },
  
    triggerBeforeAttach: true,
    triggerAttach: true,
  
    _triggerAttach: function(views, prefix) {
      var eventName = (prefix || '') + 'attach';
      _.each(views, function(view) {
        Marionette.triggerMethodOn(view, eventName, view, this);
      }, this);
    },
  
    _displayedViews: function(view) {
      return _.union([view], _.result(view, '_getNestedViews') || []);
    },
  
    _renderView: function(view) {
      if (!view.supportsRenderLifecycle) {
        Marionette.triggerMethodOn(view, 'before:render', view);
      }
      view.render();
      if (!view.supportsRenderLifecycle) {
        Marionette.triggerMethodOn(view, 'render', view);
      }
    },
  
    _ensureElement: function() {
      if (!_.isObject(this.el)) {
        this.$el = this.getEl(this.el);
        this.el = this.$el[0];
      }
  
      if (!this.$el || this.$el.length === 0) {
        if (this.getOption('allowMissingEl')) {
          return false;
        } else {
          throw new Marionette.Error('An "el" ' + this.$el.selector + ' must exist in DOM');
        }
      }
      return true;
    },
  
    _ensureViewIsIntact: function(view) {
      if (!view) {
        throw new Marionette.Error({
          name: 'ViewNotValid',
          message: 'The view passed is undefined and therefore invalid. You must pass a view instance to show.'
        });
      }
  
      if (view.isDestroyed) {
        throw new Marionette.Error({
          name: 'ViewDestroyedError',
          message: 'View (cid: "' + view.cid + '") has already been destroyed and cannot be used.'
        });
      }
    },
  
    // Override this method to change how the region finds the DOM
    // element that it manages. Return a jQuery selector object scoped
    // to a provided parent el or the document if none exists.
    getEl: function(el) {
      return Backbone.$(el, Marionette._getValue(this.options.parentEl, this));
    },
  
    // Override this method to change how the new view is
    // appended to the `$el` that the region is managing
    attachHtml: function(view) {
      this.$el.contents().detach();
  
      this.el.appendChild(view.el);
    },
  
    // Destroy the current view, if there is one. If there is no
    // current view, it does nothing and returns immediately.
    empty: function(options) {
      var view = this.currentView;
  
      var emptyOptions = options || {};
      var preventDestroy  = !!emptyOptions.preventDestroy;
      // If there is no view in the region
      // we should not remove anything
      if (!view) { return this; }
  
      view.off('destroy', this.empty, this);
      this.triggerMethod('before:empty', view);
      if (!preventDestroy) {
        this._destroyView();
      }
      this.triggerMethod('empty', view);
  
      // Remove region pointer to the currentView
      delete this.currentView;
  
      if (preventDestroy) {
        this.$el.contents().detach();
      }
  
      return this;
    },
  
    // call 'destroy' or 'remove', depending on which is found
    // on the view (if showing a raw Backbone view or a Marionette View)
    _destroyView: function() {
      var view = this.currentView;
      if (view.isDestroyed) { return; }
  
      if (!view.supportsDestroyLifecycle) {
        Marionette.triggerMethodOn(view, 'before:destroy', view);
      }
      if (view.destroy) {
        view.destroy();
      } else {
        view.remove();
  
        // appending isDestroyed to raw Backbone View allows regions
        // to throw a ViewDestroyedError for this view
        view.isDestroyed = true;
      }
      if (!view.supportsDestroyLifecycle) {
        Marionette.triggerMethodOn(view, 'destroy', view);
      }
    },
  
    // Attach an existing view to the region. This
    // will not call `render` or `onShow` for the new view,
    // and will not replace the current HTML for the `el`
    // of the region.
    attachView: function(view) {
      if (this.currentView) {
        delete this.currentView._parent;
      }
      view._parent = this;
      this.currentView = view;
      return this;
    },
  
    // Checks whether a view is currently present within
    // the region. Returns `true` if there is and `false` if
    // no view is present.
    hasView: function() {
      return !!this.currentView;
    },
  
    // Reset the region by destroying any existing view and
    // clearing out the cached `$el`. The next time a view
    // is shown via this region, the region will re-query the
    // DOM for the region's `el`.
    reset: function() {
      this.empty();
  
      if (this.$el) {
        this.el = this.$el.selector;
      }
  
      delete this.$el;
      return this;
    }
  
  },
  
  // Static Methods
  {
  
    // Build an instance of a region by passing in a configuration object
    // and a default region class to use if none is specified in the config.
    //
    // The config object should either be a string as a jQuery DOM selector,
    // a Region class directly, or an object literal that specifies a selector,
    // a custom regionClass, and any options to be supplied to the region:
    //
    // ```js
    // {
    //   selector: "#foo",
    //   regionClass: MyCustomRegion,
    //   allowMissingEl: false
    // }
    // ```
    //
    buildRegion: function(regionConfig, DefaultRegionClass) {
      if (_.isString(regionConfig)) {
        return this._buildRegionFromSelector(regionConfig, DefaultRegionClass);
      }
  
      if (regionConfig.selector || regionConfig.el || regionConfig.regionClass) {
        return this._buildRegionFromObject(regionConfig, DefaultRegionClass);
      }
  
      if (_.isFunction(regionConfig)) {
        return this._buildRegionFromRegionClass(regionConfig);
      }
  
      throw new Marionette.Error({
        message: 'Improper region configuration type.',
        url: 'marionette.region.html#region-configuration-types'
      });
    },
  
    // Build the region from a string selector like '#foo-region'
    _buildRegionFromSelector: function(selector, DefaultRegionClass) {
      return new DefaultRegionClass({el: selector});
    },
  
    // Build the region from a configuration object
    // ```js
    // { selector: '#foo', regionClass: FooRegion, allowMissingEl: false }
    // ```
    _buildRegionFromObject: function(regionConfig, DefaultRegionClass) {
      var RegionClass = regionConfig.regionClass || DefaultRegionClass;
      var options = _.omit(regionConfig, 'selector', 'regionClass');
  
      if (regionConfig.selector && !options.el) {
        options.el = regionConfig.selector;
      }
  
      return new RegionClass(options);
    },
  
    // Build the region directly from a given `RegionClass`
    _buildRegionFromRegionClass: function(RegionClass) {
      return new RegionClass();
    }
  });
  
  // Region Manager
  // --------------
  
  // Manage one or more related `Marionette.Region` objects.
  Marionette.RegionManager = Marionette.Controller.extend({
    constructor: function(options) {
      this._regions = {};
      this.length = 0;
  
      Marionette.Controller.call(this, options);
  
      this.addRegions(this.getOption('regions'));
    },
  
    // Add multiple regions using an object literal or a
    // function that returns an object literal, where
    // each key becomes the region name, and each value is
    // the region definition.
    addRegions: function(regionDefinitions, defaults) {
      regionDefinitions = Marionette._getValue(regionDefinitions, this, arguments);
  
      return _.reduce(regionDefinitions, function(regions, definition, name) {
        if (_.isString(definition)) {
          definition = {selector: definition};
        }
        if (definition.selector) {
          definition = _.defaults({}, definition, defaults);
        }
  
        regions[name] = this.addRegion(name, definition);
        return regions;
      }, {}, this);
    },
  
    // Add an individual region to the region manager,
    // and return the region instance
    addRegion: function(name, definition) {
      var region;
  
      if (definition instanceof Marionette.Region) {
        region = definition;
      } else {
        region = Marionette.Region.buildRegion(definition, Marionette.Region);
      }
  
      this.triggerMethod('before:add:region', name, region);
  
      region._parent = this;
      this._store(name, region);
  
      this.triggerMethod('add:region', name, region);
      return region;
    },
  
    // Get a region by name
    get: function(name) {
      return this._regions[name];
    },
  
    // Gets all the regions contained within
    // the `regionManager` instance.
    getRegions: function() {
      return _.clone(this._regions);
    },
  
    // Remove a region by name
    removeRegion: function(name) {
      var region = this._regions[name];
      this._remove(name, region);
  
      return region;
    },
  
    // Empty all regions in the region manager, and
    // remove them
    removeRegions: function() {
      var regions = this.getRegions();
      _.each(this._regions, function(region, name) {
        this._remove(name, region);
      }, this);
  
      return regions;
    },
  
    // Empty all regions in the region manager, but
    // leave them attached
    emptyRegions: function() {
      var regions = this.getRegions();
      _.invoke(regions, 'empty');
      return regions;
    },
  
    // Destroy all regions and shut down the region
    // manager entirely
    destroy: function() {
      this.removeRegions();
      return Marionette.Controller.prototype.destroy.apply(this, arguments);
    },
  
    // internal method to store regions
    _store: function(name, region) {
      if (!this._regions[name]) {
        this.length++;
      }
  
      this._regions[name] = region;
    },
  
    // internal method to remove a region
    _remove: function(name, region) {
      this.triggerMethod('before:remove:region', name, region);
      region.empty();
      region.stopListening();
  
      delete region._parent;
      delete this._regions[name];
      this.length--;
      this.triggerMethod('remove:region', name, region);
    }
  });
  
  Marionette.actAsCollection(Marionette.RegionManager.prototype, '_regions');
  

  // Template Cache
  // --------------
  
  // Manage templates stored in `<script>` blocks,
  // caching them for faster access.
  Marionette.TemplateCache = function(templateId) {
    this.templateId = templateId;
  };
  
  // TemplateCache object-level methods. Manage the template
  // caches from these method calls instead of creating
  // your own TemplateCache instances
  _.extend(Marionette.TemplateCache, {
    templateCaches: {},
  
    // Get the specified template by id. Either
    // retrieves the cached version, or loads it
    // from the DOM.
    get: function(templateId, options) {
      var cachedTemplate = this.templateCaches[templateId];
  
      if (!cachedTemplate) {
        cachedTemplate = new Marionette.TemplateCache(templateId);
        this.templateCaches[templateId] = cachedTemplate;
      }
  
      return cachedTemplate.load(options);
    },
  
    // Clear templates from the cache. If no arguments
    // are specified, clears all templates:
    // `clear()`
    //
    // If arguments are specified, clears each of the
    // specified templates from the cache:
    // `clear("#t1", "#t2", "...")`
    clear: function() {
      var i;
      var args = _.toArray(arguments);
      var length = args.length;
  
      if (length > 0) {
        for (i = 0; i < length; i++) {
          delete this.templateCaches[args[i]];
        }
      } else {
        this.templateCaches = {};
      }
    }
  });
  
  // TemplateCache instance methods, allowing each
  // template cache object to manage its own state
  // and know whether or not it has been loaded
  _.extend(Marionette.TemplateCache.prototype, {
  
    // Internal method to load the template
    load: function(options) {
      // Guard clause to prevent loading this template more than once
      if (this.compiledTemplate) {
        return this.compiledTemplate;
      }
  
      // Load the template and compile it
      var template = this.loadTemplate(this.templateId, options);
      this.compiledTemplate = this.compileTemplate(template, options);
  
      return this.compiledTemplate;
    },
  
    // Load a template from the DOM, by default. Override
    // this method to provide your own template retrieval
    // For asynchronous loading with AMD/RequireJS, consider
    // using a template-loader plugin as described here:
    // https://github.com/marionettejs/backbone.marionette/wiki/Using-marionette-with-requirejs
    loadTemplate: function(templateId, options) {
      var $template = Backbone.$(templateId);
  
      if (!$template.length) {
        throw new Marionette.Error({
          name: 'NoTemplateError',
          message: 'Could not find template: "' + templateId + '"'
        });
      }
      return $template.html();
    },
  
    // Pre-compile the template before caching it. Override
    // this method if you do not need to pre-compile a template
    // (JST / RequireJS for example) or if you want to change
    // the template engine used (Handebars, etc).
    compileTemplate: function(rawTemplate, options) {
      return _.template(rawTemplate, options);
    }
  });
  
  // Renderer
  // --------
  
  // Render a template with data by passing in the template
  // selector and the data to render.
  Marionette.Renderer = {
  
    // Render a template with data. The `template` parameter is
    // passed to the `TemplateCache` object to retrieve the
    // template function. Override this method to provide your own
    // custom rendering and template handling for all of Marionette.
    render: function(template, data) {
      if (!template) {
        throw new Marionette.Error({
          name: 'TemplateNotFoundError',
          message: 'Cannot render the template since its false, null or undefined.'
        });
      }
  
      var templateFunc = _.isFunction(template) ? template : Marionette.TemplateCache.get(template);
  
      return templateFunc(data);
    }
  };
  

  /* jshint maxlen: 114, nonew: false */
  // View
  // ----
  
  // The core view class that other Marionette views extend from.
  Marionette.View = Backbone.View.extend({
    isDestroyed: false,
    supportsRenderLifecycle: true,
    supportsDestroyLifecycle: true,
  
    constructor: function(options) {
      this.render = _.bind(this.render, this);
  
      options = Marionette._getValue(options, this);
  
      // this exposes view options to the view initializer
      // this is a backfill since backbone removed the assignment
      // of this.options
      // at some point however this may be removed
      this.options = _.extend({}, _.result(this, 'options'), options);
  
      this._behaviors = Marionette.Behaviors(this);
  
      Backbone.View.call(this, this.options);
  
      Marionette.MonitorDOMRefresh(this);
    },
  
    // Get the template for this view
    // instance. You can set a `template` attribute in the view
    // definition or pass a `template: "whatever"` parameter in
    // to the constructor options.
    getTemplate: function() {
      return this.getOption('template');
    },
  
    // Serialize a model by returning its attributes. Clones
    // the attributes to allow modification.
    serializeModel: function(model) {
      return model.toJSON.apply(model, _.rest(arguments));
    },
  
    // Mix in template helper methods. Looks for a
    // `templateHelpers` attribute, which can either be an
    // object literal, or a function that returns an object
    // literal. All methods and attributes from this object
    // are copies to the object passed in.
    mixinTemplateHelpers: function(target) {
      target = target || {};
      var templateHelpers = this.getOption('templateHelpers');
      templateHelpers = Marionette._getValue(templateHelpers, this);
      return _.extend(target, templateHelpers);
    },
  
    // normalize the keys of passed hash with the views `ui` selectors.
    // `{"@ui.foo": "bar"}`
    normalizeUIKeys: function(hash) {
      var uiBindings = _.result(this, '_uiBindings');
      return Marionette.normalizeUIKeys(hash, uiBindings || _.result(this, 'ui'));
    },
  
    // normalize the values of passed hash with the views `ui` selectors.
    // `{foo: "@ui.bar"}`
    normalizeUIValues: function(hash, properties) {
      var ui = _.result(this, 'ui');
      var uiBindings = _.result(this, '_uiBindings');
      return Marionette.normalizeUIValues(hash, uiBindings || ui, properties);
    },
  
    // Configure `triggers` to forward DOM events to view
    // events. `triggers: {"click .foo": "do:foo"}`
    configureTriggers: function() {
      if (!this.triggers) { return; }
  
      // Allow `triggers` to be configured as a function
      var triggers = this.normalizeUIKeys(_.result(this, 'triggers'));
  
      // Configure the triggers, prevent default
      // action and stop propagation of DOM events
      return _.reduce(triggers, function(events, value, key) {
        events[key] = this._buildViewTrigger(value);
        return events;
      }, {}, this);
    },
  
    // Overriding Backbone.View's delegateEvents to handle
    // the `triggers`, `modelEvents`, and `collectionEvents` configuration
    delegateEvents: function(events) {
      this._delegateDOMEvents(events);
      this.bindEntityEvents(this.model, this.getOption('modelEvents'));
      this.bindEntityEvents(this.collection, this.getOption('collectionEvents'));
  
      _.each(this._behaviors, function(behavior) {
        behavior.bindEntityEvents(this.model, behavior.getOption('modelEvents'));
        behavior.bindEntityEvents(this.collection, behavior.getOption('collectionEvents'));
      }, this);
  
      return this;
    },
  
    // internal method to delegate DOM events and triggers
    _delegateDOMEvents: function(eventsArg) {
      var events = Marionette._getValue(eventsArg || this.events, this);
  
      // normalize ui keys
      events = this.normalizeUIKeys(events);
      if (_.isUndefined(eventsArg)) {this.events = events;}
  
      var combinedEvents = {};
  
      // look up if this view has behavior events
      var behaviorEvents = _.result(this, 'behaviorEvents') || {};
      var triggers = this.configureTriggers();
      var behaviorTriggers = _.result(this, 'behaviorTriggers') || {};
  
      // behavior events will be overriden by view events and or triggers
      _.extend(combinedEvents, behaviorEvents, events, triggers, behaviorTriggers);
  
      Backbone.View.prototype.delegateEvents.call(this, combinedEvents);
    },
  
    // Overriding Backbone.View's undelegateEvents to handle unbinding
    // the `triggers`, `modelEvents`, and `collectionEvents` config
    undelegateEvents: function() {
      Backbone.View.prototype.undelegateEvents.apply(this, arguments);
  
      this.unbindEntityEvents(this.model, this.getOption('modelEvents'));
      this.unbindEntityEvents(this.collection, this.getOption('collectionEvents'));
  
      _.each(this._behaviors, function(behavior) {
        behavior.unbindEntityEvents(this.model, behavior.getOption('modelEvents'));
        behavior.unbindEntityEvents(this.collection, behavior.getOption('collectionEvents'));
      }, this);
  
      return this;
    },
  
    // Internal helper method to verify whether the view hasn't been destroyed
    _ensureViewIsIntact: function() {
      if (this.isDestroyed) {
        throw new Marionette.Error({
          name: 'ViewDestroyedError',
          message: 'View (cid: "' + this.cid + '") has already been destroyed and cannot be used.'
        });
      }
    },
  
    // Default `destroy` implementation, for removing a view from the
    // DOM and unbinding it. Regions will call this method
    // for you. You can specify an `onDestroy` method in your view to
    // add custom code that is called after the view is destroyed.
    destroy: function() {
      if (this.isDestroyed) { return this; }
  
      var args = _.toArray(arguments);
  
      this.triggerMethod.apply(this, ['before:destroy'].concat(args));
  
      // mark as destroyed before doing the actual destroy, to
      // prevent infinite loops within "destroy" event handlers
      // that are trying to destroy other views
      this.isDestroyed = true;
      this.triggerMethod.apply(this, ['destroy'].concat(args));
  
      // unbind UI elements
      this.unbindUIElements();
  
      this.isRendered = false;
  
      // remove the view from the DOM
      this.remove();
  
      // Call destroy on each behavior after
      // destroying the view.
      // This unbinds event listeners
      // that behaviors have registered for.
      _.invoke(this._behaviors, 'destroy', args);
  
      return this;
    },
  
    bindUIElements: function() {
      this._bindUIElements();
      _.invoke(this._behaviors, this._bindUIElements);
    },
  
    // This method binds the elements specified in the "ui" hash inside the view's code with
    // the associated jQuery selectors.
    _bindUIElements: function() {
      if (!this.ui) { return; }
  
      // store the ui hash in _uiBindings so they can be reset later
      // and so re-rendering the view will be able to find the bindings
      if (!this._uiBindings) {
        this._uiBindings = this.ui;
      }
  
      // get the bindings result, as a function or otherwise
      var bindings = _.result(this, '_uiBindings');
  
      // empty the ui so we don't have anything to start with
      this.ui = {};
  
      // bind each of the selectors
      _.each(bindings, function(selector, key) {
        this.ui[key] = this.$(selector);
      }, this);
    },
  
    // This method unbinds the elements specified in the "ui" hash
    unbindUIElements: function() {
      this._unbindUIElements();
      _.invoke(this._behaviors, this._unbindUIElements);
    },
  
    _unbindUIElements: function() {
      if (!this.ui || !this._uiBindings) { return; }
  
      // delete all of the existing ui bindings
      _.each(this.ui, function($el, name) {
        delete this.ui[name];
      }, this);
  
      // reset the ui element to the original bindings configuration
      this.ui = this._uiBindings;
      delete this._uiBindings;
    },
  
    // Internal method to create an event handler for a given `triggerDef` like
    // 'click:foo'
    _buildViewTrigger: function(triggerDef) {
  
      var options = _.defaults({}, triggerDef, {
        preventDefault: true,
        stopPropagation: true
      });
  
      var eventName = _.isObject(triggerDef) ? options.event : triggerDef;
  
      return function(e) {
        if (e) {
          if (e.preventDefault && options.preventDefault) {
            e.preventDefault();
          }
  
          if (e.stopPropagation && options.stopPropagation) {
            e.stopPropagation();
          }
        }
  
        var args = {
          view: this,
          model: this.model,
          collection: this.collection
        };
  
        this.triggerMethod(eventName, args);
      };
    },
  
    setElement: function() {
      var ret = Backbone.View.prototype.setElement.apply(this, arguments);
  
      // proxy behavior $el to the view's $el.
      // This is needed because a view's $el proxy
      // is not set until after setElement is called.
      _.invoke(this._behaviors, 'proxyViewProperties', this);
  
      return ret;
    },
  
    // import the `triggerMethod` to trigger events with corresponding
    // methods if the method exists
    triggerMethod: function() {
      var ret = Marionette._triggerMethod(this, arguments);
  
      this._triggerEventOnBehaviors(arguments);
      this._triggerEventOnParentLayout(arguments[0], _.rest(arguments));
  
      return ret;
    },
  
    _triggerEventOnBehaviors: function(args) {
      var triggerMethod = Marionette._triggerMethod;
      var behaviors = this._behaviors;
      // Use good ol' for as this is a very hot function
      for (var i = 0, length = behaviors && behaviors.length; i < length; i++) {
        triggerMethod(behaviors[i], args);
      }
    },
  
    _triggerEventOnParentLayout: function(eventName, args) {
      var layoutView = this._parentLayoutView();
      if (!layoutView) {
        return;
      }
  
      // invoke triggerMethod on parent view
      var eventPrefix = Marionette.getOption(layoutView, 'childViewEventPrefix');
      var prefixedEventName = eventPrefix + ':' + eventName;
      var callArgs = [this].concat(args);
  
      Marionette._triggerMethod(layoutView, prefixedEventName, callArgs);
  
      // call the parent view's childEvents handler
      var childEvents = Marionette.getOption(layoutView, 'childEvents');
  
      // since childEvents can be an object or a function use Marionette._getValue
      // to handle the abstaction for us.
      childEvents = Marionette._getValue(childEvents, layoutView);
      var normalizedChildEvents = layoutView.normalizeMethods(childEvents);
  
      if (normalizedChildEvents && _.isFunction(normalizedChildEvents[eventName])) {
        normalizedChildEvents[eventName].apply(layoutView, callArgs);
      }
    },
  
    // This method returns any views that are immediate
    // children of this view
    _getImmediateChildren: function() {
      return [];
    },
  
    // Returns an array of every nested view within this view
    _getNestedViews: function() {
      var children = this._getImmediateChildren();
  
      if (!children.length) { return children; }
  
      return _.reduce(children, function(memo, view) {
        if (!view._getNestedViews) { return memo; }
        return memo.concat(view._getNestedViews());
      }, children);
    },
  
    // Walk the _parent tree until we find a layout view (if one exists).
    // Returns the parent layout view hierarchically closest to this view.
    _parentLayoutView: function() {
      var parent  = this._parent;
  
      while (parent) {
        if (parent instanceof Marionette.LayoutView) {
          return parent;
        }
        parent = parent._parent;
      }
    },
  
    // Imports the "normalizeMethods" to transform hashes of
    // events=>function references/names to a hash of events=>function references
    normalizeMethods: Marionette.normalizeMethods,
  
    // A handy way to merge passed-in options onto the instance
    mergeOptions: Marionette.mergeOptions,
  
    // Proxy `getOption` to enable getting options from this or this.options by name.
    getOption: Marionette.proxyGetOption,
  
    // Proxy `bindEntityEvents` to enable binding view's events from another entity.
    bindEntityEvents: Marionette.proxyBindEntityEvents,
  
    // Proxy `unbindEntityEvents` to enable unbinding view's events from another entity.
    unbindEntityEvents: Marionette.proxyUnbindEntityEvents
  });
  
  // Item View
  // ---------
  
  // A single item view implementation that contains code for rendering
  // with underscore.js templates, serializing the view's model or collection,
  // and calling several methods on extended views, such as `onRender`.
  Marionette.ItemView = Marionette.View.extend({
  
    // Setting up the inheritance chain which allows changes to
    // Marionette.View.prototype.constructor which allows overriding
    constructor: function() {
      Marionette.View.apply(this, arguments);
    },
  
    // Serialize the model or collection for the view. If a model is
    // found, the view's `serializeModel` is called. If a collection is found,
    // each model in the collection is serialized by calling
    // the view's `serializeCollection` and put into an `items` array in
    // the resulting data. If both are found, defaults to the model.
    // You can override the `serializeData` method in your own view definition,
    // to provide custom serialization for your view's data.
    serializeData: function() {
      if (!this.model && !this.collection) {
        return {};
      }
  
      var args = [this.model || this.collection];
      if (arguments.length) {
        args.push.apply(args, arguments);
      }
  
      if (this.model) {
        return this.serializeModel.apply(this, args);
      } else {
        return {
          items: this.serializeCollection.apply(this, args)
        };
      }
    },
  
    // Serialize a collection by serializing each of its models.
    serializeCollection: function(collection) {
      return collection.toJSON.apply(collection, _.rest(arguments));
    },
  
    // Render the view, defaulting to underscore.js templates.
    // You can override this in your view definition to provide
    // a very specific rendering for your view. In general, though,
    // you should override the `Marionette.Renderer` object to
    // change how Marionette renders views.
    render: function() {
      this._ensureViewIsIntact();
  
      this.triggerMethod('before:render', this);
  
      this._renderTemplate();
      this.isRendered = true;
      this.bindUIElements();
  
      this.triggerMethod('render', this);
  
      return this;
    },
  
    // Internal method to render the template with the serialized data
    // and template helpers via the `Marionette.Renderer` object.
    // Throws an `UndefinedTemplateError` error if the template is
    // any falsely value but literal `false`.
    _renderTemplate: function() {
      var template = this.getTemplate();
  
      // Allow template-less item views
      if (template === false) {
        return;
      }
  
      if (!template) {
        throw new Marionette.Error({
          name: 'UndefinedTemplateError',
          message: 'Cannot render the template since it is null or undefined.'
        });
      }
  
      // Add in entity data and template helpers
      var data = this.mixinTemplateHelpers(this.serializeData());
  
      // Render and add to el
      var html = Marionette.Renderer.render(template, data, this);
      this.attachElContent(html);
  
      return this;
    },
  
    // Attaches the content of a given view.
    // This method can be overridden to optimize rendering,
    // or to render in a non standard way.
    //
    // For example, using `innerHTML` instead of `$el.html`
    //
    // ```js
    // attachElContent: function(html) {
    //   this.el.innerHTML = html;
    //   return this;
    // }
    // ```
    attachElContent: function(html) {
      this.$el.html(html);
  
      return this;
    }
  });
  
  /* jshint maxstatements: 20, maxcomplexity: 7 */
  
  // Collection View
  // ---------------
  
  // A view that iterates over a Backbone.Collection
  // and renders an individual child view for each model.
  Marionette.CollectionView = Marionette.View.extend({
  
    // used as the prefix for child view events
    // that are forwarded through the collectionview
    childViewEventPrefix: 'childview',
  
    // flag for maintaining the sorted order of the collection
    sort: true,
  
    // constructor
    // option to pass `{sort: false}` to prevent the `CollectionView` from
    // maintaining the sorted order of the collection.
    // This will fallback onto appending childView's to the end.
    //
    // option to pass `{comparator: compFunction()}` to allow the `CollectionView`
    // to use a custom sort order for the collection.
    constructor: function(options) {
      this.once('render', this._initialEvents);
      this._initChildViewStorage();
  
      Marionette.View.apply(this, arguments);
  
      this.on({
        'before:show':   this._onBeforeShowCalled,
        'show':          this._onShowCalled,
        'before:attach': this._onBeforeAttachCalled,
        'attach':        this._onAttachCalled
      });
      this.initRenderBuffer();
    },
  
    // Instead of inserting elements one by one into the page,
    // it's much more performant to insert elements into a document
    // fragment and then insert that document fragment into the page
    initRenderBuffer: function() {
      this._bufferedChildren = [];
    },
  
    startBuffering: function() {
      this.initRenderBuffer();
      this.isBuffering = true;
    },
  
    endBuffering: function() {
      // Only trigger attach if already shown and attached, otherwise Region#show() handles this.
      var canTriggerAttach = this._isShown && Marionette.isNodeAttached(this.el);
      var nestedViews;
  
      this.isBuffering = false;
  
      if (this._isShown) {
        this._triggerMethodMany(this._bufferedChildren, this, 'before:show');
      }
      if (canTriggerAttach && this._triggerBeforeAttach) {
        nestedViews = this._getNestedViews();
        this._triggerMethodMany(nestedViews, this, 'before:attach');
      }
  
      this.attachBuffer(this, this._createBuffer());
  
      if (canTriggerAttach && this._triggerAttach) {
        nestedViews = this._getNestedViews();
        this._triggerMethodMany(nestedViews, this, 'attach');
      }
      if (this._isShown) {
        this._triggerMethodMany(this._bufferedChildren, this, 'show');
      }
      this.initRenderBuffer();
    },
  
    _triggerMethodMany: function(targets, source, eventName) {
      var args = _.drop(arguments, 3);
  
      _.each(targets, function(target) {
        Marionette.triggerMethodOn.apply(target, [target, eventName, target, source].concat(args));
      });
    },
  
    // Configured the initial events that the collection view
    // binds to.
    _initialEvents: function() {
      if (this.collection) {
        this.listenTo(this.collection, 'add', this._onCollectionAdd);
        this.listenTo(this.collection, 'remove', this._onCollectionRemove);
        this.listenTo(this.collection, 'reset', this.render);
  
        if (this.getOption('sort')) {
          this.listenTo(this.collection, 'sort', this._sortViews);
        }
      }
    },
  
    // Handle a child added to the collection
    _onCollectionAdd: function(child, collection, opts) {
      // `index` is present when adding with `at` since BB 1.2; indexOf fallback for < 1.2
      var index = opts.at !== undefined && (opts.index || collection.indexOf(child));
  
      // When filtered or when there is no initial index, calculate index.
      if (this.getOption('filter') || index === false) {
        index = _.indexOf(this._filteredSortedModels(index), child);
      }
  
      if (this._shouldAddChild(child, index)) {
        this.destroyEmptyView();
        var ChildView = this.getChildView(child);
        this.addChild(child, ChildView, index);
      }
    },
  
    // get the child view by model it holds, and remove it
    _onCollectionRemove: function(model) {
      var view = this.children.findByModel(model);
      this.removeChildView(view);
      this.checkEmpty();
    },
  
    _onBeforeShowCalled: function() {
      // Reset attach event flags at the top of the Region#show() event lifecycle; if the Region's
      // show() options permit onBeforeAttach/onAttach events, these flags will be set true again.
      this._triggerBeforeAttach = this._triggerAttach = false;
      this.children.each(function(childView) {
        Marionette.triggerMethodOn(childView, 'before:show', childView);
      });
    },
  
    _onShowCalled: function() {
      this.children.each(function(childView) {
        Marionette.triggerMethodOn(childView, 'show', childView);
      });
    },
  
    // If during Region#show() onBeforeAttach was fired, continue firing it for child views
    _onBeforeAttachCalled: function() {
      this._triggerBeforeAttach = true;
    },
  
    // If during Region#show() onAttach was fired, continue firing it for child views
    _onAttachCalled: function() {
      this._triggerAttach = true;
    },
  
    // Render children views. Override this method to
    // provide your own implementation of a render function for
    // the collection view.
    render: function() {
      this._ensureViewIsIntact();
      this.triggerMethod('before:render', this);
      this._renderChildren();
      this.isRendered = true;
      this.triggerMethod('render', this);
      return this;
    },
  
    // Reorder DOM after sorting. When your element's rendering
    // do not use their index, you can pass reorderOnSort: true
    // to only reorder the DOM after a sort instead of rendering
    // all the collectionView
    reorder: function() {
      var children = this.children;
      var models = this._filteredSortedModels();
  
      if (!models.length && this._showingEmptyView) { return this; }
  
      var anyModelsAdded = _.some(models, function(model) {
        return !children.findByModel(model);
      });
  
      // If there are any new models added due to filtering
      // We need to add child views
      // So render as normal
      if (anyModelsAdded) {
        this.render();
      } else {
        // get the DOM nodes in the same order as the models
        var elsToReorder = _.map(models, function(model, index) {
          var view = children.findByModel(model);
          view._index = index;
          return view.el;
        });
  
        // find the views that were children before but arent in this new ordering
        var filteredOutViews = children.filter(function(view) {
          return !_.contains(elsToReorder, view.el);
        });
  
        this.triggerMethod('before:reorder');
  
        // since append moves elements that are already in the DOM,
        // appending the elements will effectively reorder them
        this._appendReorderedChildren(elsToReorder);
  
        // remove any views that have been filtered out
        _.each(filteredOutViews, this.removeChildView, this);
        this.checkEmpty();
  
        this.triggerMethod('reorder');
      }
    },
  
    // Render view after sorting. Override this method to
    // change how the view renders after a `sort` on the collection.
    // An example of this would be to only `renderChildren` in a `CompositeView`
    // rather than the full view.
    resortView: function() {
      if (Marionette.getOption(this, 'reorderOnSort')) {
        this.reorder();
      } else {
        this.render();
      }
    },
  
    // Internal method. This checks for any changes in the order of the collection.
    // If the index of any view doesn't match, it will render.
    _sortViews: function() {
      var models = this._filteredSortedModels();
  
      // check for any changes in sort order of views
      var orderChanged = _.find(models, function(item, index) {
        var view = this.children.findByModel(item);
        return !view || view._index !== index;
      }, this);
  
      if (orderChanged) {
        this.resortView();
      }
    },
  
    // Internal reference to what index a `emptyView` is.
    _emptyViewIndex: -1,
  
    // Internal method. Separated so that CompositeView can append to the childViewContainer
    // if necessary
    _appendReorderedChildren: function(children) {
      this.$el.append(children);
    },
  
    // Internal method. Separated so that CompositeView can have
    // more control over events being triggered, around the rendering
    // process
    _renderChildren: function() {
      this.destroyEmptyView();
      this.destroyChildren({checkEmpty: false});
  
      if (this.isEmpty(this.collection)) {
        this.showEmptyView();
      } else {
        this.triggerMethod('before:render:collection', this);
        this.startBuffering();
        this.showCollection();
        this.endBuffering();
        this.triggerMethod('render:collection', this);
  
        // If we have shown children and none have passed the filter, show the empty view
        if (this.children.isEmpty() && this.getOption('filter')) {
          this.showEmptyView();
        }
      }
    },
  
    // Internal method to loop through collection and show each child view.
    showCollection: function() {
      var ChildView;
  
      var models = this._filteredSortedModels();
  
      _.each(models, function(child, index) {
        ChildView = this.getChildView(child);
        this.addChild(child, ChildView, index);
      }, this);
    },
  
    // Allow the collection to be sorted by a custom view comparator
    _filteredSortedModels: function(addedAt) {
      var viewComparator = this.getViewComparator();
      var models = this.collection.models;
      addedAt = Math.min(Math.max(addedAt, 0), models.length - 1);
  
      if (viewComparator) {
        var addedModel;
        // Preserve `at` location, even for a sorted view
        if (addedAt) {
          addedModel = models[addedAt];
          models = models.slice(0, addedAt).concat(models.slice(addedAt + 1));
        }
        models = this._sortModelsBy(models, viewComparator);
        if (addedModel) {
          models.splice(addedAt, 0, addedModel);
        }
      }
  
      // Filter after sorting in case the filter uses the index
      if (this.getOption('filter')) {
        models = _.filter(models, function(model, index) {
          return this._shouldAddChild(model, index);
        }, this);
      }
  
      return models;
    },
  
    _sortModelsBy: function(models, comparator) {
      if (typeof comparator === 'string') {
        return _.sortBy(models, function(model) {
          return model.get(comparator);
        }, this);
      } else if (comparator.length === 1) {
        return _.sortBy(models, comparator, this);
      } else {
        return models.sort(_.bind(comparator, this));
      }
    },
  
    // Internal method to show an empty view in place of
    // a collection of child views, when the collection is empty
    showEmptyView: function() {
      var EmptyView = this.getEmptyView();
  
      if (EmptyView && !this._showingEmptyView) {
        this.triggerMethod('before:render:empty');
  
        this._showingEmptyView = true;
        var model = new Backbone.Model();
        this.addEmptyView(model, EmptyView);
  
        this.triggerMethod('render:empty');
      }
    },
  
    // Internal method to destroy an existing emptyView instance
    // if one exists. Called when a collection view has been
    // rendered empty, and then a child is added to the collection.
    destroyEmptyView: function() {
      if (this._showingEmptyView) {
        this.triggerMethod('before:remove:empty');
  
        this.destroyChildren();
        delete this._showingEmptyView;
  
        this.triggerMethod('remove:empty');
      }
    },
  
    // Retrieve the empty view class
    getEmptyView: function() {
      return this.getOption('emptyView');
    },
  
    // Render and show the emptyView. Similar to addChild method
    // but "add:child" events are not fired, and the event from
    // emptyView are not forwarded
    addEmptyView: function(child, EmptyView) {
      // Only trigger attach if already shown, attached, and not buffering, otherwise endBuffer() or
      // Region#show() handles this.
      var canTriggerAttach = this._isShown && !this.isBuffering && Marionette.isNodeAttached(this.el);
      var nestedViews;
  
      // get the emptyViewOptions, falling back to childViewOptions
      var emptyViewOptions = this.getOption('emptyViewOptions') ||
                            this.getOption('childViewOptions');
  
      if (_.isFunction(emptyViewOptions)) {
        emptyViewOptions = emptyViewOptions.call(this, child, this._emptyViewIndex);
      }
  
      // build the empty view
      var view = this.buildChildView(child, EmptyView, emptyViewOptions);
  
      view._parent = this;
  
      // Proxy emptyView events
      this.proxyChildEvents(view);
  
      view.once('render', function() {
        // trigger the 'before:show' event on `view` if the collection view has already been shown
        if (this._isShown) {
          Marionette.triggerMethodOn(view, 'before:show', view);
        }
  
        // Trigger `before:attach` following `render` to avoid adding logic and event triggers
        // to public method `renderChildView()`.
        if (canTriggerAttach && this._triggerBeforeAttach) {
          nestedViews = this._getViewAndNested(view);
          this._triggerMethodMany(nestedViews, this, 'before:attach');
        }
      }, this);
  
      // Store the `emptyView` like a `childView` so we can properly remove and/or close it later
      this.children.add(view);
      this.renderChildView(view, this._emptyViewIndex);
  
      // Trigger `attach`
      if (canTriggerAttach && this._triggerAttach) {
        nestedViews = this._getViewAndNested(view);
        this._triggerMethodMany(nestedViews, this, 'attach');
      }
      // call the 'show' method if the collection view has already been shown
      if (this._isShown) {
        Marionette.triggerMethodOn(view, 'show', view);
      }
    },
  
    // Retrieve the `childView` class, either from `this.options.childView`
    // or from the `childView` in the object definition. The "options"
    // takes precedence.
    // This method receives the model that will be passed to the instance
    // created from this `childView`. Overriding methods may use the child
    // to determine what `childView` class to return.
    getChildView: function(child) {
      var childView = this.getOption('childView');
  
      if (!childView) {
        throw new Marionette.Error({
          name: 'NoChildViewError',
          message: 'A "childView" must be specified'
        });
      }
  
      return childView;
    },
  
    // Render the child's view and add it to the
    // HTML for the collection view at a given index.
    // This will also update the indices of later views in the collection
    // in order to keep the children in sync with the collection.
    addChild: function(child, ChildView, index) {
      var childViewOptions = this.getOption('childViewOptions');
      childViewOptions = Marionette._getValue(childViewOptions, this, [child, index]);
  
      var view = this.buildChildView(child, ChildView, childViewOptions);
  
      // increment indices of views after this one
      this._updateIndices(view, true, index);
  
      this.triggerMethod('before:add:child', view);
      this._addChildView(view, index);
      this.triggerMethod('add:child', view);
  
      view._parent = this;
  
      return view;
    },
  
    // Internal method. This decrements or increments the indices of views after the
    // added/removed view to keep in sync with the collection.
    _updateIndices: function(view, increment, index) {
      if (!this.getOption('sort')) {
        return;
      }
  
      if (increment) {
        // assign the index to the view
        view._index = index;
      }
  
      // update the indexes of views after this one
      this.children.each(function(laterView) {
        if (laterView._index >= view._index) {
          laterView._index += increment ? 1 : -1;
        }
      });
    },
  
    // Internal Method. Add the view to children and render it at
    // the given index.
    _addChildView: function(view, index) {
      // Only trigger attach if already shown, attached, and not buffering, otherwise endBuffer() or
      // Region#show() handles this.
      var canTriggerAttach = this._isShown && !this.isBuffering && Marionette.isNodeAttached(this.el);
      var nestedViews;
  
      // set up the child view event forwarding
      this.proxyChildEvents(view);
  
      view.once('render', function() {
        // trigger the 'before:show' event on `view` if the collection view has already been shown
        if (this._isShown && !this.isBuffering) {
          Marionette.triggerMethodOn(view, 'before:show', view);
        }
  
        // Trigger `before:attach` following `render` to avoid adding logic and event triggers
        // to public method `renderChildView()`.
        if (canTriggerAttach && this._triggerBeforeAttach) {
          nestedViews = this._getViewAndNested(view);
          this._triggerMethodMany(nestedViews, this, 'before:attach');
        }
      }, this);
  
      // Store the child view itself so we can properly remove and/or destroy it later
      this.children.add(view);
      this.renderChildView(view, index);
  
      // Trigger `attach`
      if (canTriggerAttach && this._triggerAttach) {
        nestedViews = this._getViewAndNested(view);
        this._triggerMethodMany(nestedViews, this, 'attach');
      }
      // Trigger `show`
      if (this._isShown && !this.isBuffering) {
        Marionette.triggerMethodOn(view, 'show', view);
      }
    },
  
    // render the child view
    renderChildView: function(view, index) {
      if (!view.supportsRenderLifecycle) {
        Marionette.triggerMethodOn(view, 'before:render', view);
      }
      view.render();
      if (!view.supportsRenderLifecycle) {
        Marionette.triggerMethodOn(view, 'render', view);
      }
      this.attachHtml(this, view, index);
      return view;
    },
  
    // Build a `childView` for a model in the collection.
    buildChildView: function(child, ChildViewClass, childViewOptions) {
      var options = _.extend({model: child}, childViewOptions);
      var childView = new ChildViewClass(options);
      Marionette.MonitorDOMRefresh(childView);
      return childView;
    },
  
    // Remove the child view and destroy it.
    // This function also updates the indices of
    // later views in the collection in order to keep
    // the children in sync with the collection.
    removeChildView: function(view) {
      if (!view) { return view; }
  
      this.triggerMethod('before:remove:child', view);
  
      if (!view.supportsDestroyLifecycle) {
        Marionette.triggerMethodOn(view, 'before:destroy', view);
      }
      // call 'destroy' or 'remove', depending on which is found
      if (view.destroy) {
        view.destroy();
      } else {
        view.remove();
      }
      if (!view.supportsDestroyLifecycle) {
        Marionette.triggerMethodOn(view, 'destroy', view);
      }
  
      delete view._parent;
      this.stopListening(view);
      this.children.remove(view);
      this.triggerMethod('remove:child', view);
  
      // decrement the index of views after this one
      this._updateIndices(view, false);
  
      return view;
    },
  
    // check if the collection is empty
    isEmpty: function() {
      return !this.collection || this.collection.length === 0;
    },
  
    // If empty, show the empty view
    checkEmpty: function() {
      if (this.isEmpty(this.collection)) {
        this.showEmptyView();
      }
    },
  
    // You might need to override this if you've overridden attachHtml
    attachBuffer: function(collectionView, buffer) {
      collectionView.$el.append(buffer);
    },
  
    // Create a fragment buffer from the currently buffered children
    _createBuffer: function() {
      var elBuffer = document.createDocumentFragment();
      _.each(this._bufferedChildren, function(b) {
        elBuffer.appendChild(b.el);
      });
      return elBuffer;
    },
  
    // Append the HTML to the collection's `el`.
    // Override this method to do something other
    // than `.append`.
    attachHtml: function(collectionView, childView, index) {
      if (collectionView.isBuffering) {
        // buffering happens on reset events and initial renders
        // in order to reduce the number of inserts into the
        // document, which are expensive.
        collectionView._bufferedChildren.splice(index, 0, childView);
      } else {
        // If we've already rendered the main collection, append
        // the new child into the correct order if we need to. Otherwise
        // append to the end.
        if (!collectionView._insertBefore(childView, index)) {
          collectionView._insertAfter(childView);
        }
      }
    },
  
    // Internal method. Check whether we need to insert the view into
    // the correct position.
    _insertBefore: function(childView, index) {
      var currentView;
      var findPosition = this.getOption('sort') && (index < this.children.length - 1);
      if (findPosition) {
        // Find the view after this one
        currentView = this.children.find(function(view) {
          return view._index === index + 1;
        });
      }
  
      if (currentView) {
        currentView.$el.before(childView.el);
        return true;
      }
  
      return false;
    },
  
    // Internal method. Append a view to the end of the $el
    _insertAfter: function(childView) {
      this.$el.append(childView.el);
    },
  
    // Internal method to set up the `children` object for
    // storing all of the child views
    _initChildViewStorage: function() {
      this.children = new Backbone.ChildViewContainer();
    },
  
    // Handle cleanup and other destroying needs for the collection of views
    destroy: function() {
      if (this.isDestroyed) { return this; }
  
      this.triggerMethod('before:destroy:collection');
      this.destroyChildren({checkEmpty: false});
      this.triggerMethod('destroy:collection');
  
      return Marionette.View.prototype.destroy.apply(this, arguments);
    },
  
    // Destroy the child views that this collection view
    // is holding on to, if any
    destroyChildren: function(options) {
      var destroyOptions = options || {};
      var shouldCheckEmpty = true;
      var childViews = this.children.map(_.identity);
  
      if (!_.isUndefined(destroyOptions.checkEmpty)) {
        shouldCheckEmpty = destroyOptions.checkEmpty;
      }
  
      this.children.each(this.removeChildView, this);
  
      if (shouldCheckEmpty) {
        this.checkEmpty();
      }
      return childViews;
    },
  
    // Return true if the given child should be shown
    // Return false otherwise
    // The filter will be passed (child, index, collection)
    // Where
    //  'child' is the given model
    //  'index' is the index of that model in the collection
    //  'collection' is the collection referenced by this CollectionView
    _shouldAddChild: function(child, index) {
      var filter = this.getOption('filter');
      return !_.isFunction(filter) || filter.call(this, child, index, this.collection);
    },
  
    // Set up the child view event forwarding. Uses a "childview:"
    // prefix in front of all forwarded events.
    proxyChildEvents: function(view) {
      var prefix = this.getOption('childViewEventPrefix');
  
      // Forward all child view events through the parent,
      // prepending "childview:" to the event name
      this.listenTo(view, 'all', function() {
        var args = _.toArray(arguments);
        var rootEvent = args[0];
        var childEvents = this.normalizeMethods(_.result(this, 'childEvents'));
  
        args[0] = prefix + ':' + rootEvent;
        args.splice(1, 0, view);
  
        // call collectionView childEvent if defined
        if (typeof childEvents !== 'undefined' && _.isFunction(childEvents[rootEvent])) {
          childEvents[rootEvent].apply(this, args.slice(1));
        }
  
        this.triggerMethod.apply(this, args);
      });
    },
  
    _getImmediateChildren: function() {
      return _.values(this.children._views);
    },
  
    _getViewAndNested: function(view) {
      // This will not fail on Backbone.View which does not have #_getNestedViews.
      return [view].concat(_.result(view, '_getNestedViews') || []);
    },
  
    getViewComparator: function() {
      return this.getOption('viewComparator');
    }
  });
  
  /* jshint maxstatements: 17, maxlen: 117 */
  
  // Composite View
  // --------------
  
  // Used for rendering a branch-leaf, hierarchical structure.
  // Extends directly from CollectionView and also renders an
  // a child view as `modelView`, for the top leaf
  Marionette.CompositeView = Marionette.CollectionView.extend({
  
    // Setting up the inheritance chain which allows changes to
    // Marionette.CollectionView.prototype.constructor which allows overriding
    // option to pass '{sort: false}' to prevent the CompositeView from
    // maintaining the sorted order of the collection.
    // This will fallback onto appending childView's to the end.
    constructor: function() {
      Marionette.CollectionView.apply(this, arguments);
    },
  
    // Configured the initial events that the composite view
    // binds to. Override this method to prevent the initial
    // events, or to add your own initial events.
    _initialEvents: function() {
  
      // Bind only after composite view is rendered to avoid adding child views
      // to nonexistent childViewContainer
  
      if (this.collection) {
        this.listenTo(this.collection, 'add', this._onCollectionAdd);
        this.listenTo(this.collection, 'remove', this._onCollectionRemove);
        this.listenTo(this.collection, 'reset', this._renderChildren);
  
        if (this.getOption('sort')) {
          this.listenTo(this.collection, 'sort', this._sortViews);
        }
      }
    },
  
    // Retrieve the `childView` to be used when rendering each of
    // the items in the collection. The default is to return
    // `this.childView` or Marionette.CompositeView if no `childView`
    // has been defined
    getChildView: function(child) {
      var childView = this.getOption('childView') || this.constructor;
  
      return childView;
    },
  
    // Serialize the model for the view.
    // You can override the `serializeData` method in your own view
    // definition, to provide custom serialization for your view's data.
    serializeData: function() {
      var data = {};
  
      if (this.model) {
        data = _.partial(this.serializeModel, this.model).apply(this, arguments);
      }
  
      return data;
    },
  
    // Renders the model and the collection.
    render: function() {
      this._ensureViewIsIntact();
      this._isRendering = true;
      this.resetChildViewContainer();
  
      this.triggerMethod('before:render', this);
  
      this._renderTemplate();
      this._renderChildren();
  
      this._isRendering = false;
      this.isRendered = true;
      this.triggerMethod('render', this);
      return this;
    },
  
    _renderChildren: function() {
      if (this.isRendered || this._isRendering) {
        Marionette.CollectionView.prototype._renderChildren.call(this);
      }
    },
  
    // Render the root template that the children
    // views are appended to
    _renderTemplate: function() {
      var data = {};
      data = this.serializeData();
      data = this.mixinTemplateHelpers(data);
  
      this.triggerMethod('before:render:template');
  
      var template = this.getTemplate();
      var html = Marionette.Renderer.render(template, data, this);
      this.attachElContent(html);
  
      // the ui bindings is done here and not at the end of render since they
      // will not be available until after the model is rendered, but should be
      // available before the collection is rendered.
      this.bindUIElements();
      this.triggerMethod('render:template');
    },
  
    // Attaches the content of the root.
    // This method can be overridden to optimize rendering,
    // or to render in a non standard way.
    //
    // For example, using `innerHTML` instead of `$el.html`
    //
    // ```js
    // attachElContent: function(html) {
    //   this.el.innerHTML = html;
    //   return this;
    // }
    // ```
    attachElContent: function(html) {
      this.$el.html(html);
  
      return this;
    },
  
    // You might need to override this if you've overridden attachHtml
    attachBuffer: function(compositeView, buffer) {
      var $container = this.getChildViewContainer(compositeView);
      $container.append(buffer);
    },
  
    // Internal method. Append a view to the end of the $el.
    // Overidden from CollectionView to ensure view is appended to
    // childViewContainer
    _insertAfter: function(childView) {
      var $container = this.getChildViewContainer(this, childView);
      $container.append(childView.el);
    },
  
    // Internal method. Append reordered childView'.
    // Overidden from CollectionView to ensure reordered views
    // are appended to childViewContainer
    _appendReorderedChildren: function(children) {
      var $container = this.getChildViewContainer(this);
      $container.append(children);
    },
  
    // Internal method to ensure an `$childViewContainer` exists, for the
    // `attachHtml` method to use.
    getChildViewContainer: function(containerView, childView) {
      if (!!containerView.$childViewContainer) {
        return containerView.$childViewContainer;
      }
  
      var container;
      var childViewContainer = Marionette.getOption(containerView, 'childViewContainer');
      if (childViewContainer) {
  
        var selector = Marionette._getValue(childViewContainer, containerView);
  
        if (selector.charAt(0) === '@' && containerView.ui) {
          container = containerView.ui[selector.substr(4)];
        } else {
          container = containerView.$(selector);
        }
  
        if (container.length <= 0) {
          throw new Marionette.Error({
            name: 'ChildViewContainerMissingError',
            message: 'The specified "childViewContainer" was not found: ' + containerView.childViewContainer
          });
        }
  
      } else {
        container = containerView.$el;
      }
  
      containerView.$childViewContainer = container;
      return container;
    },
  
    // Internal method to reset the `$childViewContainer` on render
    resetChildViewContainer: function() {
      if (this.$childViewContainer) {
        this.$childViewContainer = undefined;
      }
    }
  });
  
  // Layout View
  // -----------
  
  // Used for managing application layoutViews, nested layoutViews and
  // multiple regions within an application or sub-application.
  //
  // A specialized view class that renders an area of HTML and then
  // attaches `Region` instances to the specified `regions`.
  // Used for composite view management and sub-application areas.
  Marionette.LayoutView = Marionette.ItemView.extend({
    regionClass: Marionette.Region,
  
    options: {
      destroyImmediate: false
    },
  
    // used as the prefix for child view events
    // that are forwarded through the layoutview
    childViewEventPrefix: 'childview',
  
    // Ensure the regions are available when the `initialize` method
    // is called.
    constructor: function(options) {
      options = options || {};
  
      this._firstRender = true;
      this._initializeRegions(options);
  
      Marionette.ItemView.call(this, options);
    },
  
    // LayoutView's render will use the existing region objects the
    // first time it is called. Subsequent calls will destroy the
    // views that the regions are showing and then reset the `el`
    // for the regions to the newly rendered DOM elements.
    render: function() {
      this._ensureViewIsIntact();
  
      if (this._firstRender) {
        // if this is the first render, don't do anything to
        // reset the regions
        this._firstRender = false;
      } else {
        // If this is not the first render call, then we need to
        // re-initialize the `el` for each region
        this._reInitializeRegions();
      }
  
      return Marionette.ItemView.prototype.render.apply(this, arguments);
    },
  
    // Handle destroying regions, and then destroy the view itself.
    destroy: function() {
      if (this.isDestroyed) { return this; }
      // #2134: remove parent element before destroying the child views, so
      // removing the child views doesn't retrigger repaints
      if (this.getOption('destroyImmediate') === true) {
        this.$el.remove();
      }
      this.regionManager.destroy();
      return Marionette.ItemView.prototype.destroy.apply(this, arguments);
    },
  
    showChildView: function(regionName, view, options) {
      var region = this.getRegion(regionName);
      return region.show.apply(region, _.rest(arguments));
    },
  
    getChildView: function(regionName) {
      return this.getRegion(regionName).currentView;
    },
  
    // Add a single region, by name, to the layoutView
    addRegion: function(name, definition) {
      var regions = {};
      regions[name] = definition;
      return this._buildRegions(regions)[name];
    },
  
    // Add multiple regions as a {name: definition, name2: def2} object literal
    addRegions: function(regions) {
      this.regions = _.extend({}, this.regions, regions);
      return this._buildRegions(regions);
    },
  
    // Remove a single region from the LayoutView, by name
    removeRegion: function(name) {
      delete this.regions[name];
      return this.regionManager.removeRegion(name);
    },
  
    // Provides alternative access to regions
    // Accepts the region name
    // getRegion('main')
    getRegion: function(region) {
      return this.regionManager.get(region);
    },
  
    // Get all regions
    getRegions: function() {
      return this.regionManager.getRegions();
    },
  
    // internal method to build regions
    _buildRegions: function(regions) {
      var defaults = {
        regionClass: this.getOption('regionClass'),
        parentEl: _.partial(_.result, this, 'el')
      };
  
      return this.regionManager.addRegions(regions, defaults);
    },
  
    // Internal method to initialize the regions that have been defined in a
    // `regions` attribute on this layoutView.
    _initializeRegions: function(options) {
      var regions;
      this._initRegionManager();
  
      regions = Marionette._getValue(this.regions, this, [options]) || {};
  
      // Enable users to define `regions` as instance options.
      var regionOptions = this.getOption.call(options, 'regions');
  
      // enable region options to be a function
      regionOptions = Marionette._getValue(regionOptions, this, [options]);
  
      _.extend(regions, regionOptions);
  
      // Normalize region selectors hash to allow
      // a user to use the @ui. syntax.
      regions = this.normalizeUIValues(regions, ['selector', 'el']);
  
      this.addRegions(regions);
    },
  
    // Internal method to re-initialize all of the regions by updating the `el` that
    // they point to
    _reInitializeRegions: function() {
      this.regionManager.invoke('reset');
    },
  
    // Enable easy overriding of the default `RegionManager`
    // for customized region interactions and business specific
    // view logic for better control over single regions.
    getRegionManager: function() {
      return new Marionette.RegionManager();
    },
  
    // Internal method to initialize the region manager
    // and all regions in it
    _initRegionManager: function() {
      this.regionManager = this.getRegionManager();
      this.regionManager._parent = this;
  
      this.listenTo(this.regionManager, 'before:add:region', function(name) {
        this.triggerMethod('before:add:region', name);
      });
  
      this.listenTo(this.regionManager, 'add:region', function(name, region) {
        this[name] = region;
        this.triggerMethod('add:region', name, region);
      });
  
      this.listenTo(this.regionManager, 'before:remove:region', function(name) {
        this.triggerMethod('before:remove:region', name);
      });
  
      this.listenTo(this.regionManager, 'remove:region', function(name, region) {
        delete this[name];
        this.triggerMethod('remove:region', name, region);
      });
    },
  
    _getImmediateChildren: function() {
      return _.chain(this.regionManager.getRegions())
        .pluck('currentView')
        .compact()
        .value();
    }
  });
  

  // Behavior
  // --------
  
  // A Behavior is an isolated set of DOM /
  // user interactions that can be mixed into any View.
  // Behaviors allow you to blackbox View specific interactions
  // into portable logical chunks, keeping your views simple and your code DRY.
  
  Marionette.Behavior = Marionette.Object.extend({
    constructor: function(options, view) {
      // Setup reference to the view.
      // this comes in handle when a behavior
      // wants to directly talk up the chain
      // to the view.
      this.view = view;
      this.defaults = _.result(this, 'defaults') || {};
      this.options  = _.extend({}, this.defaults, options);
      // Construct an internal UI hash using
      // the views UI hash and then the behaviors UI hash.
      // This allows the user to use UI hash elements
      // defined in the parent view as well as those
      // defined in the given behavior.
      this.ui = _.extend({}, _.result(view, 'ui'), _.result(this, 'ui'));
  
      Marionette.Object.apply(this, arguments);
    },
  
    // proxy behavior $ method to the view
    // this is useful for doing jquery DOM lookups
    // scoped to behaviors view.
    $: function() {
      return this.view.$.apply(this.view, arguments);
    },
  
    // Stops the behavior from listening to events.
    // Overrides Object#destroy to prevent additional events from being triggered.
    destroy: function() {
      this.stopListening();
  
      return this;
    },
  
    proxyViewProperties: function(view) {
      this.$el = view.$el;
      this.el = view.el;
    }
  });
  
  /* jshint maxlen: 143 */
  // Behaviors
  // ---------
  
  // Behaviors is a utility class that takes care of
  // gluing your behavior instances to their given View.
  // The most important part of this class is that you
  // **MUST** override the class level behaviorsLookup
  // method for things to work properly.
  
  Marionette.Behaviors = (function(Marionette, _) {
    // Borrow event splitter from Backbone
    var delegateEventSplitter = /^(\S+)\s*(.*)$/;
  
    function Behaviors(view, behaviors) {
  
      if (!_.isObject(view.behaviors)) {
        return {};
      }
  
      // Behaviors defined on a view can be a flat object literal
      // or it can be a function that returns an object.
      behaviors = Behaviors.parseBehaviors(view, behaviors || _.result(view, 'behaviors'));
  
      // Wraps several of the view's methods
      // calling the methods first on each behavior
      // and then eventually calling the method on the view.
      Behaviors.wrap(view, behaviors, _.keys(methods));
      return behaviors;
    }
  
    var methods = {
      behaviorTriggers: function(behaviorTriggers, behaviors) {
        var triggerBuilder = new BehaviorTriggersBuilder(this, behaviors);
        return triggerBuilder.buildBehaviorTriggers();
      },
  
      behaviorEvents: function(behaviorEvents, behaviors) {
        var _behaviorsEvents = {};
  
        _.each(behaviors, function(b, i) {
          var _events = {};
          var behaviorEvents = _.clone(_.result(b, 'events')) || {};
  
          // Normalize behavior events hash to allow
          // a user to use the @ui. syntax.
          behaviorEvents = Marionette.normalizeUIKeys(behaviorEvents, getBehaviorsUI(b));
  
          var j = 0;
          _.each(behaviorEvents, function(behaviour, key) {
            var match     = key.match(delegateEventSplitter);
  
            // Set event name to be namespaced using the view cid,
            // the behavior index, and the behavior event index
            // to generate a non colliding event namespace
            // http://api.jquery.com/event.namespace/
            var eventName = match[1] + '.' + [this.cid, i, j++, ' '].join('');
            var selector  = match[2];
  
            var eventKey  = eventName + selector;
            var handler   = _.isFunction(behaviour) ? behaviour : b[behaviour];
            if (!handler) { return; }
            _events[eventKey] = _.bind(handler, b);
          }, this);
  
          _behaviorsEvents = _.extend(_behaviorsEvents, _events);
        }, this);
  
        return _behaviorsEvents;
      }
    };
  
    _.extend(Behaviors, {
  
      // Placeholder method to be extended by the user.
      // The method should define the object that stores the behaviors.
      // i.e.
      //
      // ```js
      // Marionette.Behaviors.behaviorsLookup: function() {
      //   return App.Behaviors
      // }
      // ```
      behaviorsLookup: function() {
        throw new Marionette.Error({
          message: 'You must define where your behaviors are stored.',
          url: 'marionette.behaviors.html#behaviorslookup'
        });
      },
  
      // Takes care of getting the behavior class
      // given options and a key.
      // If a user passes in options.behaviorClass
      // default to using that. Otherwise delegate
      // the lookup to the users `behaviorsLookup` implementation.
      getBehaviorClass: function(options, key) {
        if (options.behaviorClass) {
          return options.behaviorClass;
        }
  
        // Get behavior class can be either a flat object or a method
        return Marionette._getValue(Behaviors.behaviorsLookup, this, [options, key])[key];
      },
  
      // Iterate over the behaviors object, for each behavior
      // instantiate it and get its grouped behaviors.
      parseBehaviors: function(view, behaviors) {
        return _.chain(behaviors).map(function(options, key) {
          var BehaviorClass = Behaviors.getBehaviorClass(options, key);
  
          var behavior = new BehaviorClass(options, view);
          var nestedBehaviors = Behaviors.parseBehaviors(view, _.result(behavior, 'behaviors'));
  
          return [behavior].concat(nestedBehaviors);
        }).flatten().value();
      },
  
      // Wrap view internal methods so that they delegate to behaviors. For example,
      // `onDestroy` should trigger destroy on all of the behaviors and then destroy itself.
      // i.e.
      //
      // `view.delegateEvents = _.partial(methods.delegateEvents, view.delegateEvents, behaviors);`
      wrap: function(view, behaviors, methodNames) {
        _.each(methodNames, function(methodName) {
          view[methodName] = _.partial(methods[methodName], view[methodName], behaviors);
        });
      }
    });
  
    // Class to build handlers for `triggers` on behaviors
    // for views
    function BehaviorTriggersBuilder(view, behaviors) {
      this._view      = view;
      this._behaviors = behaviors;
      this._triggers  = {};
    }
  
    _.extend(BehaviorTriggersBuilder.prototype, {
      // Main method to build the triggers hash with event keys and handlers
      buildBehaviorTriggers: function() {
        _.each(this._behaviors, this._buildTriggerHandlersForBehavior, this);
        return this._triggers;
      },
  
      // Internal method to build all trigger handlers for a given behavior
      _buildTriggerHandlersForBehavior: function(behavior, i) {
        var triggersHash = _.clone(_.result(behavior, 'triggers')) || {};
  
        triggersHash = Marionette.normalizeUIKeys(triggersHash, getBehaviorsUI(behavior));
  
        _.each(triggersHash, _.bind(this._setHandlerForBehavior, this, behavior, i));
      },
  
      // Internal method to create and assign the trigger handler for a given
      // behavior
      _setHandlerForBehavior: function(behavior, i, eventName, trigger) {
        // Unique identifier for the `this._triggers` hash
        var triggerKey = trigger.replace(/^\S+/, function(triggerName) {
          return triggerName + '.' + 'behaviortriggers' + i;
        });
  
        this._triggers[triggerKey] = this._view._buildViewTrigger(eventName);
      }
    });
  
    function getBehaviorsUI(behavior) {
      return behavior._uiBindings || behavior.ui;
    }
  
    return Behaviors;
  
  })(Marionette, _);
  

  // App Router
  // ----------
  
  // Reduce the boilerplate code of handling route events
  // and then calling a single method on another object.
  // Have your routers configured to call the method on
  // your object, directly.
  //
  // Configure an AppRouter with `appRoutes`.
  //
  // App routers can only take one `controller` object.
  // It is recommended that you divide your controller
  // objects in to smaller pieces of related functionality
  // and have multiple routers / controllers, instead of
  // just one giant router and controller.
  //
  // You can also add standard routes to an AppRouter.
  
  Marionette.AppRouter = Backbone.Router.extend({
  
    constructor: function(options) {
      this.options = options || {};
  
      Backbone.Router.apply(this, arguments);
  
      var appRoutes = this.getOption('appRoutes');
      var controller = this._getController();
      this.processAppRoutes(controller, appRoutes);
      this.on('route', this._processOnRoute, this);
    },
  
    // Similar to route method on a Backbone Router but
    // method is called on the controller
    appRoute: function(route, methodName) {
      var controller = this._getController();
      this._addAppRoute(controller, route, methodName);
    },
  
    // process the route event and trigger the onRoute
    // method call, if it exists
    _processOnRoute: function(routeName, routeArgs) {
      // make sure an onRoute before trying to call it
      if (_.isFunction(this.onRoute)) {
        // find the path that matches the current route
        var routePath = _.invert(this.getOption('appRoutes'))[routeName];
        this.onRoute(routeName, routePath, routeArgs);
      }
    },
  
    // Internal method to process the `appRoutes` for the
    // router, and turn them in to routes that trigger the
    // specified method on the specified `controller`.
    processAppRoutes: function(controller, appRoutes) {
      if (!appRoutes) { return; }
  
      var routeNames = _.keys(appRoutes).reverse(); // Backbone requires reverted order of routes
  
      _.each(routeNames, function(route) {
        this._addAppRoute(controller, route, appRoutes[route]);
      }, this);
    },
  
    _getController: function() {
      return this.getOption('controller');
    },
  
    _addAppRoute: function(controller, route, methodName) {
      var method = controller[methodName];
  
      if (!method) {
        throw new Marionette.Error('Method "' + methodName + '" was not found on the controller');
      }
  
      this.route(route, methodName, _.bind(method, controller));
    },
  
    mergeOptions: Marionette.mergeOptions,
  
    // Proxy `getOption` to enable getting options from this or this.options by name.
    getOption: Marionette.proxyGetOption,
  
    triggerMethod: Marionette.triggerMethod,
  
    bindEntityEvents: Marionette.proxyBindEntityEvents,
  
    unbindEntityEvents: Marionette.proxyUnbindEntityEvents
  });
  
  // Application
  // -----------
  
  // Contain and manage the composite application as a whole.
  // Stores and starts up `Region` objects, includes an
  // event aggregator as `app.vent`
  Marionette.Application = Marionette.Object.extend({
    constructor: function(options) {
      this._initializeRegions(options);
      this._initCallbacks = new Marionette.Callbacks();
      this.submodules = {};
      _.extend(this, options);
      this._initChannel();
      Marionette.Object.apply(this, arguments);
    },
  
    // Command execution, facilitated by Backbone.Wreqr.Commands
    execute: function() {
      this.commands.execute.apply(this.commands, arguments);
    },
  
    // Request/response, facilitated by Backbone.Wreqr.RequestResponse
    request: function() {
      return this.reqres.request.apply(this.reqres, arguments);
    },
  
    // Add an initializer that is either run at when the `start`
    // method is called, or run immediately if added after `start`
    // has already been called.
    addInitializer: function(initializer) {
      this._initCallbacks.add(initializer);
    },
  
    // kick off all of the application's processes.
    // initializes all of the regions that have been added
    // to the app, and runs all of the initializer functions
    start: function(options) {
      this.triggerMethod('before:start', options);
      this._initCallbacks.run(options, this);
      this.triggerMethod('start', options);
    },
  
    // Add regions to your app.
    // Accepts a hash of named strings or Region objects
    // addRegions({something: "#someRegion"})
    // addRegions({something: Region.extend({el: "#someRegion"}) });
    addRegions: function(regions) {
      return this._regionManager.addRegions(regions);
    },
  
    // Empty all regions in the app, without removing them
    emptyRegions: function() {
      return this._regionManager.emptyRegions();
    },
  
    // Removes a region from your app, by name
    // Accepts the regions name
    // removeRegion('myRegion')
    removeRegion: function(region) {
      return this._regionManager.removeRegion(region);
    },
  
    // Provides alternative access to regions
    // Accepts the region name
    // getRegion('main')
    getRegion: function(region) {
      return this._regionManager.get(region);
    },
  
    // Get all the regions from the region manager
    getRegions: function() {
      return this._regionManager.getRegions();
    },
  
    // Create a module, attached to the application
    module: function(moduleNames, moduleDefinition) {
  
      // Overwrite the module class if the user specifies one
      var ModuleClass = Marionette.Module.getClass(moduleDefinition);
  
      var args = _.toArray(arguments);
      args.unshift(this);
  
      // see the Marionette.Module object for more information
      return ModuleClass.create.apply(ModuleClass, args);
    },
  
    // Enable easy overriding of the default `RegionManager`
    // for customized region interactions and business-specific
    // view logic for better control over single regions.
    getRegionManager: function() {
      return new Marionette.RegionManager();
    },
  
    // Internal method to initialize the regions that have been defined in a
    // `regions` attribute on the application instance
    _initializeRegions: function(options) {
      var regions = _.isFunction(this.regions) ? this.regions(options) : this.regions || {};
  
      this._initRegionManager();
  
      // Enable users to define `regions` in instance options.
      var optionRegions = Marionette.getOption(options, 'regions');
  
      // Enable region options to be a function
      if (_.isFunction(optionRegions)) {
        optionRegions = optionRegions.call(this, options);
      }
  
      // Overwrite current regions with those passed in options
      _.extend(regions, optionRegions);
  
      this.addRegions(regions);
  
      return this;
    },
  
    // Internal method to set up the region manager
    _initRegionManager: function() {
      this._regionManager = this.getRegionManager();
      this._regionManager._parent = this;
  
      this.listenTo(this._regionManager, 'before:add:region', function() {
        Marionette._triggerMethod(this, 'before:add:region', arguments);
      });
  
      this.listenTo(this._regionManager, 'add:region', function(name, region) {
        this[name] = region;
        Marionette._triggerMethod(this, 'add:region', arguments);
      });
  
      this.listenTo(this._regionManager, 'before:remove:region', function() {
        Marionette._triggerMethod(this, 'before:remove:region', arguments);
      });
  
      this.listenTo(this._regionManager, 'remove:region', function(name) {
        delete this[name];
        Marionette._triggerMethod(this, 'remove:region', arguments);
      });
    },
  
    // Internal method to setup the Wreqr.radio channel
    _initChannel: function() {
      this.channelName = _.result(this, 'channelName') || 'global';
      this.channel = _.result(this, 'channel') || Backbone.Wreqr.radio.channel(this.channelName);
      this.vent = _.result(this, 'vent') || this.channel.vent;
      this.commands = _.result(this, 'commands') || this.channel.commands;
      this.reqres = _.result(this, 'reqres') || this.channel.reqres;
    }
  });
  
  /* jshint maxparams: 9 */
  
  // Module
  // ------
  
  // A simple module system, used to create privacy and encapsulation in
  // Marionette applications
  Marionette.Module = function(moduleName, app, options) {
    this.moduleName = moduleName;
    this.options = _.extend({}, this.options, options);
    // Allow for a user to overide the initialize
    // for a given module instance.
    this.initialize = options.initialize || this.initialize;
  
    // Set up an internal store for sub-modules.
    this.submodules = {};
  
    this._setupInitializersAndFinalizers();
  
    // Set an internal reference to the app
    // within a module.
    this.app = app;
  
    if (_.isFunction(this.initialize)) {
      this.initialize(moduleName, app, this.options);
    }
  };
  
  Marionette.Module.extend = Marionette.extend;
  
  // Extend the Module prototype with events / listenTo, so that the module
  // can be used as an event aggregator or pub/sub.
  _.extend(Marionette.Module.prototype, Backbone.Events, {
  
    // By default modules start with their parents.
    startWithParent: true,
  
    // Initialize is an empty function by default. Override it with your own
    // initialization logic when extending Marionette.Module.
    initialize: function() {},
  
    // Initializer for a specific module. Initializers are run when the
    // module's `start` method is called.
    addInitializer: function(callback) {
      this._initializerCallbacks.add(callback);
    },
  
    // Finalizers are run when a module is stopped. They are used to teardown
    // and finalize any variables, references, events and other code that the
    // module had set up.
    addFinalizer: function(callback) {
      this._finalizerCallbacks.add(callback);
    },
  
    // Start the module, and run all of its initializers
    start: function(options) {
      // Prevent re-starting a module that is already started
      if (this._isInitialized) { return; }
  
      // start the sub-modules (depth-first hierarchy)
      _.each(this.submodules, function(mod) {
        // check to see if we should start the sub-module with this parent
        if (mod.startWithParent) {
          mod.start(options);
        }
      });
  
      // run the callbacks to "start" the current module
      this.triggerMethod('before:start', options);
  
      this._initializerCallbacks.run(options, this);
      this._isInitialized = true;
  
      this.triggerMethod('start', options);
    },
  
    // Stop this module by running its finalizers and then stop all of
    // the sub-modules for this module
    stop: function() {
      // if we are not initialized, don't bother finalizing
      if (!this._isInitialized) { return; }
      this._isInitialized = false;
  
      this.triggerMethod('before:stop');
  
      // stop the sub-modules; depth-first, to make sure the
      // sub-modules are stopped / finalized before parents
      _.invoke(this.submodules, 'stop');
  
      // run the finalizers
      this._finalizerCallbacks.run(undefined, this);
  
      // reset the initializers and finalizers
      this._initializerCallbacks.reset();
      this._finalizerCallbacks.reset();
  
      this.triggerMethod('stop');
    },
  
    // Configure the module with a definition function and any custom args
    // that are to be passed in to the definition function
    addDefinition: function(moduleDefinition, customArgs) {
      this._runModuleDefinition(moduleDefinition, customArgs);
    },
  
    // Internal method: run the module definition function with the correct
    // arguments
    _runModuleDefinition: function(definition, customArgs) {
      // If there is no definition short circut the method.
      if (!definition) { return; }
  
      // build the correct list of arguments for the module definition
      var args = _.flatten([
        this,
        this.app,
        Backbone,
        Marionette,
        Backbone.$, _,
        customArgs
      ]);
  
      definition.apply(this, args);
    },
  
    // Internal method: set up new copies of initializers and finalizers.
    // Calling this method will wipe out all existing initializers and
    // finalizers.
    _setupInitializersAndFinalizers: function() {
      this._initializerCallbacks = new Marionette.Callbacks();
      this._finalizerCallbacks = new Marionette.Callbacks();
    },
  
    // import the `triggerMethod` to trigger events with corresponding
    // methods if the method exists
    triggerMethod: Marionette.triggerMethod
  });
  
  // Class methods to create modules
  _.extend(Marionette.Module, {
  
    // Create a module, hanging off the app parameter as the parent object.
    create: function(app, moduleNames, moduleDefinition) {
      var module = app;
  
      // get the custom args passed in after the module definition and
      // get rid of the module name and definition function
      var customArgs = _.drop(arguments, 3);
  
      // Split the module names and get the number of submodules.
      // i.e. an example module name of `Doge.Wow.Amaze` would
      // then have the potential for 3 module definitions.
      moduleNames = moduleNames.split('.');
      var length = moduleNames.length;
  
      // store the module definition for the last module in the chain
      var moduleDefinitions = [];
      moduleDefinitions[length - 1] = moduleDefinition;
  
      // Loop through all the parts of the module definition
      _.each(moduleNames, function(moduleName, i) {
        var parentModule = module;
        module = this._getModule(parentModule, moduleName, app, moduleDefinition);
        this._addModuleDefinition(parentModule, module, moduleDefinitions[i], customArgs);
      }, this);
  
      // Return the last module in the definition chain
      return module;
    },
  
    _getModule: function(parentModule, moduleName, app, def, args) {
      var options = _.extend({}, def);
      var ModuleClass = this.getClass(def);
  
      // Get an existing module of this name if we have one
      var module = parentModule[moduleName];
  
      if (!module) {
        // Create a new module if we don't have one
        module = new ModuleClass(moduleName, app, options);
        parentModule[moduleName] = module;
        // store the module on the parent
        parentModule.submodules[moduleName] = module;
      }
  
      return module;
    },
  
    // ## Module Classes
    //
    // Module classes can be used as an alternative to the define pattern.
    // The extend function of a Module is identical to the extend functions
    // on other Backbone and Marionette classes.
    // This allows module lifecyle events like `onStart` and `onStop` to be called directly.
    getClass: function(moduleDefinition) {
      var ModuleClass = Marionette.Module;
  
      if (!moduleDefinition) {
        return ModuleClass;
      }
  
      // If all of the module's functionality is defined inside its class,
      // then the class can be passed in directly. `MyApp.module("Foo", FooModule)`.
      if (moduleDefinition.prototype instanceof ModuleClass) {
        return moduleDefinition;
      }
  
      return moduleDefinition.moduleClass || ModuleClass;
    },
  
    // Add the module definition and add a startWithParent initializer function.
    // This is complicated because module definitions are heavily overloaded
    // and support an anonymous function, module class, or options object
    _addModuleDefinition: function(parentModule, module, def, args) {
      var fn = this._getDefine(def);
      var startWithParent = this._getStartWithParent(def, module);
  
      if (fn) {
        module.addDefinition(fn, args);
      }
  
      this._addStartWithParent(parentModule, module, startWithParent);
    },
  
    _getStartWithParent: function(def, module) {
      var swp;
  
      if (_.isFunction(def) && (def.prototype instanceof Marionette.Module)) {
        swp = module.constructor.prototype.startWithParent;
        return _.isUndefined(swp) ? true : swp;
      }
  
      if (_.isObject(def)) {
        swp = def.startWithParent;
        return _.isUndefined(swp) ? true : swp;
      }
  
      return true;
    },
  
    _getDefine: function(def) {
      if (_.isFunction(def) && !(def.prototype instanceof Marionette.Module)) {
        return def;
      }
  
      if (_.isObject(def)) {
        return def.define;
      }
  
      return null;
    },
  
    _addStartWithParent: function(parentModule, module, startWithParent) {
      module.startWithParent = module.startWithParent && startWithParent;
  
      if (!module.startWithParent || !!module.startWithParentIsConfigured) {
        return;
      }
  
      module.startWithParentIsConfigured = true;
  
      parentModule.addInitializer(function(options) {
        if (module.startWithParent) {
          module.start(options);
        }
      });
    }
  });
  

  return Marionette;
}));

}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})

},{"backbone.babysitter":5,"backbone.wreqr":7}],7:[function(require,module,exports){
(function (global){
// Backbone.Wreqr (Backbone.Marionette)
// ----------------------------------
// v1.4.0
//
// Copyright (c)2016 Derick Bailey, Muted Solutions, LLC.
// Distributed under MIT license
//
// http://github.com/marionettejs/backbone.wreqr


(function(root, factory) {

  if (typeof define === 'function' && define.amd) {
    define(['backbone', 'underscore'], function(Backbone, _) {
      return factory(Backbone, _);
    });
  } else if (typeof exports !== 'undefined') {
    var Backbone = (typeof window !== "undefined" ? window['Backbone'] : typeof global !== "undefined" ? global['Backbone'] : null);
    var _ = (typeof window !== "undefined" ? window['_'] : typeof global !== "undefined" ? global['_'] : null);
    module.exports = factory(Backbone, _);
  } else {
    factory(root.Backbone, root._);
  }

}(this, function(Backbone, _) {
  "use strict";

  var previousWreqr = Backbone.Wreqr;

  var Wreqr = Backbone.Wreqr = {};

  Backbone.Wreqr.VERSION = '1.4.0';

  Backbone.Wreqr.noConflict = function () {
    Backbone.Wreqr = previousWreqr;
    return this;
  };

  // Handlers
  // --------
  // A registry of functions to call, given a name
  
  Wreqr.Handlers = (function(Backbone, _){
    "use strict";
    
    // Constructor
    // -----------
  
    var Handlers = function(options){
      this.options = options;
      this._wreqrHandlers = {};
      
      if (_.isFunction(this.initialize)){
        this.initialize(options);
      }
    };
  
    Handlers.extend = Backbone.Model.extend;
  
    // Instance Members
    // ----------------
  
    _.extend(Handlers.prototype, Backbone.Events, {
  
      // Add multiple handlers using an object literal configuration
      setHandlers: function(handlers){
        _.each(handlers, _.bind(function(handler, name){
          var context = null;
  
          if (_.isObject(handler) && !_.isFunction(handler)){
            context = handler.context;
            handler = handler.callback;
          }
  
          this.setHandler(name, handler, context);
        }, this));
      },
  
      // Add a handler for the given name, with an
      // optional context to run the handler within
      setHandler: function(name, handler, context){
        var config = {
          callback: handler,
          context: context
        };
  
        this._wreqrHandlers[name] = config;
  
        this.trigger("handler:add", name, handler, context);
      },
  
      // Determine whether or not a handler is registered
      hasHandler: function(name){
        return !! this._wreqrHandlers[name];
      },
  
      // Get the currently registered handler for
      // the specified name. Throws an exception if
      // no handler is found.
      getHandler: function(name){
        var config = this._wreqrHandlers[name];
  
        if (!config){
          return;
        }
  
        return function(){
          return config.callback.apply(config.context, arguments);
        };
      },
  
      // Remove a handler for the specified name
      removeHandler: function(name){
        delete this._wreqrHandlers[name];
      },
  
      // Remove all handlers from this registry
      removeAllHandlers: function(){
        this._wreqrHandlers = {};
      }
    });
  
    return Handlers;
  })(Backbone, _);
  
  // Wreqr.CommandStorage
  // --------------------
  //
  // Store and retrieve commands for execution.
  Wreqr.CommandStorage = (function(){
    "use strict";
  
    // Constructor function
    var CommandStorage = function(options){
      this.options = options;
      this._commands = {};
  
      if (_.isFunction(this.initialize)){
        this.initialize(options);
      }
    };
  
    // Instance methods
    _.extend(CommandStorage.prototype, Backbone.Events, {
  
      // Get an object literal by command name, that contains
      // the `commandName` and the `instances` of all commands
      // represented as an array of arguments to process
      getCommands: function(commandName){
        var commands = this._commands[commandName];
  
        // we don't have it, so add it
        if (!commands){
  
          // build the configuration
          commands = {
            command: commandName, 
            instances: []
          };
  
          // store it
          this._commands[commandName] = commands;
        }
  
        return commands;
      },
  
      // Add a command by name, to the storage and store the
      // args for the command
      addCommand: function(commandName, args){
        var command = this.getCommands(commandName);
        command.instances.push(args);
      },
  
      // Clear all commands for the given `commandName`
      clearCommands: function(commandName){
        var command = this.getCommands(commandName);
        command.instances = [];
      }
    });
  
    return CommandStorage;
  })();
  
  // Wreqr.Commands
  // --------------
  //
  // A simple command pattern implementation. Register a command
  // handler and execute it.
  Wreqr.Commands = (function(Wreqr, _){
    "use strict";
  
    return Wreqr.Handlers.extend({
      // default storage type
      storageType: Wreqr.CommandStorage,
  
      constructor: function(options){
        this.options = options || {};
  
        this._initializeStorage(this.options);
        this.on("handler:add", this._executeCommands, this);
  
        Wreqr.Handlers.prototype.constructor.apply(this, arguments);
      },
  
      // Execute a named command with the supplied args
      execute: function(name){
        name = arguments[0];
        var args = _.rest(arguments);
  
        if (this.hasHandler(name)){
          this.getHandler(name).apply(this, args);
        } else {
          this.storage.addCommand(name, args);
        }
  
      },
  
      // Internal method to handle bulk execution of stored commands
      _executeCommands: function(name, handler, context){
        var command = this.storage.getCommands(name);
  
        // loop through and execute all the stored command instances
        _.each(command.instances, function(args){
          handler.apply(context, args);
        });
  
        this.storage.clearCommands(name);
      },
  
      // Internal method to initialize storage either from the type's
      // `storageType` or the instance `options.storageType`.
      _initializeStorage: function(options){
        var storage;
  
        var StorageType = options.storageType || this.storageType;
        if (_.isFunction(StorageType)){
          storage = new StorageType();
        } else {
          storage = StorageType;
        }
  
        this.storage = storage;
      }
    });
  
  })(Wreqr, _);
  
  // Wreqr.RequestResponse
  // ---------------------
  //
  // A simple request/response implementation. Register a
  // request handler, and return a response from it
  Wreqr.RequestResponse = (function(Wreqr, _){
    "use strict";
  
    return Wreqr.Handlers.extend({
      request: function(name){
        if (this.hasHandler(name)) {
          return this.getHandler(name).apply(this, _.rest(arguments));
        }
      }
    });
  
  })(Wreqr, _);
  
  // Event Aggregator
  // ----------------
  // A pub-sub object that can be used to decouple various parts
  // of an application through event-driven architecture.
  
  Wreqr.EventAggregator = (function(Backbone, _){
    "use strict";
    var EA = function(){};
  
    // Copy the `extend` function used by Backbone's classes
    EA.extend = Backbone.Model.extend;
  
    // Copy the basic Backbone.Events on to the event aggregator
    _.extend(EA.prototype, Backbone.Events);
  
    return EA;
  })(Backbone, _);
  
  // Wreqr.Channel
  // --------------
  //
  // An object that wraps the three messaging systems:
  // EventAggregator, RequestResponse, Commands
  Wreqr.Channel = (function(Wreqr){
    "use strict";
  
    var Channel = function(channelName) {
      this.vent        = new Backbone.Wreqr.EventAggregator();
      this.reqres      = new Backbone.Wreqr.RequestResponse();
      this.commands    = new Backbone.Wreqr.Commands();
      this.channelName = channelName;
    };
  
    _.extend(Channel.prototype, {
  
      // Remove all handlers from the messaging systems of this channel
      reset: function() {
        this.vent.off();
        this.vent.stopListening();
        this.reqres.removeAllHandlers();
        this.commands.removeAllHandlers();
        return this;
      },
  
      // Connect a hash of events; one for each messaging system
      connectEvents: function(hash, context) {
        this._connect('vent', hash, context);
        return this;
      },
  
      connectCommands: function(hash, context) {
        this._connect('commands', hash, context);
        return this;
      },
  
      connectRequests: function(hash, context) {
        this._connect('reqres', hash, context);
        return this;
      },
  
      // Attach the handlers to a given message system `type`
      _connect: function(type, hash, context) {
        if (!hash) {
          return;
        }
  
        context = context || this;
        var method = (type === 'vent') ? 'on' : 'setHandler';
  
        _.each(hash, _.bind(function(fn, eventName) {
          this[type][method](eventName, _.bind(fn, context));
        }, this));
      }
    });
  
  
    return Channel;
  })(Wreqr);
  
  // Wreqr.Radio
  // --------------
  //
  // An object that lets you communicate with many channels.
  Wreqr.radio = (function(Wreqr, _){
    "use strict";
  
    var Radio = function() {
      this._channels = {};
      this.vent = {};
      this.commands = {};
      this.reqres = {};
      this._proxyMethods();
    };
  
    _.extend(Radio.prototype, {
  
      channel: function(channelName) {
        if (!channelName) {
          throw new Error('Channel must receive a name');
        }
  
        return this._getChannel( channelName );
      },
  
      _getChannel: function(channelName) {
        var channel = this._channels[channelName];
  
        if(!channel) {
          channel = new Wreqr.Channel(channelName);
          this._channels[channelName] = channel;
        }
  
        return channel;
      },
  
      _proxyMethods: function() {
        _.each(['vent', 'commands', 'reqres'], _.bind(function(system) {
          _.each( messageSystems[system], _.bind(function(method) {
            this[system][method] = proxyMethod(this, system, method);
          }, this));
        }, this));
      }
    });
  
  
    var messageSystems = {
      vent: [
        'on',
        'off',
        'trigger',
        'once',
        'stopListening',
        'listenTo',
        'listenToOnce'
      ],
  
      commands: [
        'execute',
        'setHandler',
        'setHandlers',
        'removeHandler',
        'removeAllHandlers'
      ],
  
      reqres: [
        'request',
        'setHandler',
        'setHandlers',
        'removeHandler',
        'removeAllHandlers'
      ]
    };
  
    var proxyMethod = function(radio, system, method) {
      return function(channelName) {
        var messageSystem = radio._getChannel(channelName)[system];
  
        return messageSystem[method].apply(messageSystem, _.rest(arguments));
      };
    };
  
    return new Radio();
  
  })(Wreqr, _);
  

  return Backbone.Wreqr;

}));

}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})

},{}],8:[function(require,module,exports){
module.exports = require('./lib/bloodhound');

},{"./lib/bloodhound":10}],9:[function(require,module,exports){
var Promise = require('es6-promise').Promise;
var request = require('superagent');

module.exports = function(o) {
  return new Promise(function(resolve, reject) {
    request.get(o.url).end(function(err, res) {
      if(err) return reject(err);
      resolve(res.body);
    });
  });
};

},{"es6-promise":22,"superagent":33}],10:[function(require,module,exports){
var _ = require('./utils');
var Promise = require('es6-promise').Promise;
var Remote = require('./remote');
var Prefetch = require('./prefetch');
var tokenizers = require('./tokenizers');
var oParser = require('./options_parser');
var SearchIndex = require('./search_index');
var Transport = require('./transport');

function Bloodhound(o) {
  o = oParser(o);

  this.sorter = o.sorter;
  this.identify = o.identify;
  this.sufficient = o.sufficient;

  this.local = o.local;
  this.remote = o.remote ? new Remote(o.remote) : null;
  this.prefetch = o.prefetch ? new Prefetch(o.prefetch) : null;

  // the backing data structure used for fast pattern matching
  this.index = new SearchIndex({
    identify: this.identify,
    datumTokenizer: o.datumTokenizer,
    queryTokenizer: o.queryTokenizer
  });

  // hold off on intialization if the intialize option was explicitly false
  o.initialize !== false && this.initialize();
}

Bloodhound.tokenizers = tokenizers;

_.mixin(Bloodhound.prototype, {

  // ### super secret stuff used for integration with jquery plugin

  __ttAdapter: function ttAdapter() {
    var that = this;

    return this.remote ? withAsync : withoutAsync;

    function withAsync(query, sync, async) {
      return that.search(query, sync, async);
    }

    function withoutAsync(query, sync) {
      return that.search(query, sync);
    }
  },

  _loadPrefetch: function loadPrefetch() {
    var that = this, promise, serialized;

    if (!this.prefetch) {
      return new Promise(function(resolve, reject) {
        resolve();
      });
    }

    else if (serialized = this.prefetch.fromCache()) {
      this.index.bootstrap(serialized);
      return new Promise(function(resolve, reject) {
        resolve();
      });
    }

    else {
      // this.prefetch.fromNetwork(done);
      return new Promise(function(resolve, reject) {

        // todo: promise
        that.prefetch.fromNetwork(function(err, data) {
          if (err) return reject(err);

          try {
            that.add(data);
            that.prefetch.store(that.index.serialize());
            resolve();
          } catch(e) {
            reject(e);
          }
        });
      });
    }
  },

  _initialize: function() {
    var that = this, deferred;

    // in case this is a reinitialization, clear previous data
    this.clear();

    (this.initPromise = this._loadPrefetch())
    .then(addLocalToIndex); // local must be added to index after prefetch

    return this.initPromise;

    function addLocalToIndex() { that.add(that.local); }
  },

  // ### public

  initialize: function(force) {
    return !this.initPromise || force ? this._initialize() : this.initPromise;
  },

  // TODO: before initialize what happens?
  add: function(data) {
    this.index.add(data);
    return this;
  },

  get: function(ids) {
    ids = _.isArray(ids) ? ids : [].slice.call(arguments);
    return this.index.get(ids);
  },

  search: function(query, sync, async) {
    var that = this, local;

    local = this.sorter(this.index.search(query));

    // return a copy to guarantee no changes within this scope
    // as this array will get used when processing the remote results
    sync(this.remote ? local.slice() : local);

    if (this.remote && local.length < this.sufficient) {
      this.remote.get(query, processRemote);
    }

    else if (this.remote) {
      // #149: prevents outdated rate-limited requests from being sent
      this.remote.cancelLastRequest();
    }

    return this;

    function processRemote(remote) {
      var nonDuplicates = [];

      // exclude duplicates
      _.each(remote, function(r) {
         !_.some(local, function(l) {
          return that.identify(r) === that.identify(l);
        }) && nonDuplicates.push(r);
      });

      async && async(nonDuplicates);
    }
  },

  all: function() {
    return this.index.all();
  },

  clear: function() {
    this.index.reset();
    return this;
  },

  clearPrefetchCache: function() {
    this.prefetch && this.prefetch.clear();
    return this;
  },

  clearRemoteCache: function() {
    Transport.resetCache();
    return this;
  },

  // DEPRECATED: will be removed in v1
  ttAdapter: function() {
    return this.__ttAdapter();
  }
});

module.exports = Bloodhound;

},{"./options_parser":12,"./prefetch":14,"./remote":15,"./search_index":16,"./tokenizers":17,"./transport":18,"./utils":19,"es6-promise":22}],11:[function(require,module,exports){
/*
 * typeahead.js
 * https://github.com/twitter/typeahead.js
 * Copyright 2013-2014 Twitter, Inc. and other contributors; Licensed MIT
 */

// inspired by https://github.com/jharding/lru-cache

var _ = require('./utils');

function LruCache(maxSize) {
  this.maxSize = _.isNumber(maxSize) ? maxSize : 100;
  this.reset();

  // if max size is less than 0, provide a noop cache
  if (this.maxSize <= 0) {
    this.set = this.get = _.noop;
  }
}

_.mixin(LruCache.prototype, {
  set: function set(key, val) {
    var tailItem = this.list.tail, node;

    // at capacity
    if (this.size >= this.maxSize) {
      this.list.remove(tailItem);
      delete this.hash[tailItem.key];

      this.size--;
    }

    // writing over existing key
    if (node = this.hash[key]) {
      node.val = val;
      this.list.moveToFront(node);
    }

    // new key
    else {
      node = new Node(key, val);

      this.list.add(node);
      this.hash[key] = node;

      this.size++;
    }
  },

  get: function get(key) {
    var node = this.hash[key];

    if (node) {
      this.list.moveToFront(node);
      return node.val;
    }
  },

  reset: function reset() {
    this.size = 0;
    this.hash = {};
    this.list = new List();
  }
});

function List() {
  this.head = this.tail = null;
}

_.mixin(List.prototype, {
  add: function add(node) {
    if (this.head) {
      node.next = this.head;
      this.head.prev = node;
    }

    this.head = node;
    this.tail = this.tail || node;
  },

  remove: function remove(node) {
    node.prev ? node.prev.next = node.next : this.head = node.next;
    node.next ? node.next.prev = node.prev : this.tail = node.prev;
  },

  moveToFront: function(node) {
    this.remove(node);
    this.add(node);
  }
});

function Node(key, val) {
  this.key = key;
  this.val = val;
  this.prev = this.next = null;
}

module.exports = LruCache;

},{"./utils":19}],12:[function(require,module,exports){
var _ = require('./utils');
var ajax = require('./ajax');
var VERSION = require('./version');

module.exports = function(o) {
  var defaults, sorter;

  defaults = {
    initialize: true,
    identify: _.stringify,
    datumTokenizer: null,
    queryTokenizer: null,
    sufficient: 5,
    sorter: null,
    local: [],
    prefetch: null,
    remote: null
  };

  o = _.mixin(defaults, o || {});

  // throw error if required options are not set
  !o.datumTokenizer && _.error('datumTokenizer is required');
  !o.queryTokenizer && _.error('queryTokenizer is required');

  sorter = o.sorter;
  o.sorter = sorter ? function(x) { return x.sort(sorter); } : _.identity;

  o.local = _.isFunction(o.local) ? o.local() : o.local;
  o.prefetch = parsePrefetch(o.prefetch);
  o.remote = parseRemote(o.remote);

  return o;
};

function parsePrefetch(o) {
  var defaults;

  if (!o) { return null; }

  defaults = {
    url: null,
    ttl: 24 * 60 * 60 * 1000, // 1 day
    cache: true,
    cacheKey: null,
    thumbprint: '',
    prepare: _.identity,
    transform: _.identity,
    transport: null
  };

  // support basic (url) and advanced configuration
  o = _.isString(o) ? { url: o } : o;
  o = _.mixin(defaults, o);

  // throw error if required options are not set
  !o.url && _.error('prefetch requires url to be set');

  // DEPRECATED: filter will be dropped in v1
  o.transform = o.filter || o.transform;

  o.cacheKey = o.cacheKey || o.url;
  o.thumbprint = VERSION + o.thumbprint;
  o.transport = o.transport ? callbackToDeferred(o.transport) : ajax;

  return o;
}

function parseRemote(o) {
  var defaults;

  if (!o) { return; }

  defaults = {
    url: null,
    cache: true, // leave undocumented
    prepare: null,
    replace: null,
    wildcard: null,
    limiter: null,
    rateLimitBy: 'debounce',
    rateLimitWait: 300,
    transform: _.identity,
    transport: null
  };

  // support basic (url) and advanced configuration
  o = _.isString(o) ? { url: o } : o;
  o = _.mixin(defaults, o);

  // throw error if required options are not set
  !o.url && _.error('remote requires url to be set');

  // DEPRECATED: filter will be dropped in v1
  o.transform = o.filter || o.transform;

  o.prepare = toRemotePrepare(o);
  o.limiter = toLimiter(o);
  o.transport = o.transport ? callbackToDeferred(o.transport) : ajax;

  delete o.replace;
  delete o.wildcard;
  delete o.rateLimitBy;
  delete o.rateLimitWait;

  return o;
}

function toRemotePrepare(o) {
  var prepare, replace, wildcard;

  prepare = o.prepare;
  replace = o.replace;
  wildcard = o.wildcard;

  if (prepare) { return prepare; }

  if (replace) {
    prepare = prepareByReplace;
  }

  else if (o.wildcard) {
    prepare = prepareByWildcard;
  }

  else {
    prepare = idenityPrepare;
  }

  return prepare;

  function prepareByReplace(query, settings) {
    settings.url = replace(settings.url, query);
    return settings;
  }

  function prepareByWildcard(query, settings) {
    settings.url = settings.url.replace(wildcard, encodeURIComponent(query));
    return settings;
  }

  function idenityPrepare(query, settings) {
    return settings;
  }
}

function toLimiter(o) {
  var limiter, method, wait;

  limiter = o.limiter;
  method = o.rateLimitBy;
  wait = o.rateLimitWait;

  if (!limiter) {
    limiter = /^throttle$/i.test(method) ? throttle(wait) : debounce(wait);
  }

  return limiter;

  function debounce(wait) {
    return function(fn) {
      return _.debounce(fn, wait);
    };
  }

  function throttle(wait) {
    return function (fn) {
      return _.throttle(fn, wait);
    };
  }
}

function callbackToDeferred(fn) {
  return function(o) {
    // var deferred = $.Deferred();

    // fn(o, onSuccess, onError);

    // return deferred;

    // function onSuccess(resp) {
    //   // defer in case fn is synchronous, otherwise done
    //   // and always handlers will be attached after the resolution
    //   _.defer(function() { deferred.resolve(resp); });
    // }

    // function onError(err) {
    //   // defer in case fn is synchronous, otherwise done
    //   // and always handlers will be attached after the resolution
    //   _.defer(function() { deferred.reject(err); });
    // }
  };
}

},{"./ajax":9,"./utils":19,"./version":20}],13:[function(require,module,exports){
var storage2 = require('storage2');
var _ = require('./utils');

var LOCAL_STORAGE;

try {
  LOCAL_STORAGE = storage2.localStorage;

  // while in private browsing mode, some browsers make
  // localStorage available, but throw an error when used
  LOCAL_STORAGE.setItem('~~~', '!');
  LOCAL_STORAGE.removeItem('~~~');
} catch (err) {
  LOCAL_STORAGE = null;
}

// constructor
// -----------

function PersistentStorage(namespace, override) {
  this.prefix = ['__', namespace, '__'].join('');
  this.ttlKey = '__ttl__';
  this.keyMatcher = new RegExp('^' + _.escapeRegExChars(this.prefix));

  // for testing purpose
  this.ls = override || LOCAL_STORAGE;

  // if local storage isn't available, everything becomes a noop
  !this.ls && this._noop();
}

// instance methods
// ----------------

_.mixin(PersistentStorage.prototype, {
  // ### private

  _prefix: function(key) {
    return this.prefix + key;
  },

  _ttlKey: function(key) {
    return this._prefix(key) + this.ttlKey;
  },

  _noop: function() {
    this.get =
    this.set =
    this.remove =
    this.clear =
    this.isExpired = _.noop;
  },

  _safeSet: function(key, val) {
    try {
      this.ls.setItem(key, val);
    } catch (err) {
      // hit the localstorage limit so clean up and better luck next time
      if (err.name === 'QuotaExceededError') {
        this.clear();
        this._noop();
      }
    }
  },

  // ### public

  get: function(key) {
    if (this.isExpired(key)) {
      this.remove(key);
    }

    return decode(this.ls.getItem(this._prefix(key)));
  },

  set: function(key, val, ttl) {
    if (_.isNumber(ttl)) {
      this._safeSet(this._ttlKey(key), encode(now() + ttl));
    }

    else {
      this.ls.removeItem(this._ttlKey(key));
    }

    return this._safeSet(this._prefix(key), encode(val));
  },

  remove: function(key) {
    this.ls.removeItem(this._ttlKey(key));
    this.ls.removeItem(this._prefix(key));

    return this;
  },

  clear: function() {
    var i, keys = gatherMatchingKeys(this.keyMatcher);

    for (i = keys.length; i--;) {
      this.remove(keys[i]);
    }

    return this;
  },

  isExpired: function(key) {
    var ttl = decode(this.ls.getItem(this._ttlKey(key)));

    return _.isNumber(ttl) && now() > ttl ? true : false;
  }
});


// helper functions
// ----------------

function now() {
  return new Date().getTime();
}

function encode(val) {
  // convert undefined to null to avoid issues with JSON.parse
  return JSON.stringify(_.isUndefined(val) ? null : val);
}

function decode(val) {
  return JSON.parse(val);
  // return $.parseJSON(val);
}

function gatherMatchingKeys(keyMatcher) {
  var i, key, keys = [], len = LOCAL_STORAGE.length;

  for (i = 0; i < len; i++) {
    if ((key = LOCAL_STORAGE.key(i)).match(keyMatcher)) {
      keys.push(key.replace(keyMatcher, ''));
    }
  }

  return keys;
}

module.exports = PersistentStorage;

},{"./utils":19,"storage2":28}],14:[function(require,module,exports){
var PersistentStorage = require('./persistent_storage');
var _ = require('./utils');

var keys = { data: 'data', protocol: 'protocol', thumbprint: 'thumbprint' };
var location = null;


if(typeof window !== 'undefined') {
  location = window.location;
} else {
  location = {
    protocol: 'https:'
  };
}


// constructor
// -----------

// defaults for options are handled in options_parser
function Prefetch(o) {
  this.url = o.url;
  this.ttl = o.ttl;
  this.cache = o.cache;
  this.prepare = o.prepare;
  this.transform = o.transform;
  this.transport = o.transport;
  this.thumbprint = o.thumbprint;

  this.storage = new PersistentStorage(o.cacheKey);
}

_.mixin(Prefetch.prototype, {

  _settings: function() {
    return { url: this.url, type: 'GET', dataType: 'json' };
  },

  store: function(data) {
    if (!this.cache) { return; }

    this.storage.set(keys.data, data, this.ttl);
    this.storage.set(keys.protocol, location.protocol, this.ttl);
    this.storage.set(keys.thumbprint, this.thumbprint, this.ttl);
  },

  fromCache: function() {
    var stored = {}, isExpired;

    if (!this.cache) { return null; }

    stored.data = this.storage.get(keys.data);
    stored.protocol = this.storage.get(keys.protocol);
    stored.thumbprint = this.storage.get(keys.thumbprint);

    // the stored data is considered expired if the thumbprints
    // don't match or if the protocol it was originally stored under
    // has changed
    isExpired =
      stored.thumbprint !== this.thumbprint ||
      stored.protocol !== location.protocol;

    // TODO: if expired, remove from local storage

    return stored.data && !isExpired ? stored.data : null;
  },

  fromNetwork: function(cb) {
    var that = this, settings;

    if (!cb) { return; }

    settings = this.prepare(this._settings());

    // this.transport(settings).fail(onError).done(onResponse);
    this.transport(settings).then(onResponse, onError);

    function onError() { cb(true); }
    function onResponse(resp) { cb(null, that.transform(resp)); }
  },

  clear: function() {
    this.storage.clear();
    return this;
  }
});

module.exports = Prefetch;

},{"./persistent_storage":13,"./utils":19}],15:[function(require,module,exports){
/*
 * typeahead.js
 * https://github.com/twitter/typeahead.js
 * Copyright 2013-2014 Twitter, Inc. and other contributors; Licensed MIT
 */

var _ = require('./utils');
var Transport = require('./transport');

function Remote(o) {
  this.url = o.url;
  this.prepare = o.prepare;
  this.transform = o.transform;

  this.transport = new Transport({
    cache: o.cache,
    limiter: o.limiter,
    transport: o.transport
  });
}

_.mixin(Remote.prototype, {
  // ### private

  _settings: function settings() {
    return {
      url: this.url,
      type: 'GET',
      dataType: 'json'
    };
  },

  get: function get(query, cb) {
    var that = this, settings;

    if (!cb) { return; }

    query = query || '';
    settings = this.prepare(query, this._settings());

    return this.transport.get(settings, onResponse);

    function onResponse(err, resp) {
      err ? cb([]) : cb(that.transform(resp));
    }
  },

  cancelLastRequest: function cancelLastRequest() {
    this.transport.cancel();
  }
});

module.exports = Remote;
},{"./transport":18,"./utils":19}],16:[function(require,module,exports){
var _ = require('./utils');

var CHILDREN = 'c';
var IDS = 'i';

function SearchIndex(o) {
  o = o || {};

  if (!o.datumTokenizer || !o.queryTokenizer) {
    throw new Error('datumTokenizer and queryTokenizer are both required');
  }

  this.identify = o.identify || _.stringify;
  this.datumTokenizer = o.datumTokenizer;
  this.queryTokenizer = o.queryTokenizer;

  this.reset();
}

_.mixin(SearchIndex.prototype, {

  bootstrap: function(o) {
    this.datums = o.datums;
    this.trie = o.trie;
  },

  add: function(data) {
    var that = this;

    data = _.isArray(data) ? data : [data];

    _.each(data, function(datum) {
      var id, tokens;

      that.datums[id = that.identify(datum)] = datum;
      tokens = normalizeTokens(that.datumTokenizer(datum));

      _.each(tokens, function(token) {
        var node, chars, ch;

        node = that.trie;
        chars = token.split('');

        while (ch = chars.shift()) {
          node = node[CHILDREN][ch] || (node[CHILDREN][ch] = newNode());
          node[IDS].push(id);
        }
      });
    });
  },

  get: function(ids) {
    var that = this;

    return _.map(ids, function(id) { return that.datums[id]; });
  },

  search: function(query) {
    var that = this, tokens, matches;

    tokens = normalizeTokens(this.queryTokenizer(query));

    _.each(tokens, function(token) {
      var node, chars, ch, ids;

      // previous tokens didn't share any matches
      if (matches && matches.length === 0) {
        return false;
      }

      node = that.trie;
      chars = token.split('');

      while (node && (ch = chars.shift())) {
        node = node[CHILDREN][ch];
      }

      if (node && chars.length === 0) {
        ids = node[IDS].slice(0);
        matches = matches ? getIntersection(matches, ids) : ids;
      }

      // break early if we find out there are no possible matches
      else {
        matches = [];
        return false;
      }
    });

    return matches ?
      _.map(unique(matches), function(id) { return that.datums[id]; }) : [];
  },

  all: function() {
    var values = [];

    for (var key in this.datums) {
      values.push(this.datums[key]);
    }

    return values;
  },

  reset: function() {
    this.datums = {};
    this.trie = newNode();
  },

  serialize: function serialize() {
    return { datums: this.datums, trie: this.trie };
  }
});


function normalizeTokens(tokens) {
 // filter out falsy tokens
  tokens = _.filter(tokens, function(token) { return !!token; });

  // normalize tokens
  tokens = _.map(tokens, function(token) { return token.toLowerCase(); });

  return tokens;
}

function newNode() {
  var node = {};

  node[IDS] = [];
  node[CHILDREN] = {};

  return node;
}

function unique(array) {
  var seen = {}, uniques = [];

  for (var i = 0, len = array.length; i < len; i++) {
    if (!seen[array[i]]) {
      seen[array[i]] = true;
      uniques.push(array[i]);
    }
  }

  return uniques;
}

function getIntersection(arrayA, arrayB) {
  var ai = 0, bi = 0, intersection = [];

  arrayA = arrayA.sort();
  arrayB = arrayB.sort();

  var lenArrayA = arrayA.length, lenArrayB = arrayB.length;

  while (ai < lenArrayA && bi < lenArrayB) {
    if (arrayA[ai] < arrayB[bi]) {
      ai++;
    }

    else if (arrayA[ai] > arrayB[bi]) {
      bi++;
    }

    else {
      intersection.push(arrayA[ai]);
      ai++;
      bi++;
    }
  }

  return intersection;
}

module.exports = SearchIndex;

},{"./utils":19}],17:[function(require,module,exports){
/*
 * typeahead.js
 * https://github.com/twitter/typeahead.js
 * Copyright 2013-2014 Twitter, Inc. and other contributors; Licensed MIT
 */

var _ = require('./utils');

function whitespace(str) {
  str = _.toStr(str);
  return str ? str.split(/\s+/) : [];
}

function nonword(str) {
  str = _.toStr(str);
  return str ? str.split(/\W+/) : [];
}

function getObjTokenizer(tokenizer) {
  return function setKey(keys) {
    keys = _.isArray(keys) ? keys : [].slice.call(arguments, 0);

    return function tokenize(o) {
      var tokens = [];

      _.each(keys, function(k) {
        tokens = tokens.concat(tokenizer(_.toStr(o[k])));
      });

      return tokens;
    };
  };
}

module.exports = {
  nonword: nonword,
  whitespace: whitespace,
  obj: {
    nonword: getObjTokenizer(nonword),
    whitespace: getObjTokenizer(whitespace)
  }
};

},{"./utils":19}],18:[function(require,module,exports){
var LruCache = require('./lru_cache');
var _ = require('./utils');

var pendingRequestsCount = 0;
var pendingRequests = {};
var maxPendingRequests = 6;
var sharedCache = new LruCache(10);

function Transport(o) {
  o = o || {};

  this.cancelled = false;
  this.lastReq = null;

  this._send = o.transport;
  this._get = o.limiter ? o.limiter(this._get) : this._get;

  this._cache = o.cache === false ? new LruCache(0) : sharedCache;
}

Transport.setMaxPendingRequests = function setMaxPendingRequests(num) {
  maxPendingRequests = num;
};

Transport.resetCache = function resetCache() {
  sharedCache.reset();
};

_.mixin(Transport.prototype, {

  _fingerprint: function(o) {
    o = o || {};
    return o.url + o.type + JSON.stringify(o.data || {}); 
  },

  _get: function(o, cb) {
    var that = this, fingerprint, jqXhr;

    fingerprint = this._fingerprint(o);

    // #149: don't make a network request if there has been a cancellation
    // or if the url doesn't match the last url Transport#get was invoked with
    if (this.cancelled || fingerprint !== this.lastReq) { return; }

    // a request is already in progress, piggyback off of it
    if (jqXhr = pendingRequests[fingerprint]) {
      // jqXhr.done(done).fail(fail);
      jqXhr.then(done, fail);
    }

    // under the pending request threshold, so fire off a request
    else if (pendingRequestsCount < maxPendingRequests) {
      pendingRequestsCount++;
      pendingRequests[fingerprint] =
        // this._send(o).done(done).fail(fail).always(always);
        this._send(o).then(function(resp) {
          done(resp);
          always();
        }, function() {
          fail();
          always();
        });
    }

    // at the pending request threshold, so hang out in the on deck circle
    else {
      this.onDeckRequestArgs = [].slice.call(arguments, 0);
    }

    function done(resp) {
      cb(null, resp);
      that._cache.set(fingerprint, resp);
    }

    function fail() {
      cb(true);
    }

    function always() {
      pendingRequestsCount--;
      delete pendingRequests[fingerprint];

      // ensures request is always made for the last query
      if (that.onDeckRequestArgs) {
        that._get.apply(that, that.onDeckRequestArgs);
        that.onDeckRequestArgs = null;
      }
    }
  },

  get: function(o, cb) {
    var resp, fingerprint;

    cb = cb || _.noop;
    o = _.isString(o) ? { url: o } : (o || {});

    fingerprint = this._fingerprint(o);

    this.cancelled = false;
    this.lastReq = fingerprint;

    // in-memory cache hit
    if (resp = this._cache.get(fingerprint)) {
      cb(null, resp);
    }

    // go to network
    else {
      this._get(o, cb);
    }
  },

  cancel: function() {
    this.cancelled = true;
  }
});

module.exports = Transport;

},{"./lru_cache":11,"./utils":19}],19:[function(require,module,exports){
/*
 * typeahead.js
 * https://github.com/twitter/typeahead.js
 * Copyright 2013-2014 Twitter, Inc. and other contributors; Licensed MIT
 */

var assign = require('object-assign');

var _ = {
  isMsie: function() {
    // from https://github.com/ded/bowser/blob/master/bowser.js
    return (/(msie|trident)/i).test(navigator.userAgent) ?
      navigator.userAgent.match(/(msie |rv:)(\d+(.\d+)?)/i)[2] : false;
  },

  isBlankString: function(str) { return !str || /^\s*$/.test(str); },

  // http://stackoverflow.com/a/6969486
  escapeRegExChars: function(str) {
    return str.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, '\\$&');
  },

  isString: function(obj) { return typeof obj === 'string'; },

  isNumber: function(obj) { return typeof obj === 'number'; },

  isArray: Array.isArray,

  isFunction: function(obj) {
		return typeof obj === 'function';
	},

  isObject: function(obj) {
    return typeof obj === 'object';
  },

  isUndefined: function(obj) { return typeof obj === 'undefined'; },

  isElement: function(obj) { return !!(obj && obj.nodeType === 1); },

  isJQuery: function(obj) { return obj instanceof $; },

  toStr: function toStr(s) {
    return (_.isUndefined(s) || s === null) ? '' : s + '';
  },

  bind: function(fn, context) {
    return fn.bind(context);
  },

  each: function(collection, cb) {
    collection.forEach(cb);
  },

  map: function(array, fn) {
    return array.map(fn);
  },

  filter: function(array, fn) {
    return array.filter(fn);
  },

  every: function(obj, test) {
    var result = true;

    if (!obj) { return result; }

    // $.each(obj, function(key, val) {
    //   if (!(result = test.call(null, val, key, obj))) {
    //     return false;
    //   }
    // });

    for(var key in obj) {
      if(obj.hasOwnProperty(key)) {
        var val = obj[key];
        if (!(result = test.call(null, val, key, obj))) {
          return false;
        }
      }
    }

    return !!result;
  },

  some: function(obj, test) {
    var result = false;

    if (!obj) { return result; }

    // $.each(obj, function(key, val) {
    //   if (result = test.call(null, val, key, obj)) {
    //     return false;
    //   }
    // });

    for(var key in obj) {
      if(obj.hasOwnProperty(key)) {
        var val = obj[key];
        if (result = test.call(null, val, key, obj)) {
          return false;
        }
      }
    }

    return !!result;
  },

  mixin: require('object-assign'),

  identity: function(x) { return x; },

  clone: function(obj) { return assign({}, obj); },

  getIdGenerator: function() {
    var counter = 0;
    return function() { return counter++; };
  },

  templatify: function templatify(obj) {
    return _.isFunction(obj) ? obj : template;

    function template() { return String(obj); }
  },

  defer: function(fn) { setTimeout(fn, 0); },

  debounce: function(func, wait, immediate) {
    var timeout, result;

    return function() {
      var context = this, args = arguments, later, callNow;

      later = function() {
        timeout = null;
        if (!immediate) { result = func.apply(context, args); }
      };

      callNow = immediate && !timeout;

      clearTimeout(timeout);
      timeout = setTimeout(later, wait);

      if (callNow) { result = func.apply(context, args); }

      return result;
    };
  },

  throttle: function(func, wait) {
    var context, args, timeout, result, previous, later;

    previous = 0;
    later = function() {
      previous = new Date();
      timeout = null;
      result = func.apply(context, args);
    };

    return function() {
      var now = new Date(),
          remaining = wait - (now - previous);

      context = this;
      args = arguments;

      if (remaining <= 0) {
        clearTimeout(timeout);
        timeout = null;
        previous = now;
        result = func.apply(context, args);
      }

      else if (!timeout) {
        timeout = setTimeout(later, remaining);
      }

      return result;
    };
  },

  stringify: function(val) {
    return _.isString(val) ? val : JSON.stringify(val);
  },

  noop: function() {},

  error: function(msg) {
    throw new Error(msg);
  }
};

module.exports = _;

},{"object-assign":26}],20:[function(require,module,exports){
/*
 * typeahead.js
 * https://github.com/twitter/typeahead.js
 * Copyright 2013-2014 Twitter, Inc. and other contributors; Licensed MIT
 */

module.exports = '1.0.0';

},{}],21:[function(require,module,exports){

/**
 * Expose `Emitter`.
 */

if (typeof module !== 'undefined') {
  module.exports = Emitter;
}

/**
 * Initialize a new `Emitter`.
 *
 * @api public
 */

function Emitter(obj) {
  if (obj) return mixin(obj);
};

/**
 * Mixin the emitter properties.
 *
 * @param {Object} obj
 * @return {Object}
 * @api private
 */

function mixin(obj) {
  for (var key in Emitter.prototype) {
    obj[key] = Emitter.prototype[key];
  }
  return obj;
}

/**
 * Listen on the given `event` with `fn`.
 *
 * @param {String} event
 * @param {Function} fn
 * @return {Emitter}
 * @api public
 */

Emitter.prototype.on =
Emitter.prototype.addEventListener = function(event, fn){
  this._callbacks = this._callbacks || {};
  (this._callbacks['$' + event] = this._callbacks['$' + event] || [])
    .push(fn);
  return this;
};

/**
 * Adds an `event` listener that will be invoked a single
 * time then automatically removed.
 *
 * @param {String} event
 * @param {Function} fn
 * @return {Emitter}
 * @api public
 */

Emitter.prototype.once = function(event, fn){
  function on() {
    this.off(event, on);
    fn.apply(this, arguments);
  }

  on.fn = fn;
  this.on(event, on);
  return this;
};

/**
 * Remove the given callback for `event` or all
 * registered callbacks.
 *
 * @param {String} event
 * @param {Function} fn
 * @return {Emitter}
 * @api public
 */

Emitter.prototype.off =
Emitter.prototype.removeListener =
Emitter.prototype.removeAllListeners =
Emitter.prototype.removeEventListener = function(event, fn){
  this._callbacks = this._callbacks || {};

  // all
  if (0 == arguments.length) {
    this._callbacks = {};
    return this;
  }

  // specific event
  var callbacks = this._callbacks['$' + event];
  if (!callbacks) return this;

  // remove all handlers
  if (1 == arguments.length) {
    delete this._callbacks['$' + event];
    return this;
  }

  // remove specific handler
  var cb;
  for (var i = 0; i < callbacks.length; i++) {
    cb = callbacks[i];
    if (cb === fn || cb.fn === fn) {
      callbacks.splice(i, 1);
      break;
    }
  }
  return this;
};

/**
 * Emit `event` with the given args.
 *
 * @param {String} event
 * @param {Mixed} ...
 * @return {Emitter}
 */

Emitter.prototype.emit = function(event){
  this._callbacks = this._callbacks || {};
  var args = [].slice.call(arguments, 1)
    , callbacks = this._callbacks['$' + event];

  if (callbacks) {
    callbacks = callbacks.slice(0);
    for (var i = 0, len = callbacks.length; i < len; ++i) {
      callbacks[i].apply(this, args);
    }
  }

  return this;
};

/**
 * Return array of callbacks for `event`.
 *
 * @param {String} event
 * @return {Array}
 * @api public
 */

Emitter.prototype.listeners = function(event){
  this._callbacks = this._callbacks || {};
  return this._callbacks['$' + event] || [];
};

/**
 * Check if this emitter has `event` handlers.
 *
 * @param {String} event
 * @return {Boolean}
 * @api public
 */

Emitter.prototype.hasListeners = function(event){
  return !! this.listeners(event).length;
};

},{}],22:[function(require,module,exports){
(function (process,global){
/*!
 * @overview es6-promise - a tiny implementation of Promises/A+.
 * @copyright Copyright (c) 2014 Yehuda Katz, Tom Dale, Stefan Penner and contributors (Conversion to ES6 API by Jake Archibald)
 * @license   Licensed under MIT license
 *            See https://raw.githubusercontent.com/stefanpenner/es6-promise/master/LICENSE
 * @version   3.3.1
 */

(function (global, factory) {
    typeof exports === 'object' && typeof module !== 'undefined' ? module.exports = factory() :
    typeof define === 'function' && define.amd ? define(factory) :
    (global.ES6Promise = factory());
}(this, (function () { 'use strict';

function objectOrFunction(x) {
  return typeof x === 'function' || typeof x === 'object' && x !== null;
}

function isFunction(x) {
  return typeof x === 'function';
}

var _isArray = undefined;
if (!Array.isArray) {
  _isArray = function (x) {
    return Object.prototype.toString.call(x) === '[object Array]';
  };
} else {
  _isArray = Array.isArray;
}

var isArray = _isArray;

var len = 0;
var vertxNext = undefined;
var customSchedulerFn = undefined;

var asap = function asap(callback, arg) {
  queue[len] = callback;
  queue[len + 1] = arg;
  len += 2;
  if (len === 2) {
    // If len is 2, that means that we need to schedule an async flush.
    // If additional callbacks are queued before the queue is flushed, they
    // will be processed by this flush that we are scheduling.
    if (customSchedulerFn) {
      customSchedulerFn(flush);
    } else {
      scheduleFlush();
    }
  }
};

function setScheduler(scheduleFn) {
  customSchedulerFn = scheduleFn;
}

function setAsap(asapFn) {
  asap = asapFn;
}

var browserWindow = typeof window !== 'undefined' ? window : undefined;
var browserGlobal = browserWindow || {};
var BrowserMutationObserver = browserGlobal.MutationObserver || browserGlobal.WebKitMutationObserver;
var isNode = typeof self === 'undefined' && typeof process !== 'undefined' && ({}).toString.call(process) === '[object process]';

// test for web worker but not in IE10
var isWorker = typeof Uint8ClampedArray !== 'undefined' && typeof importScripts !== 'undefined' && typeof MessageChannel !== 'undefined';

// node
function useNextTick() {
  // node version 0.10.x displays a deprecation warning when nextTick is used recursively
  // see https://github.com/cujojs/when/issues/410 for details
  return function () {
    return process.nextTick(flush);
  };
}

// vertx
function useVertxTimer() {
  return function () {
    vertxNext(flush);
  };
}

function useMutationObserver() {
  var iterations = 0;
  var observer = new BrowserMutationObserver(flush);
  var node = document.createTextNode('');
  observer.observe(node, { characterData: true });

  return function () {
    node.data = iterations = ++iterations % 2;
  };
}

// web worker
function useMessageChannel() {
  var channel = new MessageChannel();
  channel.port1.onmessage = flush;
  return function () {
    return channel.port2.postMessage(0);
  };
}

function useSetTimeout() {
  // Store setTimeout reference so es6-promise will be unaffected by
  // other code modifying setTimeout (like sinon.useFakeTimers())
  var globalSetTimeout = setTimeout;
  return function () {
    return globalSetTimeout(flush, 1);
  };
}

var queue = new Array(1000);
function flush() {
  for (var i = 0; i < len; i += 2) {
    var callback = queue[i];
    var arg = queue[i + 1];

    callback(arg);

    queue[i] = undefined;
    queue[i + 1] = undefined;
  }

  len = 0;
}

function attemptVertx() {
  try {
    var r = require;
    var vertx = r('vertx');
    vertxNext = vertx.runOnLoop || vertx.runOnContext;
    return useVertxTimer();
  } catch (e) {
    return useSetTimeout();
  }
}

var scheduleFlush = undefined;
// Decide what async method to use to triggering processing of queued callbacks:
if (isNode) {
  scheduleFlush = useNextTick();
} else if (BrowserMutationObserver) {
  scheduleFlush = useMutationObserver();
} else if (isWorker) {
  scheduleFlush = useMessageChannel();
} else if (browserWindow === undefined && typeof require === 'function') {
  scheduleFlush = attemptVertx();
} else {
  scheduleFlush = useSetTimeout();
}

function then(onFulfillment, onRejection) {
  var _arguments = arguments;

  var parent = this;

  var child = new this.constructor(noop);

  if (child[PROMISE_ID] === undefined) {
    makePromise(child);
  }

  var _state = parent._state;

  if (_state) {
    (function () {
      var callback = _arguments[_state - 1];
      asap(function () {
        return invokeCallback(_state, child, callback, parent._result);
      });
    })();
  } else {
    subscribe(parent, child, onFulfillment, onRejection);
  }

  return child;
}

/**
  `Promise.resolve` returns a promise that will become resolved with the
  passed `value`. It is shorthand for the following:

  ```javascript
  let promise = new Promise(function(resolve, reject){
    resolve(1);
  });

  promise.then(function(value){
    // value === 1
  });
  ```

  Instead of writing the above, your code now simply becomes the following:

  ```javascript
  let promise = Promise.resolve(1);

  promise.then(function(value){
    // value === 1
  });
  ```

  @method resolve
  @static
  @param {Any} value value that the returned promise will be resolved with
  Useful for tooling.
  @return {Promise} a promise that will become fulfilled with the given
  `value`
*/
function resolve(object) {
  /*jshint validthis:true */
  var Constructor = this;

  if (object && typeof object === 'object' && object.constructor === Constructor) {
    return object;
  }

  var promise = new Constructor(noop);
  _resolve(promise, object);
  return promise;
}

var PROMISE_ID = Math.random().toString(36).substring(16);

function noop() {}

var PENDING = void 0;
var FULFILLED = 1;
var REJECTED = 2;

var GET_THEN_ERROR = new ErrorObject();

function selfFulfillment() {
  return new TypeError("You cannot resolve a promise with itself");
}

function cannotReturnOwn() {
  return new TypeError('A promises callback cannot return that same promise.');
}

function getThen(promise) {
  try {
    return promise.then;
  } catch (error) {
    GET_THEN_ERROR.error = error;
    return GET_THEN_ERROR;
  }
}

function tryThen(then, value, fulfillmentHandler, rejectionHandler) {
  try {
    then.call(value, fulfillmentHandler, rejectionHandler);
  } catch (e) {
    return e;
  }
}

function handleForeignThenable(promise, thenable, then) {
  asap(function (promise) {
    var sealed = false;
    var error = tryThen(then, thenable, function (value) {
      if (sealed) {
        return;
      }
      sealed = true;
      if (thenable !== value) {
        _resolve(promise, value);
      } else {
        fulfill(promise, value);
      }
    }, function (reason) {
      if (sealed) {
        return;
      }
      sealed = true;

      _reject(promise, reason);
    }, 'Settle: ' + (promise._label || ' unknown promise'));

    if (!sealed && error) {
      sealed = true;
      _reject(promise, error);
    }
  }, promise);
}

function handleOwnThenable(promise, thenable) {
  if (thenable._state === FULFILLED) {
    fulfill(promise, thenable._result);
  } else if (thenable._state === REJECTED) {
    _reject(promise, thenable._result);
  } else {
    subscribe(thenable, undefined, function (value) {
      return _resolve(promise, value);
    }, function (reason) {
      return _reject(promise, reason);
    });
  }
}

function handleMaybeThenable(promise, maybeThenable, then$$) {
  if (maybeThenable.constructor === promise.constructor && then$$ === then && maybeThenable.constructor.resolve === resolve) {
    handleOwnThenable(promise, maybeThenable);
  } else {
    if (then$$ === GET_THEN_ERROR) {
      _reject(promise, GET_THEN_ERROR.error);
    } else if (then$$ === undefined) {
      fulfill(promise, maybeThenable);
    } else if (isFunction(then$$)) {
      handleForeignThenable(promise, maybeThenable, then$$);
    } else {
      fulfill(promise, maybeThenable);
    }
  }
}

function _resolve(promise, value) {
  if (promise === value) {
    _reject(promise, selfFulfillment());
  } else if (objectOrFunction(value)) {
    handleMaybeThenable(promise, value, getThen(value));
  } else {
    fulfill(promise, value);
  }
}

function publishRejection(promise) {
  if (promise._onerror) {
    promise._onerror(promise._result);
  }

  publish(promise);
}

function fulfill(promise, value) {
  if (promise._state !== PENDING) {
    return;
  }

  promise._result = value;
  promise._state = FULFILLED;

  if (promise._subscribers.length !== 0) {
    asap(publish, promise);
  }
}

function _reject(promise, reason) {
  if (promise._state !== PENDING) {
    return;
  }
  promise._state = REJECTED;
  promise._result = reason;

  asap(publishRejection, promise);
}

function subscribe(parent, child, onFulfillment, onRejection) {
  var _subscribers = parent._subscribers;
  var length = _subscribers.length;

  parent._onerror = null;

  _subscribers[length] = child;
  _subscribers[length + FULFILLED] = onFulfillment;
  _subscribers[length + REJECTED] = onRejection;

  if (length === 0 && parent._state) {
    asap(publish, parent);
  }
}

function publish(promise) {
  var subscribers = promise._subscribers;
  var settled = promise._state;

  if (subscribers.length === 0) {
    return;
  }

  var child = undefined,
      callback = undefined,
      detail = promise._result;

  for (var i = 0; i < subscribers.length; i += 3) {
    child = subscribers[i];
    callback = subscribers[i + settled];

    if (child) {
      invokeCallback(settled, child, callback, detail);
    } else {
      callback(detail);
    }
  }

  promise._subscribers.length = 0;
}

function ErrorObject() {
  this.error = null;
}

var TRY_CATCH_ERROR = new ErrorObject();

function tryCatch(callback, detail) {
  try {
    return callback(detail);
  } catch (e) {
    TRY_CATCH_ERROR.error = e;
    return TRY_CATCH_ERROR;
  }
}

function invokeCallback(settled, promise, callback, detail) {
  var hasCallback = isFunction(callback),
      value = undefined,
      error = undefined,
      succeeded = undefined,
      failed = undefined;

  if (hasCallback) {
    value = tryCatch(callback, detail);

    if (value === TRY_CATCH_ERROR) {
      failed = true;
      error = value.error;
      value = null;
    } else {
      succeeded = true;
    }

    if (promise === value) {
      _reject(promise, cannotReturnOwn());
      return;
    }
  } else {
    value = detail;
    succeeded = true;
  }

  if (promise._state !== PENDING) {
    // noop
  } else if (hasCallback && succeeded) {
      _resolve(promise, value);
    } else if (failed) {
      _reject(promise, error);
    } else if (settled === FULFILLED) {
      fulfill(promise, value);
    } else if (settled === REJECTED) {
      _reject(promise, value);
    }
}

function initializePromise(promise, resolver) {
  try {
    resolver(function resolvePromise(value) {
      _resolve(promise, value);
    }, function rejectPromise(reason) {
      _reject(promise, reason);
    });
  } catch (e) {
    _reject(promise, e);
  }
}

var id = 0;
function nextId() {
  return id++;
}

function makePromise(promise) {
  promise[PROMISE_ID] = id++;
  promise._state = undefined;
  promise._result = undefined;
  promise._subscribers = [];
}

function Enumerator(Constructor, input) {
  this._instanceConstructor = Constructor;
  this.promise = new Constructor(noop);

  if (!this.promise[PROMISE_ID]) {
    makePromise(this.promise);
  }

  if (isArray(input)) {
    this._input = input;
    this.length = input.length;
    this._remaining = input.length;

    this._result = new Array(this.length);

    if (this.length === 0) {
      fulfill(this.promise, this._result);
    } else {
      this.length = this.length || 0;
      this._enumerate();
      if (this._remaining === 0) {
        fulfill(this.promise, this._result);
      }
    }
  } else {
    _reject(this.promise, validationError());
  }
}

function validationError() {
  return new Error('Array Methods must be provided an Array');
};

Enumerator.prototype._enumerate = function () {
  var length = this.length;
  var _input = this._input;

  for (var i = 0; this._state === PENDING && i < length; i++) {
    this._eachEntry(_input[i], i);
  }
};

Enumerator.prototype._eachEntry = function (entry, i) {
  var c = this._instanceConstructor;
  var resolve$$ = c.resolve;

  if (resolve$$ === resolve) {
    var _then = getThen(entry);

    if (_then === then && entry._state !== PENDING) {
      this._settledAt(entry._state, i, entry._result);
    } else if (typeof _then !== 'function') {
      this._remaining--;
      this._result[i] = entry;
    } else if (c === Promise) {
      var promise = new c(noop);
      handleMaybeThenable(promise, entry, _then);
      this._willSettleAt(promise, i);
    } else {
      this._willSettleAt(new c(function (resolve$$) {
        return resolve$$(entry);
      }), i);
    }
  } else {
    this._willSettleAt(resolve$$(entry), i);
  }
};

Enumerator.prototype._settledAt = function (state, i, value) {
  var promise = this.promise;

  if (promise._state === PENDING) {
    this._remaining--;

    if (state === REJECTED) {
      _reject(promise, value);
    } else {
      this._result[i] = value;
    }
  }

  if (this._remaining === 0) {
    fulfill(promise, this._result);
  }
};

Enumerator.prototype._willSettleAt = function (promise, i) {
  var enumerator = this;

  subscribe(promise, undefined, function (value) {
    return enumerator._settledAt(FULFILLED, i, value);
  }, function (reason) {
    return enumerator._settledAt(REJECTED, i, reason);
  });
};

/**
  `Promise.all` accepts an array of promises, and returns a new promise which
  is fulfilled with an array of fulfillment values for the passed promises, or
  rejected with the reason of the first passed promise to be rejected. It casts all
  elements of the passed iterable to promises as it runs this algorithm.

  Example:

  ```javascript
  let promise1 = resolve(1);
  let promise2 = resolve(2);
  let promise3 = resolve(3);
  let promises = [ promise1, promise2, promise3 ];

  Promise.all(promises).then(function(array){
    // The array here would be [ 1, 2, 3 ];
  });
  ```

  If any of the `promises` given to `all` are rejected, the first promise
  that is rejected will be given as an argument to the returned promises's
  rejection handler. For example:

  Example:

  ```javascript
  let promise1 = resolve(1);
  let promise2 = reject(new Error("2"));
  let promise3 = reject(new Error("3"));
  let promises = [ promise1, promise2, promise3 ];

  Promise.all(promises).then(function(array){
    // Code here never runs because there are rejected promises!
  }, function(error) {
    // error.message === "2"
  });
  ```

  @method all
  @static
  @param {Array} entries array of promises
  @param {String} label optional string for labeling the promise.
  Useful for tooling.
  @return {Promise} promise that is fulfilled when all `promises` have been
  fulfilled, or rejected if any of them become rejected.
  @static
*/
function all(entries) {
  return new Enumerator(this, entries).promise;
}

/**
  `Promise.race` returns a new promise which is settled in the same way as the
  first passed promise to settle.

  Example:

  ```javascript
  let promise1 = new Promise(function(resolve, reject){
    setTimeout(function(){
      resolve('promise 1');
    }, 200);
  });

  let promise2 = new Promise(function(resolve, reject){
    setTimeout(function(){
      resolve('promise 2');
    }, 100);
  });

  Promise.race([promise1, promise2]).then(function(result){
    // result === 'promise 2' because it was resolved before promise1
    // was resolved.
  });
  ```

  `Promise.race` is deterministic in that only the state of the first
  settled promise matters. For example, even if other promises given to the
  `promises` array argument are resolved, but the first settled promise has
  become rejected before the other promises became fulfilled, the returned
  promise will become rejected:

  ```javascript
  let promise1 = new Promise(function(resolve, reject){
    setTimeout(function(){
      resolve('promise 1');
    }, 200);
  });

  let promise2 = new Promise(function(resolve, reject){
    setTimeout(function(){
      reject(new Error('promise 2'));
    }, 100);
  });

  Promise.race([promise1, promise2]).then(function(result){
    // Code here never runs
  }, function(reason){
    // reason.message === 'promise 2' because promise 2 became rejected before
    // promise 1 became fulfilled
  });
  ```

  An example real-world use case is implementing timeouts:

  ```javascript
  Promise.race([ajax('foo.json'), timeout(5000)])
  ```

  @method race
  @static
  @param {Array} promises array of promises to observe
  Useful for tooling.
  @return {Promise} a promise which settles in the same way as the first passed
  promise to settle.
*/
function race(entries) {
  /*jshint validthis:true */
  var Constructor = this;

  if (!isArray(entries)) {
    return new Constructor(function (_, reject) {
      return reject(new TypeError('You must pass an array to race.'));
    });
  } else {
    return new Constructor(function (resolve, reject) {
      var length = entries.length;
      for (var i = 0; i < length; i++) {
        Constructor.resolve(entries[i]).then(resolve, reject);
      }
    });
  }
}

/**
  `Promise.reject` returns a promise rejected with the passed `reason`.
  It is shorthand for the following:

  ```javascript
  let promise = new Promise(function(resolve, reject){
    reject(new Error('WHOOPS'));
  });

  promise.then(function(value){
    // Code here doesn't run because the promise is rejected!
  }, function(reason){
    // reason.message === 'WHOOPS'
  });
  ```

  Instead of writing the above, your code now simply becomes the following:

  ```javascript
  let promise = Promise.reject(new Error('WHOOPS'));

  promise.then(function(value){
    // Code here doesn't run because the promise is rejected!
  }, function(reason){
    // reason.message === 'WHOOPS'
  });
  ```

  @method reject
  @static
  @param {Any} reason value that the returned promise will be rejected with.
  Useful for tooling.
  @return {Promise} a promise rejected with the given `reason`.
*/
function reject(reason) {
  /*jshint validthis:true */
  var Constructor = this;
  var promise = new Constructor(noop);
  _reject(promise, reason);
  return promise;
}

function needsResolver() {
  throw new TypeError('You must pass a resolver function as the first argument to the promise constructor');
}

function needsNew() {
  throw new TypeError("Failed to construct 'Promise': Please use the 'new' operator, this object constructor cannot be called as a function.");
}

/**
  Promise objects represent the eventual result of an asynchronous operation. The
  primary way of interacting with a promise is through its `then` method, which
  registers callbacks to receive either a promise's eventual value or the reason
  why the promise cannot be fulfilled.

  Terminology
  -----------

  - `promise` is an object or function with a `then` method whose behavior conforms to this specification.
  - `thenable` is an object or function that defines a `then` method.
  - `value` is any legal JavaScript value (including undefined, a thenable, or a promise).
  - `exception` is a value that is thrown using the throw statement.
  - `reason` is a value that indicates why a promise was rejected.
  - `settled` the final resting state of a promise, fulfilled or rejected.

  A promise can be in one of three states: pending, fulfilled, or rejected.

  Promises that are fulfilled have a fulfillment value and are in the fulfilled
  state.  Promises that are rejected have a rejection reason and are in the
  rejected state.  A fulfillment value is never a thenable.

  Promises can also be said to *resolve* a value.  If this value is also a
  promise, then the original promise's settled state will match the value's
  settled state.  So a promise that *resolves* a promise that rejects will
  itself reject, and a promise that *resolves* a promise that fulfills will
  itself fulfill.


  Basic Usage:
  ------------

  ```js
  let promise = new Promise(function(resolve, reject) {
    // on success
    resolve(value);

    // on failure
    reject(reason);
  });

  promise.then(function(value) {
    // on fulfillment
  }, function(reason) {
    // on rejection
  });
  ```

  Advanced Usage:
  ---------------

  Promises shine when abstracting away asynchronous interactions such as
  `XMLHttpRequest`s.

  ```js
  function getJSON(url) {
    return new Promise(function(resolve, reject){
      let xhr = new XMLHttpRequest();

      xhr.open('GET', url);
      xhr.onreadystatechange = handler;
      xhr.responseType = 'json';
      xhr.setRequestHeader('Accept', 'application/json');
      xhr.send();

      function handler() {
        if (this.readyState === this.DONE) {
          if (this.status === 200) {
            resolve(this.response);
          } else {
            reject(new Error('getJSON: `' + url + '` failed with status: [' + this.status + ']'));
          }
        }
      };
    });
  }

  getJSON('/posts.json').then(function(json) {
    // on fulfillment
  }, function(reason) {
    // on rejection
  });
  ```

  Unlike callbacks, promises are great composable primitives.

  ```js
  Promise.all([
    getJSON('/posts'),
    getJSON('/comments')
  ]).then(function(values){
    values[0] // => postsJSON
    values[1] // => commentsJSON

    return values;
  });
  ```

  @class Promise
  @param {function} resolver
  Useful for tooling.
  @constructor
*/
function Promise(resolver) {
  this[PROMISE_ID] = nextId();
  this._result = this._state = undefined;
  this._subscribers = [];

  if (noop !== resolver) {
    typeof resolver !== 'function' && needsResolver();
    this instanceof Promise ? initializePromise(this, resolver) : needsNew();
  }
}

Promise.all = all;
Promise.race = race;
Promise.resolve = resolve;
Promise.reject = reject;
Promise._setScheduler = setScheduler;
Promise._setAsap = setAsap;
Promise._asap = asap;

Promise.prototype = {
  constructor: Promise,

  /**
    The primary way of interacting with a promise is through its `then` method,
    which registers callbacks to receive either a promise's eventual value or the
    reason why the promise cannot be fulfilled.
  
    ```js
    findUser().then(function(user){
      // user is available
    }, function(reason){
      // user is unavailable, and you are given the reason why
    });
    ```
  
    Chaining
    --------
  
    The return value of `then` is itself a promise.  This second, 'downstream'
    promise is resolved with the return value of the first promise's fulfillment
    or rejection handler, or rejected if the handler throws an exception.
  
    ```js
    findUser().then(function (user) {
      return user.name;
    }, function (reason) {
      return 'default name';
    }).then(function (userName) {
      // If `findUser` fulfilled, `userName` will be the user's name, otherwise it
      // will be `'default name'`
    });
  
    findUser().then(function (user) {
      throw new Error('Found user, but still unhappy');
    }, function (reason) {
      throw new Error('`findUser` rejected and we're unhappy');
    }).then(function (value) {
      // never reached
    }, function (reason) {
      // if `findUser` fulfilled, `reason` will be 'Found user, but still unhappy'.
      // If `findUser` rejected, `reason` will be '`findUser` rejected and we're unhappy'.
    });
    ```
    If the downstream promise does not specify a rejection handler, rejection reasons will be propagated further downstream.
  
    ```js
    findUser().then(function (user) {
      throw new PedagogicalException('Upstream error');
    }).then(function (value) {
      // never reached
    }).then(function (value) {
      // never reached
    }, function (reason) {
      // The `PedgagocialException` is propagated all the way down to here
    });
    ```
  
    Assimilation
    ------------
  
    Sometimes the value you want to propagate to a downstream promise can only be
    retrieved asynchronously. This can be achieved by returning a promise in the
    fulfillment or rejection handler. The downstream promise will then be pending
    until the returned promise is settled. This is called *assimilation*.
  
    ```js
    findUser().then(function (user) {
      return findCommentsByAuthor(user);
    }).then(function (comments) {
      // The user's comments are now available
    });
    ```
  
    If the assimliated promise rejects, then the downstream promise will also reject.
  
    ```js
    findUser().then(function (user) {
      return findCommentsByAuthor(user);
    }).then(function (comments) {
      // If `findCommentsByAuthor` fulfills, we'll have the value here
    }, function (reason) {
      // If `findCommentsByAuthor` rejects, we'll have the reason here
    });
    ```
  
    Simple Example
    --------------
  
    Synchronous Example
  
    ```javascript
    let result;
  
    try {
      result = findResult();
      // success
    } catch(reason) {
      // failure
    }
    ```
  
    Errback Example
  
    ```js
    findResult(function(result, err){
      if (err) {
        // failure
      } else {
        // success
      }
    });
    ```
  
    Promise Example;
  
    ```javascript
    findResult().then(function(result){
      // success
    }, function(reason){
      // failure
    });
    ```
  
    Advanced Example
    --------------
  
    Synchronous Example
  
    ```javascript
    let author, books;
  
    try {
      author = findAuthor();
      books  = findBooksByAuthor(author);
      // success
    } catch(reason) {
      // failure
    }
    ```
  
    Errback Example
  
    ```js
  
    function foundBooks(books) {
  
    }
  
    function failure(reason) {
  
    }
  
    findAuthor(function(author, err){
      if (err) {
        failure(err);
        // failure
      } else {
        try {
          findBoooksByAuthor(author, function(books, err) {
            if (err) {
              failure(err);
            } else {
              try {
                foundBooks(books);
              } catch(reason) {
                failure(reason);
              }
            }
          });
        } catch(error) {
          failure(err);
        }
        // success
      }
    });
    ```
  
    Promise Example;
  
    ```javascript
    findAuthor().
      then(findBooksByAuthor).
      then(function(books){
        // found books
    }).catch(function(reason){
      // something went wrong
    });
    ```
  
    @method then
    @param {Function} onFulfilled
    @param {Function} onRejected
    Useful for tooling.
    @return {Promise}
  */
  then: then,

  /**
    `catch` is simply sugar for `then(undefined, onRejection)` which makes it the same
    as the catch block of a try/catch statement.
  
    ```js
    function findAuthor(){
      throw new Error('couldn't find that author');
    }
  
    // synchronous
    try {
      findAuthor();
    } catch(reason) {
      // something went wrong
    }
  
    // async with promises
    findAuthor().catch(function(reason){
      // something went wrong
    });
    ```
  
    @method catch
    @param {Function} onRejection
    Useful for tooling.
    @return {Promise}
  */
  'catch': function _catch(onRejection) {
    return this.then(null, onRejection);
  }
};

function polyfill() {
    var local = undefined;

    if (typeof global !== 'undefined') {
        local = global;
    } else if (typeof self !== 'undefined') {
        local = self;
    } else {
        try {
            local = Function('return this')();
        } catch (e) {
            throw new Error('polyfill failed because global object is unavailable in this environment');
        }
    }

    var P = local.Promise;

    if (P) {
        var promiseToString = null;
        try {
            promiseToString = Object.prototype.toString.call(P.resolve());
        } catch (e) {
            // silently ignored
        }

        if (promiseToString === '[object Promise]' && !P.cast) {
            return;
        }
    }

    local.Promise = Promise;
}

polyfill();
// Strange compat..
Promise.polyfill = polyfill;
Promise.Promise = Promise;

return Promise;

})));

}).call(this,require('_process'),typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})

},{"_process":27}],23:[function(require,module,exports){
(function (global){
/*! Lity - v1.6.6 - 2016-04-22
* http://sorgalla.com/lity/
* Copyright (c) 2016 Jan Sorgalla; Licensed MIT */
(function(window, factory) {
    if (typeof define === 'function' && define.amd) {
        define(['jquery'], function($) {
            return factory(window, $);
        });
    } else if (typeof module === 'object' && typeof module.exports === 'object') {
        module.exports = factory(window, (typeof window !== "undefined" ? window['jQuery'] : typeof global !== "undefined" ? global['jQuery'] : null));
    } else {
        window.lity = factory(window, window.jQuery || window.Zepto);
    }
}(typeof window !== "undefined" ? window : this, function(window, $) {
    'use strict';

    var document = window.document;

    var _win = $(window);
    var _html = $('html');
    var _instanceCount = 0;

    var _imageRegexp = /(^data:image\/)|(\.(png|jpe?g|gif|svg|webp|bmp|ico|tiff?)(\?\S*)?$)/i;
    var _youtubeRegex = /(youtube(-nocookie)?\.com|youtu\.be)\/(watch\?v=|v\/|u\/|embed\/?)?([\w-]{11})(.*)?/i;
    var _vimeoRegex =  /(vimeo(pro)?.com)\/(?:[^\d]+)?(\d+)\??(.*)?$/;
    var _googlemapsRegex = /((maps|www)\.)?google\.([^\/\?]+)\/?((maps\/?)?\?)(.*)/i;

    var _defaultHandlers = {
        image: imageHandler,
        inline: inlineHandler,
        iframe: iframeHandler
    };

    var _defaultOptions = {
        esc: true,
        handler: null,
        template: '<div class="lity" tabindex="-1"><div class="lity-wrap" data-lity-close><div class="lity-loader">Loading...</div><div class="lity-container"><div class="lity-content"></div><button class="lity-close" type="button" title="Close (Esc)" data-lity-close>×</button></div></div></div>'
    };

    function globalToggle() {
        _html[_instanceCount > 0 ? 'addClass' : 'removeClass']('lity-active');
    }

    var transitionEndEvent = (function() {
        var el = document.createElement('div');

        var transEndEventNames = {
            WebkitTransition: 'webkitTransitionEnd',
            MozTransition: 'transitionend',
            OTransition: 'oTransitionEnd otransitionend',
            transition: 'transitionend'
        };

        for (var name in transEndEventNames) {
            if (el.style[name] !== undefined) {
                return transEndEventNames[name];
            }
        }

        return false;
    })();

    function transitionEnd(element) {
        var deferred = $.Deferred();

        if (!transitionEndEvent) {
            deferred.resolve();
        } else {
            element.one(transitionEndEvent, deferred.resolve);
            setTimeout(deferred.resolve, 500);
        }

        return deferred.promise();
    }

    function settings(currSettings, key, value) {
        if (arguments.length === 1) {
            return $.extend({}, currSettings);
        }

        if (typeof key === 'string') {
            if (typeof value === 'undefined') {
                return typeof currSettings[key] === 'undefined' ?
                    null :
                    currSettings[key];
            }
            currSettings[key] = value;
        } else {
            $.extend(currSettings, key);
        }

        return this;
    }

    function parseQueryParams(params){
        var pairs = decodeURI(params).split('&');
        var obj = {}, p;

        for (var i = 0, n = pairs.length; i < n; i++) {
            if (!pairs[i]) {
                continue;
            }

            p = pairs[i].split('=');
            obj[p[0]] = p[1];
        }

        return obj;
    }

    function appendQueryParams(url, params) {
        return url + (url.indexOf('?') > -1 ? '&' : '?') + $.param(params);
    }

    function error(msg) {
        return $('<span class="lity-error"/>').append(msg);
    }

    function imageHandler(target) {
        if (!_imageRegexp.test(target)) {
            return false;
        }

        var img = $('<img src="' + target + '">');
        var deferred = $.Deferred();
        var failed = function() {
            deferred.reject(error('Failed loading image'));
        };

        img
            .on('load', function() {
                if (this.naturalWidth === 0) {
                    return failed();
                }

                deferred.resolve(img);
            })
            .on('error', failed)
        ;

        return deferred.promise();
    }

    function inlineHandler(target) {
        var el;

        try {
            el = $(target);
        } catch (e) {
            return false;
        }

        if (!el.length) {
            return false;
        }

        var placeholder = $('<span style="display:none !important" class="lity-inline-placeholder"/>');

        return el
            .after(placeholder)
            .on('lity:ready', function(e, instance) {
                instance.one('lity:remove', function() {
                    placeholder
                        .before(el.addClass('lity-hide'))
                        .remove()
                    ;
                });
            })
        ;
    }

    function iframeHandler(target) {
        var matches, url = target;

        matches = _youtubeRegex.exec(target);

        if (matches) {
            url = appendQueryParams(
                'https://www.youtube' + (matches[2] || '') + '.com/embed/' + matches[4],
                $.extend(
                    {
                        autoplay: 1
                    },
                    parseQueryParams(matches[5] || '')
                )
            );
        }

        matches = _vimeoRegex.exec(target);

        if (matches) {
            url = appendQueryParams(
                'https://player.vimeo.com/video/' + matches[3],
                $.extend(
                    {
                        autoplay: 1
                    },
                    parseQueryParams(matches[4] || '')
                )
            );
        }

        matches = _googlemapsRegex.exec(target);

        if (matches) {
            url = appendQueryParams(
                'https://www.google.' + matches[3] + '/maps?' + matches[6],
                {
                    output: matches[6].indexOf('layer=c') > 0 ? 'svembed' : 'embed'
                }
            );
        }

        return '<div class="lity-iframe-container"><iframe frameborder="0" allowfullscreen src="' + url + '"></iframe></div>';
    }

    function lity(options) {
        var _options = {},
            _handlers = {},
            _instance,
            _content,
            _ready = $.Deferred().resolve();

        function keyup(e) {
            if (e.keyCode === 27) {
                close();
            }
        }

        function resize() {
            var height = document.documentElement.clientHeight ? document.documentElement.clientHeight : Math.round(_win.height());

            _content
                .css('max-height', Math.floor(height) + 'px')
                .trigger('lity:resize', [_instance])
            ;
        }

        function ready(el, content) {
            if (!_instance) {
                return;
            }

            _content = $(content);

            _win.on('resize', resize);
            resize();

            _instance
                .find('.lity-loader')
                .each(function() {
                    var el = $(this);
                    transitionEnd(el).always(function() {
                        el.remove();
                    });
                })
            ;

            _instance
                .removeClass('lity-loading')
                .find('.lity-content')
                .empty()
                .append(_content)
            ;

            _content
                .removeClass('lity-hide')
                .trigger('lity:ready', [_instance, el])
            ;

            _ready.resolve();
        }

        function init(handler, content, options, el) {
            _ready = $.Deferred();

            _instanceCount++;
            globalToggle();

            _instance = $(options.template)
                .addClass('lity-loading')
                .appendTo('body');

            if (!!options.esc) {
                _win.on('keyup', keyup);
            }

            setTimeout(function() {
                _instance
                    .addClass('lity-opened lity-' + handler)
                    .on('click', '[data-lity-close]', function(e) {
                        if ($(e.target).is('[data-lity-close]')) {
                            close();
                        }
                    })
                    .trigger('lity:open', [_instance, el])
                ;

                $.when(content).always($.proxy(ready, null, el));
            }, 0);
        }

        function open(target, options, el) {
            var handler, content, handlers = $.extend({}, _defaultHandlers, _handlers);

            options = $.extend(
                {},
                _defaultOptions,
                _options,
                options
            );

            if (options.handler && handlers[options.handler]) {
                content = handlers[options.handler](target, popup);
                handler = options.handler;
            } else {
                var lateHandlers = {};

                // Run inline and iframe handlers after all other handlers
                $.each(['inline', 'iframe'], function(i, name) {
                    if (handlers[name]) {
                        lateHandlers[name] = handlers[name];
                    }

                    delete handlers[name];
                });

                var call = function(name, callback) {
                    // Handler might be "removed" by setting callback to null
                    if (!callback) {
                        return true;
                    }

                    content = callback(target, popup);

                    if (!!content) {
                        handler = name;
                        return false;
                    }
                };

                $.each(handlers, call);

                if (!handler) {
                    $.each(lateHandlers, call);
                }
            }

            if (content) {
                $.when(close()).done($.proxy(init, null, handler, content, options, el));
            }

            return !!content;
        }

        function close() {
            if (!_instance) {
                return;
            }

            var deferred = $.Deferred();

            _ready.done(function() {
                _instanceCount--;
                globalToggle();

                _win
                    .off('resize', resize)
                    .off('keyup', keyup)
                ;

                _content.trigger('lity:close', [_instance]);

                _instance
                    .removeClass('lity-opened')
                    .addClass('lity-closed')
                ;

                var instance = _instance, content = _content;
                _instance = null;
                _content = null;

                transitionEnd(content.add(instance)).always(function() {
                    content.trigger('lity:remove', [instance]);
                    instance.remove();
                    deferred.resolve();
                });
            });

            return deferred.promise();
        }

        function popup(event) {
            // If not an event, act as alias of popup.open
            if (!event.preventDefault) {
                return popup.open(event);
            }

            var el = $(this);
            var target = el.data('lity-target') || el.attr('href') || el.attr('src');

            if (!target) {
                return;
            }

            var options = el.data('lity-options') || el.data('lity');

            if (open(target, options, el)) {
                el.blur();
                event.preventDefault();
            }
        }

        popup.handlers = $.proxy(settings, popup, _handlers);
        popup.options = $.proxy(settings, popup, _options);

        popup.open = function(target, options, el) {
            open(target, options, el);
            return popup;
        };

        popup.close = function() {
            close();
            return popup;
        };

        return popup.options(options);
    }

    lity.version = '1.6.6';
    lity.handlers = $.proxy(settings, lity, _defaultHandlers);
    lity.options = $.proxy(settings, lity, _defaultOptions);

    $(document).on('click', '[data-lity]', lity());

    return lity;
}));

}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})

},{}],24:[function(require,module,exports){
(function (global){
( function( root, factory ) {
	// UMD wrapper
	if ( typeof define === 'function' && define.amd ) {
		// AMD
		define( [ 'underscore', 'backbone', 'backbone.View', 'backbone-view-options', 'backbone-courier', 'backbone-handle', 'backbone-subviews' ], factory );
	} else if ( typeof exports !== 'undefined' ) {
		// Node/CommonJS
		module.exports = factory( (typeof window !== "undefined" ? window['_'] : typeof global !== "undefined" ? global['_'] : null), (typeof window !== "undefined" ? window['Backbone'] : typeof global !== "undefined" ? global['Backbone'] : null), (typeof window !== "undefined" ? window['Backbone'] : typeof global !== "undefined" ? global['Backbone'] : null).View, require( 'backbone-view-options' ), require( 'backbone-courier' ), require( 'backbone-handle' ), require( 'backbone-subviews' ) );
	} else {
		// Browser globals
		factory( root._, root.Backbone, root.Backbone.View, root.Backbone.ViewOptions, root.Backbone.Courier, root.Backbone.Handle, root.Backbone.Subviews );
	}
}( this, function( _, Backbone, Super, viewOptions, courier, handle, subviews ) {

Backbone.ModuiBase = Super.extend( {
	className : 'view',
	
	options : [],

	constructor : function( options ) {
		//handle.add( Super.prototype ); // needs to be added to view prototype, so that logic executes before render() in derived classes
		handle.add( this ); // needs to be added to view prototype, so that logic executes before render() in derived classes

		viewOptions.add( this );
		this.setOptions( options );
		
		// needs to be done before super is called, since super calls view#initialize,
		// and view#initialize might spawn events
		courier.add( this );

		// must be done before super is called, since if this.render is referenced
		// in view#initialize (for example, if we bind an event to this.render),
		// we want it to reference the wrapped version (post subview) of render.
		subviews.add( this );

		var returnValue = Super.prototype.constructor.apply( this, arguments );

		return returnValue;
	},

	render : function() {
		if( this.template ) {
			var templateData = this.getOptions();
			if( this.model ) _.extend( templateData , this.model.attributes );
			_.extend( templateData , this._getTemplateData() );

			this.$el.html( this._renderTemplate( templateData ) );
		}
		
		this.resolveHandles();
		
		return this;
	},

	_getTemplateData : function() {
		// this function may be overridden to add additional properties
		// to the object passed to the template's rendering function
		return {};
	},

	_renderTemplate : function( templateData ) {
		var html;
		
		if( _.isFunction( this.template ) )
			html = this.template( templateData );
		else if( this.template.render )
			html = this.template.render( templateData );

		return html;
	},

	_onSubviewsRendered : function() {
		// override in derived classes
	}
} );

return Backbone.ModuiBase;

} ) );

}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})

},{"backbone-courier":1,"backbone-handle":2,"backbone-subviews":3,"backbone-view-options":4}],25:[function(require,module,exports){
(function (global){
( function( root, factory ) {
	// UMD wrapper
	if ( typeof define === 'function' && define.amd ) {
		// AMD
		define( [ 'underscore', 'backbone', 'jquery', 'modui-base' ], factory );
	} else if ( typeof exports !== 'undefined' ) {
		// Node/CommonJS
		module.exports = factory( (typeof window !== "undefined" ? window['_'] : typeof global !== "undefined" ? global['_'] : null), (typeof window !== "undefined" ? window['Backbone'] : typeof global !== "undefined" ? global['Backbone'] : null), (typeof window !== "undefined" ? window['jQuery'] : typeof global !== "undefined" ? global['jQuery'] : null), require( 'modui-base' ) );
	} else {
		// Browser globals
		factory( root._, root.Backbone, ( root.jQuery || root.Zepto || root.$ ), root.Backbone.ModuiBase );
	}
}( this, function( _, Backbone, $, Super ) {

var lastPossibleViewElement = $( 'body' )[ 0 ];
var mOpenPopups = [];

var kState_Closed = 'closed';
var kState_Open = 'open';
var kState_Closing = 'closing';

var kFadeTime = 100;
var kMinTimeAfterOpenBeforeCloseOnOutsideClick = 100;

var kPositions = [
	'bottom center',
	'top center',
	'right center',
	'left center',
	'bottom center right',
	'bottom center left',
	'top center right',
	'top center left',
	'bottom left',
	'bottom right',
	'top left',
	'top right',
	'right top',
	'right bottom',
	'left top',
	'left bottom'
];

var kPositionClasses = _.map( kPositions, function( thisPosition ) {
	return thisPosition.replace( /\ /g, '-' );
} );

var mWindowEventListenersAttached = false;

Backbone.ModuiPopup = Super.extend( {
	options : [
		'target!',
		'contents',
		{ position : 'bottom center' },
		{ strictPositioning : false },
		{ hideIfAllPositionsAreOutOfBounds : false },
		{ distanceAway : 12 }, // margin / pointer is 10 pixels. With this default the tip of the pointer ends up 2 pixels from target
		{ pointerOffset : 0 },
		{ keepWithinRect : function() { return {
			top : $( window ).scrollTop(),
			bottom : $( window ).scrollTop() + $( window ).height(),
			left   : 0,
			right  : $( window ).width()
		}; } },
		{ closeOnOutsideClick : true },
		'onClose',
		'signature',
		'zIndex',
		{ 'extraClassName' : '' }, // appended to regular class names to facilitate styling
		{ 'kPointerHeight' : 10 }
	],

	passMessages : { '*' : '.' }, // pass all courier messages directly through to parent view. why??

	className : 'modui-popup',

	initialize : function() {
		var _this = this;

		this._setupTargetEl();

		this._setState( kState_Closed );

		// if( this.closeOnOutsideClick ) {
		// 	setTimeout( function() {
		// 		// in case this popup is triggered by a click, we need to wait
		// 		// until the next event loop before we bind the outside click
		// 		// event to closing the popup. otherwise would close right away
		// 		_this.$el.bind( 'clickoutside', function( e ) {
		// 			// we do not close the popup if the clicked element is within the original
		// 			// target element that this popup is pointing at (or IS that element)
		// 			if( e.target !== _this.targetEl.get( 0 ) && ! $.contains( _this.targetEl.get( 0 ), e.target ) ) {
		// 				_this.close();
		// 			}
		// 		} );
		// 	} );
		// }

		if( ! mWindowEventListenersAttached ) {
			_attachWindowEventListeners();
			mWindowEventListenersAttached = true;
		}
	},

	render : function() {
		if( _.isString( this.contents ) ) {
			this.$el.html( '<div class="html-contents">' + this.contents + '</div>' );
		} else if( _.isObject( this.contents ) && _.isFunction( this.contents.render ) ) {
			this.$el.html( '' );
			this.$el.append( this.contents.$el );
			this.contents.render();
			this.contents.delegateEvents();
		} else {
			// if we don't have any contents specified, assume that this is
			// a derived class that defines its own contents with its own render.
			Super.prototype.render.apply( this, arguments );
		}

		if( ! _.isUndefined( this.zIndex ) ) this.$el.css( 'z-index', this.zIndex );
		else {
			// if no explicit z-index is supplied, make sure we are in front of
			// our target (being mindful over browser support).

			var popupZIndex = _getElementZIndex( this.$el );
			var targetElZIndex = _getElementZIndex( this.targetEl );
			if( _.isNaN( popupZIndex ) || popupZIndex <= targetElZIndex ) {
				this.$el.css( 'z-index', targetElZIndex + 1 );
			}
		}
	},

	close : function() {
		var _this = this;

		if( this.state !== kState_Open ) return;

		this.$el.unbind( 'clickoutside' );
		this._setState( kState_Closing );

		this.spawn( 'closing' );

		setTimeout( function() {
			if( _this.state === kState_Closing ) {
				_this.remove();
				mOpenPopups = _.without( mOpenPopups, _this );
				_this.spawn( 'closed' );
			}
		}, kFadeTime );

		if( _.isFunction( this.onClose ) ) this.onClose.apply( this, arguments );
	},
 
	reposition : function( allowedPositions, options ) {
		var _this = this;

		options = _.extend( {}, {
			tryAgainIfDimentionsChange : true,
			hideIfAllPositionsAreOutOfBounds : this.hideIfAllPositionsAreOutOfBounds
		}, options );

		var targetIsVisible = this.targetEl.is( ':visible' );
		this.$el.toggle( targetIsVisible );
		if( ! targetIsVisible ) return false;

		if( _.isUndefined( allowedPositions ) ) {
			allowedPositions = [];

			if( _.isArray( this.position ) ) allowedPositions = allowedPositions.concat( this.position )
			else allowedPositions.push( this.position );

			if( this.currentPosition && this.state === 'open' ) {
				// give preference to current position, if we already have one!

				if( _.contains( allowedPositions, this.currentPosition ) || ! this.strictPositioning ) {
					allowedPositions.unshift( this.currentPosition );
				}
			}

			if( ! this.strictPositioning ) allowedPositions = _.union( allowedPositions, kPositions );
		}

		allowedPositions = _.unique( allowedPositions );

		var targetIsFixed = _elementPositionIsFixed( this.targetEl );

		var targetWidth = Math.round( this.targetEl.outerWidth() );
		var targetHeight = Math.round( this.targetEl.outerHeight() );

		var popupWidth  = Math.round( this.$el.outerWidth() );
		var popupHeight = Math.round( this.$el.outerHeight() );
		var popupMargin = Math.round( ( this.$el.outerWidth( true ) - this.$el.outerWidth() ) / 2 ); // later we assume vertical is the same as this horizontal margin

		var kPointerHeight = this.kPointerHeight;
		var pointerInsetForSidePositions = Math.round( kPointerHeight + kPointerHeight * .66 );

		var offsetParent = $( window );
		var parentWidth = Math.round( offsetParent.outerWidth() );
		var parentHeight = Math.round( offsetParent.outerHeight() );

		var distanceAway = this.distanceAway;

		var targetOffset = this.targetEl.offset();
		var pointerOffset = this.pointerOffset;

		var cssPositionProps;

		var firstPositionTried;
		var currentPositionBeingTried = firstPositionTried = _.first( allowedPositions );
		var haveTriedOtherPositions = false;
		var degreeOfUndesirabilityByPosition = {};
		var allPositionsAreOutOfBounds = false;
		var done = false;

		do {  // run through all our different positions to find one that works
			if( ! _.contains( kPositions, currentPositionBeingTried ) ) {
				throw new Error( 'Invalid position for popup: ' + currentPositionBeingTried );
			}

			switch( currentPositionBeingTried ) {
				case 'bottom center':
					cssPositionProps = {
						top	: targetOffset.top + targetHeight + distanceAway - popupMargin,
						left : Math.round( targetOffset.left + ( targetWidth / 2 ) - ( popupWidth / 2 ) + pointerOffset ) - popupMargin,
						bottom : 'auto',
						right : 'auto'
					};
					break;
				case 'top center':
					cssPositionProps = {
						bottom : 'auto',
						left : Math.round( targetOffset.left + ( targetWidth / 2 ) - ( popupWidth / 2 ) + pointerOffset ) - popupMargin,
						top : targetOffset.top - popupHeight - kPointerHeight - distanceAway,
						right : 'auto'
					};
					break;
				case 'right top':
					cssPositionProps = {
						top	: Math.round( targetOffset.top + pointerOffset ) - popupMargin,
						left : targetOffset.left + targetWidth + distanceAway - popupMargin,
						bottom : 'auto',
						right : 'auto'
					};
					break;
				case 'right bottom':
					cssPositionProps = {
						top	: Math.round( targetOffset.top + targetHeight + pointerOffset ) - popupMargin,
						left : targetOffset.left + targetWidth + distanceAway - popupMargin,
						bottom : 'auto',
						right : 'auto'
					};
					break;
				case 'right center':
					cssPositionProps = {
						top	: Math.round( targetOffset.top + ( targetHeight / 2 ) - ( popupHeight / 2 ) + pointerOffset ) - popupMargin,
						left : targetOffset.left + targetWidth + distanceAway - popupMargin,
						bottom : 'auto',
						right : 'auto'
					};
					break;
				case 'left top':
					cssPositionProps = {
						top	: Math.round( targetOffset.top + pointerOffset ) - popupMargin,
						right : parentWidth - targetOffset.left + distanceAway - popupMargin,
						left : 'auto',
						bottom : 'auto'
					};
					break;
				case 'left bottom':
					cssPositionProps = {
						top	: Math.round( targetOffset.top + targetHeight + pointerOffset ) - popupMargin,
						right : parentWidth - targetOffset.left + distanceAway - popupMargin,
						left : 'auto',
						bottom : 'auto'
					};
					break;
				case 'left center':
					cssPositionProps = {
						top	: Math.round( targetOffset.top + ( targetHeight / 2 ) - ( popupHeight / 2 ) + pointerOffset ) - popupMargin,
						right : parentWidth - targetOffset.left + distanceAway - popupMargin,
						left : 'auto',
						bottom : 'auto'
					};
					break;
				case 'bottom center right':
					cssPositionProps = {
						top	: targetOffset.top + targetHeight + distanceAway - popupMargin,
						left : Math.round( targetOffset.left + targetWidth / 2 ) - popupMargin - pointerInsetForSidePositions + pointerOffset,
						right : 'auto',
						bottom : 'auto'
					};
					break;
				case 'bottom center left':
					cssPositionProps = {
						top	: targetOffset.top + targetHeight + distanceAway - popupMargin,
						left : 'auto',
						right : parentWidth - Math.round( targetOffset.left + targetWidth / 2 ) - popupMargin - pointerInsetForSidePositions + pointerOffset,
						bottom : 'auto'
					};
					break;
				case 'top center right':
					cssPositionProps = {
						top : targetOffset.top - popupHeight - kPointerHeight - distanceAway,
						left : Math.round( targetOffset.left + targetWidth / 2 ) - popupMargin - pointerInsetForSidePositions + pointerOffset,
						right : 'auto',
						bottom : 'auto'
					};
					break;
				case 'top center left':
					cssPositionProps = {
						top : targetOffset.top - popupHeight - kPointerHeight - distanceAway,
						left : 'auto',
						right : parentWidth - Math.round( targetOffset.left + targetWidth / 2 ) - popupMargin - pointerInsetForSidePositions + pointerOffset,
						bottom : 'auto'
					};
					break;
				case 'bottom right':
					cssPositionProps = {
						top	: targetOffset.top + targetHeight + distanceAway - popupMargin,
						right : parentWidth - ( targetOffset.left + targetWidth ) + pointerOffset - popupMargin,
						bottom : 'auto',
						left : 'auto'
					};
					break;
				case 'bottom left':
					cssPositionProps = {
						top	: targetOffset.top + targetHeight + distanceAway - popupMargin,
						left : targetOffset.left + pointerOffset - popupMargin,
						right : 'auto',
						bottom : 'auto'
					};
					break;
				case 'top right':
					cssPositionProps = {
						top : targetOffset.top - popupHeight - kPointerHeight - distanceAway,
						bottom : 'auto',
						right : parentWidth - ( targetOffset.left + targetWidth ) + pointerOffset - popupMargin,
						left : 'auto'
					};
					break;
				case 'top left':
					cssPositionProps = {
						bottom : 'auto',
						left : targetOffset.left + pointerOffset - popupMargin,
						top : targetOffset.top - popupHeight - kPointerHeight - distanceAway,
						right : 'auto'
					};
					break;
			}

			if( targetIsFixed ) {
				cssPositionProps.position = 'fixed';
				cssPositionProps.top -= $( window ).scrollTop();
			}

			this.$el
				.css( cssPositionProps )
				.removeClass( 'top left bottom right' )
				.removeClass( kPositionClasses.join( ' ' ) )
				.addClass( currentPositionBeingTried.split( ' ' )[ 0 ] )
				.addClass( currentPositionBeingTried.replace( /\ /g, '-' ) )
			;

			degreeOfUndesirabilityByPosition[ currentPositionBeingTried ] = this._getDegreeOfUndesirabilityOfCurrentPosition();
			var cantFitIntoKeepWithinRectInThisPosition = degreeOfUndesirabilityByPosition[ currentPositionBeingTried ] !== 0;

			if( cantFitIntoKeepWithinRectInThisPosition ) {
				if( currentPositionBeingTried === firstPositionTried && haveTriedOtherPositions ) {
					// if we have tried all the different positions and are now are back at our
					// original 'preferred' position, then, shit, all positions were out of bounds.\
					// just leave the popup in its default position, eventhough it is also out of bounds.

					allPositionsAreOutOfBounds = true;
					done = true;
				} else {
					// Popup is outside bounding rect. try a new position.
					haveTriedOtherPositions = true;
					currentPositionBeingTried = _getNextPositionToTry( currentPositionBeingTried, allowedPositions );
				}
			} else done = true;
		} while( ! done );


		if( allPositionsAreOutOfBounds && allowedPositions.length > 1 ) {
			var bestOfTheBadPositions = _.first( _.sortBy( _.pairs( degreeOfUndesirabilityByPosition ), function( thisPosition ) {
				// if the current position and another position are tied, give preference to the current position
				return thisPosition[ 1 ] + ( thisPosition[ 0 ] === _this.currentPosition && _this.state === 'open' ? -1 : 0 );
			} ) )[ 0 ];

			allPositionsAreOutOfBounds = ! this.reposition( [ bestOfTheBadPositions ], { hideIfAllPositionsAreOutOfBounds : false } )
		}

		if( this._dimentionsHaveChanged( popupWidth, popupHeight ) ) {
			// there is a fringe case in which positining the popup actually changes its width and / or height.
			// for example, if the popup is placed just a few pixels from the edge of the view port, it might shrink
			// and text will wrap. so we have to check to see if the width or height of the popup has changed since
			// we started this re-positioning process. if so, try repositioning it once at the same position. if that
			// doesn't work, then move on to another position to see if we have better luck.
			if( ! options.tryAgainIfDimentionsChange ) return false;

			allPositionsAreOutOfBounds = ! this.reposition( [ currentPositionBeingTried ], {
				tryAgainIfDimentionsChange : false,
				hideIfAllPositionsAreOutOfBounds : false
			} );

			// try one more time, with our new width and height.
			// if( ! this.reposition( [ currentPositionBeingTried ], false ) ) {
			// 	// if that doesn't work, then give up on this position
			// 	newAllowedPositions = _.without( allowedPositions, currentPositionBeingTried );
			// 	if( newAllowedPositions.length > 0 ) allPositionsAreOutOfBounds = this.reposition( newAllowedPositions );
			// }
		}

		this.currentPosition = currentPositionBeingTried;

		if( options.hideIfAllPositionsAreOutOfBounds && allPositionsAreOutOfBounds ) {
			this.$el.hide();
		}
		
		return ! allPositionsAreOutOfBounds;
	},

	_onSubviewsRendered : function() {
		if( ! _.isUndefined( this.extraClassName ) ) this.$el.addClass( this.extraClassName );
	},

	_getDegreeOfUndesirabilityOfCurrentPosition : function() {
		var myOffset = this.$el.offset();
		if( ! myOffset ) return false; // hidden elements have undefined offsets, not much we can do

		var myWidth = this.$el.outerWidth();
		var myHeight = this.$el.outerHeight();

		var myRect = {
			top : myOffset.top,
			right : myOffset.left + myWidth,
			bottom : myOffset.top + myHeight,
			left : myOffset.left
		};

		var keepWithinRect = _.result( this, 'keepWithinRect' );

		var horizontalOverlap = Math.max( 0, Math.min( myRect.right, keepWithinRect.right ) - Math.max( myRect.left, keepWithinRect.left ) )
		var veritcalOverlap = Math.max( 0, Math.min( myRect.bottom, keepWithinRect.bottom ) - Math.max( myRect.top, keepWithinRect.top ) );

		var myRectArea = myWidth * myHeight;

		var amountOutsideBoundingRect = myRectArea - horizontalOverlap * veritcalOverlap;

		var documentRect = {
			top : 0,
			left : 0,
			right : $( document ).width(),
			bottom : $( document ).height()
		};

		horizontalOverlap = Math.max( 0, Math.min( myRect.right, documentRect.right ) - Math.max( myRect.left, documentRect.left ) )
		veritcalOverlap = Math.max( 0, Math.min( myRect.bottom, documentRect.bottom ) - Math.max( myRect.top, documentRect.top ) );
		
		var amountOutsideDocument = myRectArea - horizontalOverlap * veritcalOverlap;
		
		return Math.max( Math.round( amountOutsideBoundingRect + amountOutsideDocument * 10 ), 0 );
	},

	_onOptionsChanged : function( changedOptions ) {
		if( 'target' in changedOptions ) this._setupTargetEl();
		if( 'contents' in changedOptions ) this.render();

		this.reposition();
	},

	_getParentView : function() {
		var parent = null;

		var curElement = this.targetEl;
		while( curElement.length > 0 && curElement[0] !== lastPossibleViewElement ) {
			var view = curElement.data( 'view' );
			if( view && _.isFunction( view.render ) ) {
				parent = view;
				break;
			}

			curElement = curElement.parent();
		}

		return parent;
	},

	_setState : function( newState ) {
		this.state = newState;
		this.$el.attr( 'data-state', this.state );

		if( newState === kState_Open ) this.timeOpened = (new Date()).getTime();
	},

	_setupTargetEl : function() {
		var _this = this;

		this.targetEl = _.isObject( this.target ) && _.isFunction( this.target.render ) ? this.target.$el : $( this.target );

		if( this.targetEl.length !== 1 ) throw new Error( 'Each ModuiPopup must have exactly one target element.' );

		this.targetEl.on( 'remove', function() {
			if( _this.targetEl.get( 0 ) === $( this ).get( 0 ) ) {
				_this.close();
			}
		} );
	},

	_dimentionsHaveChanged : function( oldOuterWidth, oldOuterHeight ) {
		var widthDifference = Math.abs( oldOuterWidth - Math.round( this.$el.outerWidth() ) );
		var heightDifference = Math.abs( oldOuterHeight - Math.round( this.$el.outerHeight() ) );

		return widthDifference > 1 || heightDifference > 1;
	}
}, {
	open : function( options ) {
		var popupInstance;

		if( options.signature ) {
			var existingPopupsOfThisSignature = _.filter( mOpenPopups, function( thisPopup ) {
				return thisPopup.signature === options.signature && thisPopup.state === kState_Open;
			} );

			if( existingPopupsOfThisSignature.length ) {
				var popupWeAreGoingTokeep = existingPopupsOfThisSignature.pop();

				popupInstance = popupWeAreGoingTokeep;
				popupInstance.setOptions( options );
				popupInstance.reposition();

				_.each( existingPopupsOfThisSignature, function( thisExtraPopup ) {
					thisExtraPopup.close();
				} );
			}
		}

		if( ! popupInstance ) {
			popupInstance = new this( options );

			$( 'body' ).append( popupInstance.$el );

			popupInstance.render();
			popupInstance.reposition();
			mOpenPopups.push( popupInstance );
		}

		popupInstance._setState( kState_Open );

		return popupInstance;
	}
} );

$( document ).bind( 'mousedown', function( e ) {
	_.each( mOpenPopups, function( thisPopup ) {
		if( thisPopup.closeOnOutsideClick &&
			thisPopup.state === kState_Open &&
			( new Date() ).getTime() - thisPopup.timeOpened > kMinTimeAfterOpenBeforeCloseOnOutsideClick ) {
			var thisPopupDomEl = thisPopup.$el.get( 0 );
			if( thisPopupDomEl !== e.target && ! $.contains( thisPopupDomEl, e.target ) ) {
				thisPopup.close();
			}
		}
	} );
} );

function _getElementZIndex( elm ) {
	var bodyDomEl = $( 'body' )[ 0 ];
	var zIndex = parseInt( elm.css( 'zIndex' ) ) > 0 ? elm.css( 'zIndex' ) : 0;

	while( elm.length > 0 && bodyDomEl !== elm.get( 0 ) ) {
		zIndex = ( parseInt( elm.css( 'zIndex' ) ) > 0 && parseInt( elm.css( 'zIndex' ), 10 ) > zIndex ) ? elm.css( 'zIndex' ) : zIndex;
		elm = elm.parent();
	}

	return zIndex;
}

function _attachWindowEventListeners() {
	if( window.addEventListener ) window.addEventListener( 'scroll', function( e ) {
		_.each( mOpenPopups, function( thisPopup ) {
			if( ! _elementPositionIsFixed( thisPopup.targetEl, e.target ) ) {
				thisPopup.reposition();
			}
		} );
	}, true );

	$( window ).resize( function() {
		_.each( mOpenPopups, function( thisPopup ) {
			thisPopup.reposition();
		} );
	} );

};

function _elementPositionIsFixed( el, relativeToDomEl ) {
	if( el.prop( 'tagName' ) === 'HTML' ) return false;

	if( el.css( 'position' ) === 'fixed' ) return true;

	var offsetParent = el.offsetParent();
	if( relativeToDomEl && ! $.contains( relativeToDomEl, offsetParent.get( 0 ) ) ) return false;

	return _elementPositionIsFixed( el.offsetParent(), relativeToDomEl );
};

function _getNextPositionToTry( position, positionsToTry ) {
	positionIndex = _.indexOf( positionsToTry, position );
	if( positionIndex === -1 ) throw new Error( 'Could not find position "' + position + '" in the allowed positions.' );

	return positionIndex === positionsToTry.length - 1 ? positionsToTry[ 0 ] : positionsToTry[ positionIndex + 1 ];
}

// return UMD
return Backbone.ModuiPopup;

} ) );
}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})

},{"modui-base":24}],26:[function(require,module,exports){
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/

'use strict';
/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

module.exports = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};

},{}],27:[function(require,module,exports){
// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };

},{}],28:[function(require,module,exports){
var Storage = require('./storage');
var cookie = require('./cookie');

var _storage_support = true;

try {
  window.localStorage.setItem('test', '42');
  window.sessionStorage.setItem('test', '42');
} catch (e) {
  _storage_support = false;
}

if (_storage_support) {
  module.exports = {
    localStorage: window.localStorage,
    sessionStorage: window.sessionStorage
  };
} else {
  var lsCookie = cookie.read('localStorage');

  var ls = new Storage(
    lsCookie ? JSON.parse(lsCookie) : {}, // init
    function(data) {
      // set
      cookie.create('localStorage', JSON.stringify(data), 365);
    },
    function() {
      // clear
      cookie.create('localStorage', '', 365);
    }
  );

  var ss = new Storage();

  module.exports = {
    localStorage: ls,
    sessionStorage: ss
  };
}

},{"./cookie":29,"./storage":31}],29:[function(require,module,exports){
function createCookie(name, value, days) {
  var date, expires;

  if (days) {
    date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    expires = '; expires=' + date.toGMTString();
  } else {
    expires = '';
  }
  document.cookie = name + '=' + value + expires + '; path=/';
}

function readCookie(name) {
  var nameEQ = name + '=',
    ca = document.cookie.split(';'),
    i,
    c;

  for (i = 0; i < ca.length; i++) {
    c = ca[i];
    while (c.charAt(0) === ' ') {
      c = c.substring(1, c.length);
    }

    if (c.indexOf(nameEQ) === 0) {
      return c.substring(nameEQ.length, c.length);
    }
  }
  return null;
}

module.exports = {
  create: createCookie,
  read: readCookie
};

},{}],30:[function(require,module,exports){
module.exports = function(obj) {
  var n = 0;
  for (var k in obj) {
    if (obj.hasOwnProperty(k)) {
      n += 1;
    }
  }

  return n;
};

},{}],31:[function(require,module,exports){
var numKeys = require('./num-keys');

function Storage(obj, set, clear) {
  this._obj = obj || {};
  this._set = set;
  this._clear = clear;

  this.length = 0;
}

var proto = Storage.prototype;

// html5 storage api

proto.setItem = function(k, v) {
  k = encodeURIComponent(k);
  this._obj[k] = v;

  this._updateLength();
  if (this._set) this._set(this._obj);
};

proto.getItem = function(k) {
  k = encodeURIComponent(k);
  return this._obj[k] === undefined ? null : this._obj[k];
};

proto.removeItem = function(k) {
  k = encodeURIComponent(k);
  delete this._obj[k];

  this._updateLength();
  if (this._set) this._set(this._obj);
};

proto.key = function(i) {
  var ctr = 0;
  for (var k in this._obj) {
    if (ctr === i) return decodeURIComponent(k);
    else ctr++;
  }

  return null;
};

proto.clear = function() {
  delete this['_obj'];

  if (this._clear) this._clear();
};

// private
proto._updateLength = function() {
  this.length = numKeys(this._obj);
};

module.exports = Storage;

},{"./num-keys":30}],32:[function(require,module,exports){
function Agent() {
  this._defaults = [];
}

["use", "on", "once", "set", "query", "type", "accept", "auth", "withCredentials", "sortQuery", "retry", "ok", "redirects",
 "timeout", "buffer", "serialize", "parse", "ca", "key", "pfx", "cert"].forEach(function(fn) {
  /** Default setting for all requests from this agent */
  Agent.prototype[fn] = function(/*varargs*/) {
    this._defaults.push({fn:fn, arguments:arguments});
    return this;
  }
});

Agent.prototype._setDefaults = function(req) {
    this._defaults.forEach(function(def) {
      req[def.fn].apply(req, def.arguments);
    });
};

module.exports = Agent;

},{}],33:[function(require,module,exports){
/**
 * Root reference for iframes.
 */

var root;
if (typeof window !== 'undefined') { // Browser window
  root = window;
} else if (typeof self !== 'undefined') { // Web Worker
  root = self;
} else { // Other environments
  console.warn("Using browser-only version of superagent in non-browser environment");
  root = this;
}

var Emitter = require('component-emitter');
var RequestBase = require('./request-base');
var isObject = require('./is-object');
var ResponseBase = require('./response-base');
var Agent = require('./agent-base');

/**
 * Noop.
 */

function noop(){};

/**
 * Expose `request`.
 */

var request = exports = module.exports = function(method, url) {
  // callback
  if ('function' == typeof url) {
    return new exports.Request('GET', method).end(url);
  }

  // url first
  if (1 == arguments.length) {
    return new exports.Request('GET', method);
  }

  return new exports.Request(method, url);
}

exports.Request = Request;

/**
 * Determine XHR.
 */

request.getXHR = function () {
  if (root.XMLHttpRequest
      && (!root.location || 'file:' != root.location.protocol
          || !root.ActiveXObject)) {
    return new XMLHttpRequest;
  } else {
    try { return new ActiveXObject('Microsoft.XMLHTTP'); } catch(e) {}
    try { return new ActiveXObject('Msxml2.XMLHTTP.6.0'); } catch(e) {}
    try { return new ActiveXObject('Msxml2.XMLHTTP.3.0'); } catch(e) {}
    try { return new ActiveXObject('Msxml2.XMLHTTP'); } catch(e) {}
  }
  throw Error("Browser-only version of superagent could not find XHR");
};

/**
 * Removes leading and trailing whitespace, added to support IE.
 *
 * @param {String} s
 * @return {String}
 * @api private
 */

var trim = ''.trim
  ? function(s) { return s.trim(); }
  : function(s) { return s.replace(/(^\s*|\s*$)/g, ''); };

/**
 * Serialize the given `obj`.
 *
 * @param {Object} obj
 * @return {String}
 * @api private
 */

function serialize(obj) {
  if (!isObject(obj)) return obj;
  var pairs = [];
  for (var key in obj) {
    pushEncodedKeyValuePair(pairs, key, obj[key]);
  }
  return pairs.join('&');
}

/**
 * Helps 'serialize' with serializing arrays.
 * Mutates the pairs array.
 *
 * @param {Array} pairs
 * @param {String} key
 * @param {Mixed} val
 */

function pushEncodedKeyValuePair(pairs, key, val) {
  if (val != null) {
    if (Array.isArray(val)) {
      val.forEach(function(v) {
        pushEncodedKeyValuePair(pairs, key, v);
      });
    } else if (isObject(val)) {
      for(var subkey in val) {
        pushEncodedKeyValuePair(pairs, key + '[' + subkey + ']', val[subkey]);
      }
    } else {
      pairs.push(encodeURIComponent(key)
        + '=' + encodeURIComponent(val));
    }
  } else if (val === null) {
    pairs.push(encodeURIComponent(key));
  }
}

/**
 * Expose serialization method.
 */

request.serializeObject = serialize;

/**
  * Parse the given x-www-form-urlencoded `str`.
  *
  * @param {String} str
  * @return {Object}
  * @api private
  */

function parseString(str) {
  var obj = {};
  var pairs = str.split('&');
  var pair;
  var pos;

  for (var i = 0, len = pairs.length; i < len; ++i) {
    pair = pairs[i];
    pos = pair.indexOf('=');
    if (pos == -1) {
      obj[decodeURIComponent(pair)] = '';
    } else {
      obj[decodeURIComponent(pair.slice(0, pos))] =
        decodeURIComponent(pair.slice(pos + 1));
    }
  }

  return obj;
}

/**
 * Expose parser.
 */

request.parseString = parseString;

/**
 * Default MIME type map.
 *
 *     superagent.types.xml = 'application/xml';
 *
 */

request.types = {
  html: 'text/html',
  json: 'application/json',
  xml: 'text/xml',
  urlencoded: 'application/x-www-form-urlencoded',
  'form': 'application/x-www-form-urlencoded',
  'form-data': 'application/x-www-form-urlencoded'
};

/**
 * Default serialization map.
 *
 *     superagent.serialize['application/xml'] = function(obj){
 *       return 'generated xml here';
 *     };
 *
 */

request.serialize = {
  'application/x-www-form-urlencoded': serialize,
  'application/json': JSON.stringify
};

/**
  * Default parsers.
  *
  *     superagent.parse['application/xml'] = function(str){
  *       return { object parsed from str };
  *     };
  *
  */

request.parse = {
  'application/x-www-form-urlencoded': parseString,
  'application/json': JSON.parse
};

/**
 * Parse the given header `str` into
 * an object containing the mapped fields.
 *
 * @param {String} str
 * @return {Object}
 * @api private
 */

function parseHeader(str) {
  var lines = str.split(/\r?\n/);
  var fields = {};
  var index;
  var line;
  var field;
  var val;

  for (var i = 0, len = lines.length; i < len; ++i) {
    line = lines[i];
    index = line.indexOf(':');
    if (index === -1) { // could be empty line, just skip it
      continue;
    }
    field = line.slice(0, index).toLowerCase();
    val = trim(line.slice(index + 1));
    fields[field] = val;
  }

  return fields;
}

/**
 * Check if `mime` is json or has +json structured syntax suffix.
 *
 * @param {String} mime
 * @return {Boolean}
 * @api private
 */

function isJSON(mime) {
  // should match /json or +json
  // but not /json-seq
  return /[\/+]json($|[^-\w])/.test(mime);
}

/**
 * Initialize a new `Response` with the given `xhr`.
 *
 *  - set flags (.ok, .error, etc)
 *  - parse header
 *
 * Examples:
 *
 *  Aliasing `superagent` as `request` is nice:
 *
 *      request = superagent;
 *
 *  We can use the promise-like API, or pass callbacks:
 *
 *      request.get('/').end(function(res){});
 *      request.get('/', function(res){});
 *
 *  Sending data can be chained:
 *
 *      request
 *        .post('/user')
 *        .send({ name: 'tj' })
 *        .end(function(res){});
 *
 *  Or passed to `.send()`:
 *
 *      request
 *        .post('/user')
 *        .send({ name: 'tj' }, function(res){});
 *
 *  Or passed to `.post()`:
 *
 *      request
 *        .post('/user', { name: 'tj' })
 *        .end(function(res){});
 *
 * Or further reduced to a single call for simple cases:
 *
 *      request
 *        .post('/user', { name: 'tj' }, function(res){});
 *
 * @param {XMLHTTPRequest} xhr
 * @param {Object} options
 * @api private
 */

function Response(req) {
  this.req = req;
  this.xhr = this.req.xhr;
  // responseText is accessible only if responseType is '' or 'text' and on older browsers
  this.text = ((this.req.method !='HEAD' && (this.xhr.responseType === '' || this.xhr.responseType === 'text')) || typeof this.xhr.responseType === 'undefined')
     ? this.xhr.responseText
     : null;
  this.statusText = this.req.xhr.statusText;
  var status = this.xhr.status;
  // handle IE9 bug: http://stackoverflow.com/questions/10046972/msie-returns-status-code-of-1223-for-ajax-request
  if (status === 1223) {
    status = 204;
  }
  this._setStatusProperties(status);
  this.header = this.headers = parseHeader(this.xhr.getAllResponseHeaders());
  // getAllResponseHeaders sometimes falsely returns "" for CORS requests, but
  // getResponseHeader still works. so we get content-type even if getting
  // other headers fails.
  this.header['content-type'] = this.xhr.getResponseHeader('content-type');
  this._setHeaderProperties(this.header);

  if (null === this.text && req._responseType) {
    this.body = this.xhr.response;
  } else {
    this.body = this.req.method != 'HEAD'
      ? this._parseBody(this.text ? this.text : this.xhr.response)
      : null;
  }
}

ResponseBase(Response.prototype);

/**
 * Parse the given body `str`.
 *
 * Used for auto-parsing of bodies. Parsers
 * are defined on the `superagent.parse` object.
 *
 * @param {String} str
 * @return {Mixed}
 * @api private
 */

Response.prototype._parseBody = function(str) {
  var parse = request.parse[this.type];
  if (this.req._parser) {
    return this.req._parser(this, str);
  }
  if (!parse && isJSON(this.type)) {
    parse = request.parse['application/json'];
  }
  return parse && str && (str.length || str instanceof Object)
    ? parse(str)
    : null;
};

/**
 * Return an `Error` representative of this response.
 *
 * @return {Error}
 * @api public
 */

Response.prototype.toError = function(){
  var req = this.req;
  var method = req.method;
  var url = req.url;

  var msg = 'cannot ' + method + ' ' + url + ' (' + this.status + ')';
  var err = new Error(msg);
  err.status = this.status;
  err.method = method;
  err.url = url;

  return err;
};

/**
 * Expose `Response`.
 */

request.Response = Response;

/**
 * Initialize a new `Request` with the given `method` and `url`.
 *
 * @param {String} method
 * @param {String} url
 * @api public
 */

function Request(method, url) {
  var self = this;
  this._query = this._query || [];
  this.method = method;
  this.url = url;
  this.header = {}; // preserves header name case
  this._header = {}; // coerces header names to lowercase
  this.on('end', function(){
    var err = null;
    var res = null;

    try {
      res = new Response(self);
    } catch(e) {
      err = new Error('Parser is unable to parse the response');
      err.parse = true;
      err.original = e;
      // issue #675: return the raw response if the response parsing fails
      if (self.xhr) {
        // ie9 doesn't have 'response' property
        err.rawResponse = typeof self.xhr.responseType == 'undefined' ? self.xhr.responseText : self.xhr.response;
        // issue #876: return the http status code if the response parsing fails
        err.status = self.xhr.status ? self.xhr.status : null;
        err.statusCode = err.status; // backwards-compat only
      } else {
        err.rawResponse = null;
        err.status = null;
      }

      return self.callback(err);
    }

    self.emit('response', res);

    var new_err;
    try {
      if (!self._isResponseOK(res)) {
        new_err = new Error(res.statusText || 'Unsuccessful HTTP response');
      }
    } catch(custom_err) {
      new_err = custom_err; // ok() callback can throw
    }

    // #1000 don't catch errors from the callback to avoid double calling it
    if (new_err) {
      new_err.original = err;
      new_err.response = res;
      new_err.status = res.status;
      self.callback(new_err, res);
    } else {
      self.callback(null, res);
    }
  });
}

/**
 * Mixin `Emitter` and `RequestBase`.
 */

Emitter(Request.prototype);
RequestBase(Request.prototype);

/**
 * Set Content-Type to `type`, mapping values from `request.types`.
 *
 * Examples:
 *
 *      superagent.types.xml = 'application/xml';
 *
 *      request.post('/')
 *        .type('xml')
 *        .send(xmlstring)
 *        .end(callback);
 *
 *      request.post('/')
 *        .type('application/xml')
 *        .send(xmlstring)
 *        .end(callback);
 *
 * @param {String} type
 * @return {Request} for chaining
 * @api public
 */

Request.prototype.type = function(type){
  this.set('Content-Type', request.types[type] || type);
  return this;
};

/**
 * Set Accept to `type`, mapping values from `request.types`.
 *
 * Examples:
 *
 *      superagent.types.json = 'application/json';
 *
 *      request.get('/agent')
 *        .accept('json')
 *        .end(callback);
 *
 *      request.get('/agent')
 *        .accept('application/json')
 *        .end(callback);
 *
 * @param {String} accept
 * @return {Request} for chaining
 * @api public
 */

Request.prototype.accept = function(type){
  this.set('Accept', request.types[type] || type);
  return this;
};

/**
 * Set Authorization field value with `user` and `pass`.
 *
 * @param {String} user
 * @param {String} [pass] optional in case of using 'bearer' as type
 * @param {Object} options with 'type' property 'auto', 'basic' or 'bearer' (default 'basic')
 * @return {Request} for chaining
 * @api public
 */

Request.prototype.auth = function(user, pass, options){
  if (1 === arguments.length) pass = '';
  if (typeof pass === 'object' && pass !== null) { // pass is optional and can be replaced with options
    options = pass;
    pass = '';
  }
  if (!options) {
    options = {
      type: 'function' === typeof btoa ? 'basic' : 'auto',
    };
  }

  var encoder = function(string) {
    if ('function' === typeof btoa) {
      return btoa(string);
    }
    throw new Error('Cannot use basic auth, btoa is not a function');
  };

  return this._auth(user, pass, options, encoder);
};

/**
 * Add query-string `val`.
 *
 * Examples:
 *
 *   request.get('/shoes')
 *     .query('size=10')
 *     .query({ color: 'blue' })
 *
 * @param {Object|String} val
 * @return {Request} for chaining
 * @api public
 */

Request.prototype.query = function(val){
  if ('string' != typeof val) val = serialize(val);
  if (val) this._query.push(val);
  return this;
};

/**
 * Queue the given `file` as an attachment to the specified `field`,
 * with optional `options` (or filename).
 *
 * ``` js
 * request.post('/upload')
 *   .attach('content', new Blob(['<a id="a"><b id="b">hey!</b></a>'], { type: "text/html"}))
 *   .end(callback);
 * ```
 *
 * @param {String} field
 * @param {Blob|File} file
 * @param {String|Object} options
 * @return {Request} for chaining
 * @api public
 */

Request.prototype.attach = function(field, file, options){
  if (file) {
    if (this._data) {
      throw Error("superagent can't mix .send() and .attach()");
    }

    this._getFormData().append(field, file, options || file.name);
  }
  return this;
};

Request.prototype._getFormData = function(){
  if (!this._formData) {
    this._formData = new root.FormData();
  }
  return this._formData;
};

/**
 * Invoke the callback with `err` and `res`
 * and handle arity check.
 *
 * @param {Error} err
 * @param {Response} res
 * @api private
 */

Request.prototype.callback = function(err, res){
  if (this._shouldRetry(err, res)) {
    return this._retry();
  }

  var fn = this._callback;
  this.clearTimeout();

  if (err) {
    if (this._maxRetries) err.retries = this._retries - 1;
    this.emit('error', err);
  }

  fn(err, res);
};

/**
 * Invoke callback with x-domain error.
 *
 * @api private
 */

Request.prototype.crossDomainError = function(){
  var err = new Error('Request has been terminated\nPossible causes: the network is offline, Origin is not allowed by Access-Control-Allow-Origin, the page is being unloaded, etc.');
  err.crossDomain = true;

  err.status = this.status;
  err.method = this.method;
  err.url = this.url;

  this.callback(err);
};

// This only warns, because the request is still likely to work
Request.prototype.buffer = Request.prototype.ca = Request.prototype.agent = function(){
  console.warn("This is not supported in browser version of superagent");
  return this;
};

// This throws, because it can't send/receive data as expected
Request.prototype.pipe = Request.prototype.write = function(){
  throw Error("Streaming is not supported in browser version of superagent");
};

/**
 * Check if `obj` is a host object,
 * we don't want to serialize these :)
 *
 * @param {Object} obj
 * @return {Boolean}
 * @api private
 */
Request.prototype._isHost = function _isHost(obj) {
  // Native objects stringify to [object File], [object Blob], [object FormData], etc.
  return obj && 'object' === typeof obj && !Array.isArray(obj) && Object.prototype.toString.call(obj) !== '[object Object]';
}

/**
 * Initiate request, invoking callback `fn(res)`
 * with an instanceof `Response`.
 *
 * @param {Function} fn
 * @return {Request} for chaining
 * @api public
 */

Request.prototype.end = function(fn){
  if (this._endCalled) {
    console.warn("Warning: .end() was called twice. This is not supported in superagent");
  }
  this._endCalled = true;

  // store callback
  this._callback = fn || noop;

  // querystring
  this._finalizeQueryString();

  return this._end();
};

Request.prototype._end = function() {
  var self = this;
  var xhr = (this.xhr = request.getXHR());
  var data = this._formData || this._data;

  this._setTimeouts();

  // state change
  xhr.onreadystatechange = function(){
    var readyState = xhr.readyState;
    if (readyState >= 2 && self._responseTimeoutTimer) {
      clearTimeout(self._responseTimeoutTimer);
    }
    if (4 != readyState) {
      return;
    }

    // In IE9, reads to any property (e.g. status) off of an aborted XHR will
    // result in the error "Could not complete the operation due to error c00c023f"
    var status;
    try { status = xhr.status } catch(e) { status = 0; }

    if (!status) {
      if (self.timedout || self._aborted) return;
      return self.crossDomainError();
    }
    self.emit('end');
  };

  // progress
  var handleProgress = function(direction, e) {
    if (e.total > 0) {
      e.percent = e.loaded / e.total * 100;
    }
    e.direction = direction;
    self.emit('progress', e);
  };
  if (this.hasListeners('progress')) {
    try {
      xhr.onprogress = handleProgress.bind(null, 'download');
      if (xhr.upload) {
        xhr.upload.onprogress = handleProgress.bind(null, 'upload');
      }
    } catch(e) {
      // Accessing xhr.upload fails in IE from a web worker, so just pretend it doesn't exist.
      // Reported here:
      // https://connect.microsoft.com/IE/feedback/details/837245/xmlhttprequest-upload-throws-invalid-argument-when-used-from-web-worker-context
    }
  }

  // initiate request
  try {
    if (this.username && this.password) {
      xhr.open(this.method, this.url, true, this.username, this.password);
    } else {
      xhr.open(this.method, this.url, true);
    }
  } catch (err) {
    // see #1149
    return this.callback(err);
  }

  // CORS
  if (this._withCredentials) xhr.withCredentials = true;

  // body
  if (!this._formData && 'GET' != this.method && 'HEAD' != this.method && 'string' != typeof data && !this._isHost(data)) {
    // serialize stuff
    var contentType = this._header['content-type'];
    var serialize = this._serializer || request.serialize[contentType ? contentType.split(';')[0] : ''];
    if (!serialize && isJSON(contentType)) {
      serialize = request.serialize['application/json'];
    }
    if (serialize) data = serialize(data);
  }

  // set header fields
  for (var field in this.header) {
    if (null == this.header[field]) continue;

    if (this.header.hasOwnProperty(field))
      xhr.setRequestHeader(field, this.header[field]);
  }

  if (this._responseType) {
    xhr.responseType = this._responseType;
  }

  // send stuff
  this.emit('request', this);

  // IE11 xhr.send(undefined) sends 'undefined' string as POST payload (instead of nothing)
  // We need null here if data is undefined
  xhr.send(typeof data !== 'undefined' ? data : null);
  return this;
};

request.agent = function() {
  return new Agent();
};

["GET", "POST", "OPTIONS", "PATCH", "PUT", "DELETE"].forEach(function(method) {
  Agent.prototype[method.toLowerCase()] = function(url, fn) {
    var req = new request.Request(method, url);
    this._setDefaults(req);
    if (fn) {
      req.end(fn);
    }
    return req;
  };
});

Agent.prototype.del = Agent.prototype['delete'];

/**
 * GET `url` with optional callback `fn(res)`.
 *
 * @param {String} url
 * @param {Mixed|Function} [data] or fn
 * @param {Function} [fn]
 * @return {Request}
 * @api public
 */

request.get = function(url, data, fn) {
  var req = request('GET', url);
  if ('function' == typeof data) (fn = data), (data = null);
  if (data) req.query(data);
  if (fn) req.end(fn);
  return req;
};

/**
 * HEAD `url` with optional callback `fn(res)`.
 *
 * @param {String} url
 * @param {Mixed|Function} [data] or fn
 * @param {Function} [fn]
 * @return {Request}
 * @api public
 */

request.head = function(url, data, fn) {
  var req = request('HEAD', url);
  if ('function' == typeof data) (fn = data), (data = null);
  if (data) req.query(data);
  if (fn) req.end(fn);
  return req;
};

/**
 * OPTIONS query to `url` with optional callback `fn(res)`.
 *
 * @param {String} url
 * @param {Mixed|Function} [data] or fn
 * @param {Function} [fn]
 * @return {Request}
 * @api public
 */

request.options = function(url, data, fn) {
  var req = request('OPTIONS', url);
  if ('function' == typeof data) (fn = data), (data = null);
  if (data) req.send(data);
  if (fn) req.end(fn);
  return req;
};

/**
 * DELETE `url` with optional `data` and callback `fn(res)`.
 *
 * @param {String} url
 * @param {Mixed} [data]
 * @param {Function} [fn]
 * @return {Request}
 * @api public
 */

function del(url, data, fn) {
  var req = request('DELETE', url);
  if ('function' == typeof data) (fn = data), (data = null);
  if (data) req.send(data);
  if (fn) req.end(fn);
  return req;
}

request['del'] = del;
request['delete'] = del;

/**
 * PATCH `url` with optional `data` and callback `fn(res)`.
 *
 * @param {String} url
 * @param {Mixed} [data]
 * @param {Function} [fn]
 * @return {Request}
 * @api public
 */

request.patch = function(url, data, fn) {
  var req = request('PATCH', url);
  if ('function' == typeof data) (fn = data), (data = null);
  if (data) req.send(data);
  if (fn) req.end(fn);
  return req;
};

/**
 * POST `url` with optional `data` and callback `fn(res)`.
 *
 * @param {String} url
 * @param {Mixed} [data]
 * @param {Function} [fn]
 * @return {Request}
 * @api public
 */

request.post = function(url, data, fn) {
  var req = request('POST', url);
  if ('function' == typeof data) (fn = data), (data = null);
  if (data) req.send(data);
  if (fn) req.end(fn);
  return req;
};

/**
 * PUT `url` with optional `data` and callback `fn(res)`.
 *
 * @param {String} url
 * @param {Mixed|Function} [data] or fn
 * @param {Function} [fn]
 * @return {Request}
 * @api public
 */

request.put = function(url, data, fn) {
  var req = request('PUT', url);
  if ('function' == typeof data) (fn = data), (data = null);
  if (data) req.send(data);
  if (fn) req.end(fn);
  return req;
};

},{"./agent-base":32,"./is-object":34,"./request-base":35,"./response-base":36,"component-emitter":21}],34:[function(require,module,exports){
'use strict';

/**
 * Check if `obj` is an object.
 *
 * @param {Object} obj
 * @return {Boolean}
 * @api private
 */

function isObject(obj) {
  return null !== obj && 'object' === typeof obj;
}

module.exports = isObject;

},{}],35:[function(require,module,exports){
'use strict';

/**
 * Module of mixed-in functions shared between node and client code
 */
var isObject = require('./is-object');

/**
 * Expose `RequestBase`.
 */

module.exports = RequestBase;

/**
 * Initialize a new `RequestBase`.
 *
 * @api public
 */

function RequestBase(obj) {
  if (obj) return mixin(obj);
}

/**
 * Mixin the prototype properties.
 *
 * @param {Object} obj
 * @return {Object}
 * @api private
 */

function mixin(obj) {
  for (var key in RequestBase.prototype) {
    obj[key] = RequestBase.prototype[key];
  }
  return obj;
}

/**
 * Clear previous timeout.
 *
 * @return {Request} for chaining
 * @api public
 */

RequestBase.prototype.clearTimeout = function _clearTimeout(){
  clearTimeout(this._timer);
  clearTimeout(this._responseTimeoutTimer);
  delete this._timer;
  delete this._responseTimeoutTimer;
  return this;
};

/**
 * Override default response body parser
 *
 * This function will be called to convert incoming data into request.body
 *
 * @param {Function}
 * @api public
 */

RequestBase.prototype.parse = function parse(fn){
  this._parser = fn;
  return this;
};

/**
 * Set format of binary response body.
 * In browser valid formats are 'blob' and 'arraybuffer',
 * which return Blob and ArrayBuffer, respectively.
 *
 * In Node all values result in Buffer.
 *
 * Examples:
 *
 *      req.get('/')
 *        .responseType('blob')
 *        .end(callback);
 *
 * @param {String} val
 * @return {Request} for chaining
 * @api public
 */

RequestBase.prototype.responseType = function(val){
  this._responseType = val;
  return this;
};

/**
 * Override default request body serializer
 *
 * This function will be called to convert data set via .send or .attach into payload to send
 *
 * @param {Function}
 * @api public
 */

RequestBase.prototype.serialize = function serialize(fn){
  this._serializer = fn;
  return this;
};

/**
 * Set timeouts.
 *
 * - response timeout is time between sending request and receiving the first byte of the response. Includes DNS and connection time.
 * - deadline is the time from start of the request to receiving response body in full. If the deadline is too short large files may not load at all on slow connections.
 *
 * Value of 0 or false means no timeout.
 *
 * @param {Number|Object} ms or {response, deadline}
 * @return {Request} for chaining
 * @api public
 */

RequestBase.prototype.timeout = function timeout(options){
  if (!options || 'object' !== typeof options) {
    this._timeout = options;
    this._responseTimeout = 0;
    return this;
  }

  for(var option in options) {
    switch(option) {
      case 'deadline':
        this._timeout = options.deadline;
        break;
      case 'response':
        this._responseTimeout = options.response;
        break;
      default:
        console.warn("Unknown timeout option", option);
    }
  }
  return this;
};

/**
 * Set number of retry attempts on error.
 *
 * Failed requests will be retried 'count' times if timeout or err.code >= 500.
 *
 * @param {Number} count
 * @param {Function} [fn]
 * @return {Request} for chaining
 * @api public
 */

RequestBase.prototype.retry = function retry(count, fn){
  // Default to 1 if no count passed or true
  if (arguments.length === 0 || count === true) count = 1;
  if (count <= 0) count = 0;
  this._maxRetries = count;
  this._retries = 0;
  this._retryCallback = fn;
  return this;
};

var ERROR_CODES = [
  'ECONNRESET',
  'ETIMEDOUT',
  'EADDRINFO',
  'ESOCKETTIMEDOUT'
];

/**
 * Determine if a request should be retried.
 * (Borrowed from segmentio/superagent-retry)
 *
 * @param {Error} err
 * @param {Response} [res]
 * @returns {Boolean}
 */
RequestBase.prototype._shouldRetry = function(err, res) {
  if (!this._maxRetries || this._retries++ >= this._maxRetries) {
    return false;
  }
  if (this._retryCallback) {
    try {
      var override = this._retryCallback(err, res);
      if (override === true) return true;
      if (override === false) return false;
      // undefined falls back to defaults
    } catch(e) {
      console.error(e);
    }
  }
  if (res && res.status && res.status >= 500 && res.status != 501) return true;
  if (err) {
    if (err.code && ~ERROR_CODES.indexOf(err.code)) return true;
    // Superagent timeout
    if (err.timeout && err.code == 'ECONNABORTED') return true;
    if (err.crossDomain) return true;
  }
  return false;
};

/**
 * Retry request
 *
 * @return {Request} for chaining
 * @api private
 */

RequestBase.prototype._retry = function() {

  this.clearTimeout();

  // node
  if (this.req) {
    this.req = null;
    this.req = this.request();
  }

  this._aborted = false;
  this.timedout = false;

  return this._end();
};

/**
 * Promise support
 *
 * @param {Function} resolve
 * @param {Function} [reject]
 * @return {Request}
 */

RequestBase.prototype.then = function then(resolve, reject) {
  if (!this._fullfilledPromise) {
    var self = this;
    if (this._endCalled) {
      console.warn("Warning: superagent request was sent twice, because both .end() and .then() were called. Never call .end() if you use promises");
    }
    this._fullfilledPromise = new Promise(function(innerResolve, innerReject) {
      self.end(function(err, res) {
        if (err) innerReject(err);
        else innerResolve(res);
      });
    });
  }
  return this._fullfilledPromise.then(resolve, reject);
};

RequestBase.prototype['catch'] = function(cb) {
  return this.then(undefined, cb);
};

/**
 * Allow for extension
 */

RequestBase.prototype.use = function use(fn) {
  fn(this);
  return this;
};

RequestBase.prototype.ok = function(cb) {
  if ('function' !== typeof cb) throw Error("Callback required");
  this._okCallback = cb;
  return this;
};

RequestBase.prototype._isResponseOK = function(res) {
  if (!res) {
    return false;
  }

  if (this._okCallback) {
    return this._okCallback(res);
  }

  return res.status >= 200 && res.status < 300;
};

/**
 * Get request header `field`.
 * Case-insensitive.
 *
 * @param {String} field
 * @return {String}
 * @api public
 */

RequestBase.prototype.get = function(field){
  return this._header[field.toLowerCase()];
};

/**
 * Get case-insensitive header `field` value.
 * This is a deprecated internal API. Use `.get(field)` instead.
 *
 * (getHeader is no longer used internally by the superagent code base)
 *
 * @param {String} field
 * @return {String}
 * @api private
 * @deprecated
 */

RequestBase.prototype.getHeader = RequestBase.prototype.get;

/**
 * Set header `field` to `val`, or multiple fields with one object.
 * Case-insensitive.
 *
 * Examples:
 *
 *      req.get('/')
 *        .set('Accept', 'application/json')
 *        .set('X-API-Key', 'foobar')
 *        .end(callback);
 *
 *      req.get('/')
 *        .set({ Accept: 'application/json', 'X-API-Key': 'foobar' })
 *        .end(callback);
 *
 * @param {String|Object} field
 * @param {String} val
 * @return {Request} for chaining
 * @api public
 */

RequestBase.prototype.set = function(field, val){
  if (isObject(field)) {
    for (var key in field) {
      this.set(key, field[key]);
    }
    return this;
  }
  this._header[field.toLowerCase()] = val;
  this.header[field] = val;
  return this;
};

/**
 * Remove header `field`.
 * Case-insensitive.
 *
 * Example:
 *
 *      req.get('/')
 *        .unset('User-Agent')
 *        .end(callback);
 *
 * @param {String} field
 */
RequestBase.prototype.unset = function(field){
  delete this._header[field.toLowerCase()];
  delete this.header[field];
  return this;
};

/**
 * Write the field `name` and `val`, or multiple fields with one object
 * for "multipart/form-data" request bodies.
 *
 * ``` js
 * request.post('/upload')
 *   .field('foo', 'bar')
 *   .end(callback);
 *
 * request.post('/upload')
 *   .field({ foo: 'bar', baz: 'qux' })
 *   .end(callback);
 * ```
 *
 * @param {String|Object} name
 * @param {String|Blob|File|Buffer|fs.ReadStream} val
 * @return {Request} for chaining
 * @api public
 */
RequestBase.prototype.field = function(name, val) {
  // name should be either a string or an object.
  if (null === name || undefined === name) {
    throw new Error('.field(name, val) name can not be empty');
  }

  if (this._data) {
    console.error(".field() can't be used if .send() is used. Please use only .send() or only .field() & .attach()");
  }

  if (isObject(name)) {
    for (var key in name) {
      this.field(key, name[key]);
    }
    return this;
  }

  if (Array.isArray(val)) {
    for (var i in val) {
      this.field(name, val[i]);
    }
    return this;
  }

  // val should be defined now
  if (null === val || undefined === val) {
    throw new Error('.field(name, val) val can not be empty');
  }
  if ('boolean' === typeof val) {
    val = '' + val;
  }
  this._getFormData().append(name, val);
  return this;
};

/**
 * Abort the request, and clear potential timeout.
 *
 * @return {Request}
 * @api public
 */
RequestBase.prototype.abort = function(){
  if (this._aborted) {
    return this;
  }
  this._aborted = true;
  this.xhr && this.xhr.abort(); // browser
  this.req && this.req.abort(); // node
  this.clearTimeout();
  this.emit('abort');
  return this;
};

RequestBase.prototype._auth = function(user, pass, options, base64Encoder) {
  switch (options.type) {
    case 'basic':
      this.set('Authorization', 'Basic ' + base64Encoder(user + ':' + pass));
      break;

    case 'auto':
      this.username = user;
      this.password = pass;
      break;

    case 'bearer': // usage would be .auth(accessToken, { type: 'bearer' })
      this.set('Authorization', 'Bearer ' + user);
      break;
  }
  return this;
};

/**
 * Enable transmission of cookies with x-domain requests.
 *
 * Note that for this to work the origin must not be
 * using "Access-Control-Allow-Origin" with a wildcard,
 * and also must set "Access-Control-Allow-Credentials"
 * to "true".
 *
 * @api public
 */

RequestBase.prototype.withCredentials = function(on) {
  // This is browser-only functionality. Node side is no-op.
  if (on == undefined) on = true;
  this._withCredentials = on;
  return this;
};

/**
 * Set the max redirects to `n`. Does noting in browser XHR implementation.
 *
 * @param {Number} n
 * @return {Request} for chaining
 * @api public
 */

RequestBase.prototype.redirects = function(n){
  this._maxRedirects = n;
  return this;
};

/**
 * Maximum size of buffered response body, in bytes. Counts uncompressed size.
 * Default 200MB.
 *
 * @param {Number} n
 * @return {Request} for chaining
 */
RequestBase.prototype.maxResponseSize = function(n){
  if ('number' !== typeof n) {
    throw TypeError("Invalid argument");
  }
  this._maxResponseSize = n;
  return this;
};

/**
 * Convert to a plain javascript object (not JSON string) of scalar properties.
 * Note as this method is designed to return a useful non-this value,
 * it cannot be chained.
 *
 * @return {Object} describing method, url, and data of this request
 * @api public
 */

RequestBase.prototype.toJSON = function() {
  return {
    method: this.method,
    url: this.url,
    data: this._data,
    headers: this._header,
  };
};

/**
 * Send `data` as the request body, defaulting the `.type()` to "json" when
 * an object is given.
 *
 * Examples:
 *
 *       // manual json
 *       request.post('/user')
 *         .type('json')
 *         .send('{"name":"tj"}')
 *         .end(callback)
 *
 *       // auto json
 *       request.post('/user')
 *         .send({ name: 'tj' })
 *         .end(callback)
 *
 *       // manual x-www-form-urlencoded
 *       request.post('/user')
 *         .type('form')
 *         .send('name=tj')
 *         .end(callback)
 *
 *       // auto x-www-form-urlencoded
 *       request.post('/user')
 *         .type('form')
 *         .send({ name: 'tj' })
 *         .end(callback)
 *
 *       // defaults to x-www-form-urlencoded
 *      request.post('/user')
 *        .send('name=tobi')
 *        .send('species=ferret')
 *        .end(callback)
 *
 * @param {String|Object} data
 * @return {Request} for chaining
 * @api public
 */

RequestBase.prototype.send = function(data){
  var isObj = isObject(data);
  var type = this._header['content-type'];

  if (this._formData) {
    console.error(".send() can't be used if .attach() or .field() is used. Please use only .send() or only .field() & .attach()");
  }

  if (isObj && !this._data) {
    if (Array.isArray(data)) {
      this._data = [];
    } else if (!this._isHost(data)) {
      this._data = {};
    }
  } else if (data && this._data && this._isHost(this._data)) {
    throw Error("Can't merge these send calls");
  }

  // merge
  if (isObj && isObject(this._data)) {
    for (var key in data) {
      this._data[key] = data[key];
    }
  } else if ('string' == typeof data) {
    // default to x-www-form-urlencoded
    if (!type) this.type('form');
    type = this._header['content-type'];
    if ('application/x-www-form-urlencoded' == type) {
      this._data = this._data
        ? this._data + '&' + data
        : data;
    } else {
      this._data = (this._data || '') + data;
    }
  } else {
    this._data = data;
  }

  if (!isObj || this._isHost(data)) {
    return this;
  }

  // default to json
  if (!type) this.type('json');
  return this;
};

/**
 * Sort `querystring` by the sort function
 *
 *
 * Examples:
 *
 *       // default order
 *       request.get('/user')
 *         .query('name=Nick')
 *         .query('search=Manny')
 *         .sortQuery()
 *         .end(callback)
 *
 *       // customized sort function
 *       request.get('/user')
 *         .query('name=Nick')
 *         .query('search=Manny')
 *         .sortQuery(function(a, b){
 *           return a.length - b.length;
 *         })
 *         .end(callback)
 *
 *
 * @param {Function} sort
 * @return {Request} for chaining
 * @api public
 */

RequestBase.prototype.sortQuery = function(sort) {
  // _sort default to true but otherwise can be a function or boolean
  this._sort = typeof sort === 'undefined' ? true : sort;
  return this;
};

/**
 * Compose querystring to append to req.url
 *
 * @api private
 */
RequestBase.prototype._finalizeQueryString = function(){
  var query = this._query.join('&');
  if (query) {
    this.url += (this.url.indexOf('?') >= 0 ? '&' : '?') + query;
  }
  this._query.length = 0; // Makes the call idempotent

  if (this._sort) {
    var index = this.url.indexOf('?');
    if (index >= 0) {
      var queryArr = this.url.substring(index + 1).split('&');
      if ('function' === typeof this._sort) {
        queryArr.sort(this._sort);
      } else {
        queryArr.sort();
      }
      this.url = this.url.substring(0, index) + '?' + queryArr.join('&');
    }
  }
};

// For backwards compat only
RequestBase.prototype._appendQueryString = function() {console.trace("Unsupported");}

/**
 * Invoke callback with timeout error.
 *
 * @api private
 */

RequestBase.prototype._timeoutError = function(reason, timeout, errno){
  if (this._aborted) {
    return;
  }
  var err = new Error(reason + timeout + 'ms exceeded');
  err.timeout = timeout;
  err.code = 'ECONNABORTED';
  err.errno = errno;
  this.timedout = true;
  this.abort();
  this.callback(err);
};

RequestBase.prototype._setTimeouts = function() {
  var self = this;

  // deadline
  if (this._timeout && !this._timer) {
    this._timer = setTimeout(function(){
      self._timeoutError('Timeout of ', self._timeout, 'ETIME');
    }, this._timeout);
  }
  // response timeout
  if (this._responseTimeout && !this._responseTimeoutTimer) {
    this._responseTimeoutTimer = setTimeout(function(){
      self._timeoutError('Response timeout of ', self._responseTimeout, 'ETIMEDOUT');
    }, this._responseTimeout);
  }
};

},{"./is-object":34}],36:[function(require,module,exports){
'use strict';

/**
 * Module dependencies.
 */

var utils = require('./utils');

/**
 * Expose `ResponseBase`.
 */

module.exports = ResponseBase;

/**
 * Initialize a new `ResponseBase`.
 *
 * @api public
 */

function ResponseBase(obj) {
  if (obj) return mixin(obj);
}

/**
 * Mixin the prototype properties.
 *
 * @param {Object} obj
 * @return {Object}
 * @api private
 */

function mixin(obj) {
  for (var key in ResponseBase.prototype) {
    obj[key] = ResponseBase.prototype[key];
  }
  return obj;
}

/**
 * Get case-insensitive `field` value.
 *
 * @param {String} field
 * @return {String}
 * @api public
 */

ResponseBase.prototype.get = function(field) {
  return this.header[field.toLowerCase()];
};

/**
 * Set header related properties:
 *
 *   - `.type` the content type without params
 *
 * A response of "Content-Type: text/plain; charset=utf-8"
 * will provide you with a `.type` of "text/plain".
 *
 * @param {Object} header
 * @api private
 */

ResponseBase.prototype._setHeaderProperties = function(header){
    // TODO: moar!
    // TODO: make this a util

    // content-type
    var ct = header['content-type'] || '';
    this.type = utils.type(ct);

    // params
    var params = utils.params(ct);
    for (var key in params) this[key] = params[key];

    this.links = {};

    // links
    try {
        if (header.link) {
            this.links = utils.parseLinks(header.link);
        }
    } catch (err) {
        // ignore
    }
};

/**
 * Set flags such as `.ok` based on `status`.
 *
 * For example a 2xx response will give you a `.ok` of __true__
 * whereas 5xx will be __false__ and `.error` will be __true__. The
 * `.clientError` and `.serverError` are also available to be more
 * specific, and `.statusType` is the class of error ranging from 1..5
 * sometimes useful for mapping respond colors etc.
 *
 * "sugar" properties are also defined for common cases. Currently providing:
 *
 *   - .noContent
 *   - .badRequest
 *   - .unauthorized
 *   - .notAcceptable
 *   - .notFound
 *
 * @param {Number} status
 * @api private
 */

ResponseBase.prototype._setStatusProperties = function(status){
    var type = status / 100 | 0;

    // status / class
    this.status = this.statusCode = status;
    this.statusType = type;

    // basics
    this.info = 1 == type;
    this.ok = 2 == type;
    this.redirect = 3 == type;
    this.clientError = 4 == type;
    this.serverError = 5 == type;
    this.error = (4 == type || 5 == type)
        ? this.toError()
        : false;

    // sugar
    this.created = 201 == status;
    this.accepted = 202 == status;
    this.noContent = 204 == status;
    this.badRequest = 400 == status;
    this.unauthorized = 401 == status;
    this.notAcceptable = 406 == status;
    this.forbidden = 403 == status;
    this.notFound = 404 == status;
    this.unprocessableEntity = 422 == status;
};

},{"./utils":37}],37:[function(require,module,exports){
'use strict';

/**
 * Return the mime type for the given `str`.
 *
 * @param {String} str
 * @return {String}
 * @api private
 */

exports.type = function(str){
  return str.split(/ *; */).shift();
};

/**
 * Return header field parameters.
 *
 * @param {String} str
 * @return {Object}
 * @api private
 */

exports.params = function(str){
  return str.split(/ *; */).reduce(function(obj, str){
    var parts = str.split(/ *= */);
    var key = parts.shift();
    var val = parts.shift();

    if (key && val) obj[key] = val;
    return obj;
  }, {});
};

/**
 * Parse Link header fields.
 *
 * @param {String} str
 * @return {Object}
 * @api private
 */

exports.parseLinks = function(str){
  return str.split(/ *, */).reduce(function(obj, str){
    var parts = str.split(/ *; */);
    var url = parts[0].slice(1, -1);
    var rel = parts[1].split(/ *= */)[1].slice(1, -1);
    obj[rel] = url;
    return obj;
  }, {});
};

/**
 * Strip content related fields from `header`.
 *
 * @param {Object} header
 * @return {Object} header
 * @api private
 */

exports.cleanHeader = function(header, changesOrigin){
  delete header['content-type'];
  delete header['content-length'];
  delete header['transfer-encoding'];
  delete header['host'];
  // secuirty
  if (changesOrigin) {
    delete header['authorization'];
    delete header['cookie'];
  }
  return header;
};

},{}],38:[function(require,module,exports){
/* Citation controller */

'use strict';

module.exports = function (Module, App, Backbone) {

  var searchIndex = require('../search')(Backbone);

  var showBookRefs = function (terms) {

    App.addRegions({
      BookRefs: '#search-book-refs'
    });

    terms = decodeURIComponent(terms.replace(/\+/g, '%20'));

    if (terms) {
      searchIndex(terms, function (results) {
        if (results.length) {

          App.addRegions({
            'BookRefs': '#search-book-refs'
          });
          App.BookRefs.show(Module.Views.Layout);

          Module.Views.Layout.showChildView('bookRefs', new Module.Views.BookRef.CollectionView({
            collection: new Module.Models.BookRef.Collection(results)
          }));

        }
      });
    }

  };

  return Backbone.Marionette.Controller.extend({
    showBookRefs: showBookRefs
  });

};

},{"../search":42}],39:[function(require,module,exports){
/* Book index module */

module.exports = function (Module, App, Backbone) {

  'use strict';

  require('./models/book-ref-model.js')(Module, App, Backbone);
  require('./views/layout-view.js')(Module, App, Backbone);
  require('./views/book-ref-view.js')(Module, App, Backbone);

  var Router = require('./routers')(Module, App, Backbone);
  var Controller = require('./controllers')(Module, App, Backbone);

  App.addInitializer(function () {
    Module.router = new Router({
      controller: new Controller()
    });
  });

};

},{"./controllers":38,"./models/book-ref-model.js":40,"./routers":41,"./views/book-ref-view.js":45,"./views/layout-view.js":46}],40:[function(require,module,exports){
/* Book reference model */

'use strict';

module.exports = function (Module, App, Backbone) {

  var Model = Backbone.Model.extend({

    defaults: {
      name: '',
      ref: ''
    }

  });

  var Collection = Backbone.Collection.extend({
    model: Model
  });

  Module.Models = Module.Models || {};

  Module.Models.BookRef = {
    Model: Model,
    Collection: Collection
  };

};

},{}],41:[function(require,module,exports){
/* Book index router */

'use strict';

module.exports = function (Module, App, Backbone) {
  return Backbone.Marionette.AppRouter.extend({
    appRoutes: {
      '?s=:terms': 'showBookRefs'
    }
  });
};

},{}],42:[function(require,module,exports){
/* Book index search */

module.exports = function (Backbone) {

  'use strict';

  var Bloodhound = require('bloodhound-js');
  var indexTerms = require('../../data/index.json');

  var _ = Backbone._;

  var engine = new Bloodhound({
    local: indexTerms,
    identify: function (obj) {
      return obj.id;
    },
    queryTokenizer: Bloodhound.tokenizers.whitespace,
    datumTokenizer: function (d) {
      return Bloodhound.tokenizers.whitespace(d.name);
    }
  });

  // Build simplified results array from Bloodhound matches.
  var buildResults = function (data, cb) {

    var sortedData = _.sortBy(data, function (datum) {
      return datum.parent;
    });

    var results = [];

    // Parse results.
    _.each(sortedData, function (datum) {
      // Only proceed if the reference exists and has not already been added.
      if (datum.ref && _.findWhere(results, {ref: datum.ref}) === undefined) {
        results.push({
          name: datum.name,
          ref: datum.ref
        });
      }
    });

    // Format page numbers and section references.
    _.each(results, function (result) {
      var refs = result.ref.split(', ');
      result.ref = _.map(refs, function (ref) {
        if (ref.indexOf('.') !== -1) {
          return '<em>' + ref + '</em>';
        } else if (ref.indexOf('–') !== -1) {
          return 'pps. ' + ref;
        } else {
          return 'p. ' + ref;
        }
      }).join(', ');
    });

    cb(results);

  };

  // Initialize Bloodhound.
  var promise = engine.initialize();

  // Export search function.
  return function (terms, cb) {
    promise.then(function () {
      engine.search(terms, function (data) {
        buildResults(data, cb);
      });
    });
  };

};

},{"../../data/index.json":57,"bloodhound-js":8}],43:[function(require,module,exports){
(function (global){
var _ = (typeof window !== "undefined" ? window['_'] : typeof global !== "undefined" ? global['_'] : null);
module.exports = function(data){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
__p+='<strong>'+
((__t=( data.name + ':' ))==null?'':__t)+
'</strong> '+
((__t=( data.ref ))==null?'':__t)+
'\n';
return __p;
};

}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})

},{}],44:[function(require,module,exports){
(function (global){
var _ = (typeof window !== "undefined" ? window['_'] : typeof global !== "undefined" ? global['_'] : null);
module.exports = function(data){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
__p+='<h4>From the <em>Handbook</em></h4>\n<p>You will also find content related to your search terms in the <em>Handbook</em>. Numbers in <em>italic</em> are section references.</p>\n<div id="book-refs"></div>\n';
return __p;
};

}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})

},{}],45:[function(require,module,exports){
/* Book reference views */

'use strict';


module.exports = function (Module, App, Backbone) {

  var ItemView = Backbone.Marionette.ItemView.extend({
    tagName: 'p',
    className: 'book-ref',
    template: require('../templates/book-ref.tpl')
  });

  var CollectionView = Backbone.Marionette.CollectionView.extend({
    childView: ItemView,
    tagName: 'div',
    className: 'book-refs'
  });

  Module.Views = Module.Views || {};

  Module.Views.BookRef = {
    ItemView: ItemView,
    CollectionView: CollectionView
  };

};

},{"../templates/book-ref.tpl":43}],46:[function(require,module,exports){
/* Layout view */

'use strict';

module.exports = function (Module, App, Backbone) {

  var Layout = Backbone.Marionette.LayoutView.extend({

    template: require('../templates/layout.tpl'),

    regions: {
      bookRefs: '#book-refs'
    }

  });

  Module.Views = Module.Views || {};
  Module.Views.Layout = new Layout();

};

},{"../templates/layout.tpl":44}],47:[function(require,module,exports){
/* FAQ module */

/*global document*/

module.exports = function ($) {

  'use strict';

  /**
   * since author tiles are used on various sections but have to not link on behind-the-style,
   * disable link functionality here rather than duplicating markup
   */
  $('.category-behind-the-style .instructor-tile a, .category-teaching-resources .instructor-tile a').each(function() {
    $(this).css({ 'cursor': 'default' });
    $(this).on('click', function(e) {
      e.preventDefault();
    });
  });

};

},{}],48:[function(require,module,exports){
/* Citation controller */

'use strict';

module.exports = function (Module, App, Backbone) {

  var citationData = require('../../data/citations.json');

  var showCitationForm = function (citationType) {

    citationType = citationType || 'empty';

    App.Content.show(Module.Views.Layout, {
      forceShow: true,
      preventDestroy: true
    });

    Module.Views.Layout.showChildView('form', new Module.Views.Citation.CollectionView({
      collection: new Module.Models.Citation.Collection(citationData[citationType])
    }));

  };

  return Backbone.Marionette.Controller.extend({
    showCitationForm: showCitationForm
  });

};

},{"../../data/citations.json":56}],49:[function(require,module,exports){
/* Citation module */

module.exports = function (Module, App, Backbone) {

  'use strict';

  require('./models/citation-model.js')(Module, App, Backbone);
  require('./views/citation-view.js')(Module, App, Backbone);
  require('./views/layout-view.js')(Module, App, Backbone);

  var Router = require('./routers')(Module, App, Backbone);
  var Controller = require('./controllers')(Module, App, Backbone);

  App.addInitializer(function () {
    Module.router = new Router({
      controller: new Controller()
    });
  });

};

},{"./controllers":48,"./models/citation-model.js":50,"./routers":51,"./views/citation-view.js":54,"./views/layout-view.js":55}],50:[function(require,module,exports){
/* Citation model */

'use strict';

module.exports = function (Module, App, Backbone) {

  Module.Models = Module.Models || {};

  var _ = Backbone._;

  var Model = Backbone.Model.extend({

    defaults: function () {
      return {

        title: '',
        author: '',
        version: '',
        number: '',
        publisher: '',
        pubdate: '',
        location: '',

        container: true,
        containerNumber: 1,

        schema: {
          source: {
            author: {
              name: 'Author',
              punctuation: '.'
            },
            title: {
              name: 'Title of source',
              punctuation: '.'
            }
          },
          container: {
            title: {
              name: 'Title of container',
              punctuation: ','
            },
            author: {
              name: 'Other contributors',
              punctuation: ','
            },
            version: {
              name: 'Version',
              punctuation: ','
            },
            number: {
              name: 'Number',
              punctuation: ','
            },
            publisher: {
              name: 'Publisher',
              punctuation: ','
            },
            pubdate: {
              name: 'Publication date',
              punctuation: ','
            },
            location: {
              name: 'Location',
              punctuation: '.'
            }
          }
        },

        callouts: {},
        classNames: {},
        images: {},

        order: this.collection.nextOrder()
      };
    },

    setClassNames: function () {
      var modelAttrs = this.attributes;
      var classNames = {};

      _.each(_.keys(modelAttrs.schema.container), function (attr) {
        var attrClassNames = [];

        if (modelAttrs[attr]) {
          attrClassNames.push('has-value');
        }

        if (modelAttrs.callouts[attr]) {
          attrClassNames.push('has-callout');
        }

        if (modelAttrs.images[attr]) {
          attrClassNames.push('has-image');
        }

        classNames[attr] = attrClassNames.join(' ');
      });

      this.set({
        classNames: classNames
      });
    },

    getCitationString: function () {

      var modelAttrs = this.attributes;

      var formatAttribute = function (attr, str) {
        return str.replace(/_([^_]+)_/g, '<em>$1</em>');
      };

      var filterAttrs = (modelAttrs.container) ? _.keys(modelAttrs.schema.container) : _.keys(modelAttrs.schema.source);

      // Filter attributes for valid string values, then reduce to a
      // citation string.
      var attrs = _.filter(filterAttrs, function (attr) {
        var val = modelAttrs[attr];
        return (typeof val === 'string' && val.replace(/\s/g, '') !== '');
      });

      var citation = attrs.map(function (attr) {
        return '<span class="field-' + attr + '">' + formatAttribute(attr, modelAttrs[attr]) + '</span>';
      });

      // Wrap in span.
      return '<span class="container-' + this.attributes.order + '">' + citation.join(' ') + '</span> ';

    }

  });

  var Collection = Backbone.Collection.extend({

    model: Model,
    comparator: 'order',

    initialize: function () {
      this.bind('add remove', this.updateNumbers);
    },

    updateNumbers: function () {
      this.each(function (model, i) {
        model.set('containerNumber', i);
      });
    },

    counter: 0,

    nextOrder: function () {
      this.counter = this.counter + 1;
      return this.counter;
    }

  });

  Module.Models.Citation = {
    Model: Model,
    Collection: Collection
  };

};

},{}],51:[function(require,module,exports){
/* Citation router */

'use strict';

module.exports = function (Module, App, Backbone) {
  return Backbone.Marionette.AppRouter.extend({
    appRoutes: {
      'whats-new/': 'showCitationForm',
      'works-cited-a-quick-guide-:type/': 'showCitationForm'
    }
  });
};

},{}],52:[function(require,module,exports){
(function (global){
var _ = (typeof window !== "undefined" ? window['_'] : typeof global !== "undefined" ? global['_'] : null);
module.exports = function(data){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
__p+='<div id="citation-form"></div>\n<div class="citation-output">\n  <h4 class="citation-output-head">Final works-cited-list entry</h4>\n  <p id="citation-el"></p>\n</div>\n<div id="citation-lightbox-placeholder" class="lity-hide"></div>\n';
return __p;
};

}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})

},{}],53:[function(require,module,exports){
(function (global){
var _ = (typeof window !== "undefined" ? window['_'] : typeof global !== "undefined" ? global['_'] : null);
module.exports = function(data){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
__p+='';
 var attrs = (data.container) ? data.schema.container : data.schema.source 
__p+='\n\n';
 if (data.container) { 
__p+='\n<h3>Container '+
((__t=( data.order - 1 ))==null?'':__t)+
'</h3>\n';
 } 
__p+='\n\n';
 _.each(attrs, function (value, key) { 
__p+='\n<p class="citation-field '+
((__t=( data.classNames[key] ))==null?'':__t)+
'" data-name="'+
((__t=( key ))==null?'':__t)+
'">\n  <label for="container-title-'+
((__t=( data.order ))==null?'':__t)+
'">'+
((__t=( value.name ))==null?'':__t)+
'<span class="punctuation">'+
((__t=( value.punctuation ))==null?'':__t)+
'</span></label>\n  <span id="container-title-'+
((__t=( data.order ))==null?'':__t)+
'" class="field-value">'+
((__t=( data[key] ))==null?'':__t)+
'</span>\n  <span data-lity-image="'+
((__t=( data.images[key] ))==null?'':__t)+
'" class="image-link"></span>\n</p>\n';
 }); 
__p+='\n';
return __p;
};

}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})

},{}],54:[function(require,module,exports){
/* Citation views */

/*global wp_theme*/

'use strict';

var popup = require('modui-popup');
var lity = require('lity');

var template = require('../templates/container-form.tpl');

module.exports = function (Module, App, Backbone) {

  var $ = Backbone.$;
  var _ = Backbone._;

  var ItemView = Backbone.Marionette.ItemView.extend({

    tagName: 'fieldset',
    template: template,

    className: function () {
      return this.model.get('container') ? 'container' : 'source';
    },

    events: {
      'click .remove-container': 'removeContainer',
      'click .citation-field': 'maybeShowPopup',
      'click .image-link': 'showLightbox',
      'keyup input': 'updateField'
    },

    onRender: function () {
      var view = this;
      setTimeout(function () {
        $('.has-callout').each(function () {
          view.showPopup($(this), $(this).data('name'));
        });
      }, 1000);
    },

    updateField: function (evt) {
      var $field = $(evt.target);
      var newAttr = {};
      newAttr[$field.attr('name')] = $field.val();
      this.model.set(newAttr);
    },

    removeContainer: function () {
      this.model.collection.remove(this.model);
    },

    showPopup: function ($target, fieldName) {
      if (this.model.attributes.callouts[fieldName]) {
        popup.open({
          target: $target,
          position: 'right center',
          contents: this.model.attributes.callouts[fieldName]
        });
      }
    },

    maybeShowPopup: function (evt) {
      var $target = $(evt.target).closest('.citation-field');
      var fieldName = $target.data('name');
      this.showPopup($target, fieldName);
    },

    showLightbox: function (evt) {
      var lightbox = lity();
      var imageURL = $(evt.target).data('lity-image');
      // jscs:disable requireCamelCaseOrUpperCaseIdentifiers
      lightbox(wp_theme.asset_path + imageURL);
      // jscs:enable
    },

    serializeData: function () {
      this.model.setClassNames();
      return this.model.toJSON();
    }

  });

  var CollectionView = Backbone.Marionette.CollectionView.extend({

    childView: ItemView,
    tagName: 'div',
    className: 'citation',

    events: {
      'click .add-container': 'addContainer',
      'keyup input': 'updateCitation'
    },

    onRender: function () {
      this.updateCitation();
    },

    addContainer: function () {
      this.collection.add({});
    },

    onRemoveChild: function () {
      this.updateCitation();
    },

    updateCitation: function () {
      var citation = _.map(this.collection.models, function (model) {
        return model.getCitationString();
      });
      $('#citation-el').html(citation.join(''));
    }

  });

  Module.Views = Module.Views || {};

  Module.Views.Citation = {
    ItemView: ItemView,
    CollectionView: CollectionView
  };

};

},{"../templates/container-form.tpl":53,"lity":23,"modui-popup":25}],55:[function(require,module,exports){
/* Layout view */

'use strict';

module.exports = function (Module, App, Backbone) {

  var layoutTemplate = require('../templates/citation-layout.tpl');

  var Layout = Backbone.Marionette.LayoutView.extend({

    template: layoutTemplate,
    className: 'citation-template',

    regions: {
      output: '#citation-output',
      form: '#citation-form'
    }

  });

  Module.Views = Module.Views || {};
  Module.Views.Layout = new Layout();

};

},{"../templates/citation-layout.tpl":52}],56:[function(require,module,exports){
module.exports={
  'empty': [
    {
      container: false,
    },
    {}
  ],
  'book': [
    {
      author: 'Copeland, Edward.',
      title: '“Money.”',
      container: false,
      images: {
        author: '/assets/images/citation-book-3.png',
        title: '/assets/images/citation-book-3.png'
      }
    },
    {
      title: '<em>The Cambridge Companion to Jane Austen</em>,',
      author: 'edited by Copeland and Juliet McMaster,',
      publisher: 'Cambridge UP,',
      pubdate: '1997,',
      location: 'pp. 131-48.',
      callouts: {
        version: 'For guidance on when to skip items in the template, see p. 20 of the <em>MLA Handbook</em>.'
      },
      images: {
        author: '/assets/images/citation-book-1.png',
        title: '/assets/images/citation-book-1.png',
        publisher: '/assets/images/citation-book-1.png',
        pubdate: '/assets/images/citation-book-2.png',
        location: '/assets/images/citation-book-3.png'
      }
    }
  ],
  'video': [
    {
      title: '“<em>Curiosity</em> Rover Report (August 2015): Three Years on Mars!”',
      container: false,
      callouts: {
        author: 'This source has no author. See pp. 24 and 55–56 of the <em>MLA Handbook</em> for more guidance.'
      },
      images: {
        title: '/assets/images/citation-video-1.png'
      }
    },
    {
      title: '<em>NASA’s Journey to Mars: Videos</em>,',
      author: 'edited by Sarah Loff,',
      publisher: 'National Aeronautics and Space Administration,',
      pubdate: '30 July 2015,',
      location: 'www.nasa.gov/topics/journeytomars/videos/index.html.',
      images: {
        author: '/assets/images/citation-video-1.png',
        title: '/assets/images/citation-video-1.png',
        publisher: '/assets/images/citation-video-1.png',
        pubdate: '/assets/images/citation-video-1.png',
        location: '/assets/images/citation-video-1.png',
      }
    }
  ],
  'journal': [
    {
      title: '“Between Image and Word, Color, and Time: Jacob Lawrence’s <em>The Migration Series</em>.”',
      author: 'Lorensen, Jutta.',
      container: false,
      images: {
        author: '/assets/images/citation-journal-1.png',
        title: '/assets/images/citation-journal-1.png'
      }
    },
    {
      title: '<em>African American Review</em>,',
      number: 'vol. 40, no. 3,',
      pubdate: '2006,',
      location: 'pp. 571-86.',
      images: {
        title: '/assets/images/citation-journal-1.png',
        number: '/assets/images/citation-journal-1.png',
        pubdate: '/assets/images/citation-journal-1.png',
        location: '/assets/images/citation-journal-1.png'
      }
    },
    {
      title: '<em>EBSCOHost</em>,',
      location: 'search.ebscohost.com/login.aspx?direct=true&db=f5h&AN=24093790&site=ehost-live.',
      callouts: {
        title: 'Learn where to find publication information for online sources and when to omit a publisher’s name on pp. 17 and 42 of the <em>MLA Handbook</em>.'
      },
      images: {
        title: '/assets/images/citation-journal-1.png',
        location: '/assets/images/citation-journal-1.png'
      }
    }
  ]
}

},{}],57:[function(require,module,exports){
module.exports=[{"id":1,"name":"in online usernames @","parent":null,"ref":"24"},{"id":1001,"name":"in online usernames @ ignored in alphabetization","parent":1,"ref":"2.7.1"},{"id":3,"name":"abbreviations","parent":null,"ref":"1.6"},{"id":1002,"name":"abbreviations of common academic terms","parent":3,"ref":"1.6.2"},{"id":2001,"name":"in in-text citations authors’ first names","parent":1003,"ref":"55"},{"id":2002,"name":"in in-text citations corporate authors","parent":1003,"ref":"3.1.2"},{"id":2003,"name":"in in-text citations indirect sources (<em>qtd. in</em>)","parent":1003,"ref":"3.4"},{"id":2004,"name":"in in-text citations three or more authors (<em>et al.</em>)","parent":1003,"ref":"3.1.1"},{"id":2005,"name":"in in-text citations titles of sources","parent":1003,"ref":"55–56, 1.6.4, 3.2.1"},{"id":2006,"name":"in text numbers with abbreviations","parent":1004,"ref":"1.4.1"},{"id":2007,"name":"in text titles of sources","parent":1004,"ref":"1.2.3"},{"id":2008,"name":"in text use of periods","parent":1004,"ref":"1.6"},{"id":2009,"name":"in works-cited lists editions","parent":1005,"ref":"2.3"},{"id":2010,"name":"in works-cited lists months","parent":1005,"ref":"1.5, 1.6.1"},{"id":2011,"name":"in works-cited lists publishers’ names","parent":1005,"ref":"1.6.2–3"},{"id":2012,"name":"in works-cited lists versions","parent":1005,"ref":"2.3"},{"id":4,"name":"documentation styles in academic disciplines","parent":null,"ref":"5–6"},{"id":5,"name":"academic integrity","parent":null,"ref":"6"},{"id":6,"name":"names of academic presses","parent":null,"ref":"1.6.3"},{"id":1006,"name":"academic writing as conversation","parent":7,"ref":"x, xii–xiii, 5"},{"id":1007,"name":"academic writing cyclic nature of","parent":7,"ref":"12"},{"id":1008,"name":"academic writing diversity of","parent":7,"ref":"127–28"},{"id":1009,"name":"academic writing evaluating sources for","parent":7,"ref":"4, 10–12"},{"id":8,"name":"ignored in alphabetization accents","parent":null,"ref":"2.7.1"},{"id":9,"name":"for online sources access dates","parent":null,"ref":"53"},{"id":10,"name":"accuracy of quotations","parent":null,"ref":"1.3.1"},{"id":11,"name":"in works-cited lists actors","parent":null,"ref":"24"},{"id":13,"name":"street addresses","parent":null,"ref":"1.4.2"},{"id":1010,"name":"adjectives capitalized in titles","parent":14,"ref":"1.2.1"},{"id":1011,"name":"adjectives in languages other than English","parent":14,"ref":"1.2.5"},{"id":1012,"name":"adjectives in shortened titles","parent":14,"ref":"3.2.1"},{"id":1013,"name":"adverbs capitalized in titles","parent":15,"ref":"1.2.1"},{"id":1014,"name":"adverbs in languages other than English","parent":15,"ref":"1.2.5"},{"id":1015,"name":"adverbs in shortened titles","parent":15,"ref":"3.2.1"},{"id":1016,"name":"afterwords documenting","parent":16,"ref":"2.2.1"},{"id":1017,"name":"afterwords referred to in text","parent":16,"ref":"70"},{"id":17,"name":"<em>ALA-LC Romanization Tables</em>","parent":null,"ref":"64, 74"},{"id":1018,"name":"alphabetization of names not in English","parent":19,"ref":"1.1.4"},{"id":2013,"name":"of names not in English Asian languages","parent":1018,"ref":"63–64"},{"id":2014,"name":"of names not in English French","parent":1018,"ref":"64"},{"id":2015,"name":"of names not in English German","parent":1018,"ref":"64–65"},{"id":2016,"name":"of names not in English Italian","parent":1018,"ref":"65"},{"id":2017,"name":"of names not in English Latin","parent":1018,"ref":"65–66"},{"id":2018,"name":"of names not in English Spanish","parent":1018,"ref":"66"},{"id":1019,"name":"alphabetization in works-cited lists","parent":19,"ref":"2.7.1–4"},{"id":2019,"name":"in works-cited lists authors’ names","parent":1019,"ref":"21, 22, 2.7.2–3"},{"id":2020,"name":"in works-cited lists letter by letter","parent":1019,"ref":"2.7.1"},{"id":2021,"name":"in works-cited lists no author","parent":1019,"ref":"2.7.4"},{"id":2022,"name":"in works-cited lists titles","parent":1019,"ref":"2.7.4"},{"id":1020,"name":"<em>and</em> between authors’ names","parent":20,"ref":"21"},{"id":1021,"name":"<em>and</em> between editors’ names","parent":20,"ref":"23"},{"id":21,"name":"anonymous works","parent":null,"ref":"24, 55–56, 2.7.4"},{"id":1022,"name":"appendixes referred to in text","parent":23,"ref":"70"},{"id":1023,"name":"appendixes in Web projects works-cited lists as","parent":23,"ref":"128"},{"id":24,"name":"quotations and titles of sources in Arabic","parent":null,"ref":"74, 1.3.8"},{"id":1024,"name":"archives locations of objects in","parent":26,"ref":"49–50"},{"id":1025,"name":"archives online","parent":26,"ref":"11, 41–43, 45, 48"},{"id":27,"name":"works of Aristotle","parent":null,"ref":"122"},{"id":1026,"name":"<em>an</em> articles (<em>a</em> excluded in in-text citations","parent":28,"ref":"3.2.1"},{"id":1027,"name":"<em>an</em> articles (<em>a</em> ignored in alphabetization","parent":28,"ref":"2.7.4"},{"id":1028,"name":"<em>an</em> articles (<em>a</em> not capitalized in titles","parent":28,"ref":"1.2.1"},{"id":1029,"name":"<em>an</em> articles (<em>a</em> omitted in corporate author names","parent":28,"ref":"2.1.3"},{"id":1030,"name":"online and print articles quotation marks around titles of","parent":29,"ref":"1.2.2"},{"id":2023,"name":"in works-cited lists author’s names","parent":1031,"ref":"21, 24, 2.1.1"},{"id":2024,"name":"in works-cited lists digital platforms","parent":1031,"ref":"31, 32"},{"id":2025,"name":"in works-cited lists consecutive page numbers","parent":1031,"ref":"46"},{"id":2026,"name":"in works-cited lists not consecutive page numbers","parent":1031,"ref":"2.5.1"},{"id":2027,"name":"in works-cited lists pseudonyms","parent":1031,"ref":"24, 2.1.1"},{"id":2028,"name":"in works-cited lists publication dates","parent":1031,"ref":"42–43, 44–45"},{"id":2029,"name":"in works-cited lists republication in book collections","parent":1031,"ref":"53"},{"id":2030,"name":"in works-cited lists titles","parent":1031,"ref":"27–28, 30"},{"id":2031,"name":"in works-cited lists URLs and DOIs","parent":1031,"ref":"17, 48, 49, 128, 2.5.2"},{"id":1032,"name":"in works-cited lists artworks generic descriptions of","parent":30,"ref":"28–29"},{"id":1033,"name":"in works-cited lists artworks locations of","parent":30,"ref":"49–50"},{"id":1034,"name":"Asian languages names of persons in","parent":31,"ref":"62, 63–64, 2.1.1"},{"id":1035,"name":"Asian languages quotations and titles of sources in","parent":31,"ref":"74, 1.3.8"},{"id":33,"name":"authority of sources","parent":null,"ref":"4, 10–12"},{"id":1036,"name":"authors definition of","parent":34,"ref":"22–25"},{"id":1037,"name":"authors evaluating reliability of","parent":34,"ref":"11"},{"id":1038,"name":"authors’ names gathering information on","parent":35,"ref":"13, 14–17, 2.1"},{"id":1039,"name":"authors’ names in in-text citations","parent":35,"ref":"54–58"},{"id":2032,"name":"in in-text citations authors with same last names","parent":1039,"ref":"55"},{"id":2033,"name":"in in-text citations coauthors","parent":1039,"ref":"3.1.1"},{"id":2034,"name":"in in-text citations multiple works by one author","parent":1039,"ref":"55, 3.6"},{"id":2035,"name":"in in-text citations single authors","parent":1039,"ref":"54–55"},{"id":2036,"name":"in text first and subsequent uses of names","parent":1040,"ref":"1.1.1"},{"id":2037,"name":"in text names not in English","parent":1040,"ref":"1.1.4"},{"id":2038,"name":"in text pseudonyms and simplified names","parent":1040,"ref":"1.1.3"},{"id":2039,"name":"in text titles of persons","parent":1040,"ref":"1.1.2"},{"id":2040,"name":"in works-cited lists absence of author","parent":1041,"ref":"24, 55–56"},{"id":2042,"name":"in works-cited lists coauthors","parent":1041,"ref":"21–23, 2.7.3"},{"id":2043,"name":"in works-cited lists cross-references","parent":1041,"ref":"2.1.1, 2.7.5"},{"id":2044,"name":"in works-cited lists film and television personnel","parent":1041,"ref":"24"},{"id":2045,"name":"in works-cited lists married names","parent":1041,"ref":"2.1.1"},{"id":2046,"name":"in works-cited lists multiple works by one author","parent":1041,"ref":"2.1.3, 2.7.2"},{"id":2047,"name":"in works-cited lists pseudonyms and online usernames","parent":1041,"ref":"24, 2.1.1"},{"id":2048,"name":"in works-cited lists punctuation","parent":1041,"ref":"20, 21–22"},{"id":2049,"name":"in works-cited lists titles and suffixes","parent":1041,"ref":"72–74, 1.1.2, 2.1.2"},{"id":2050,"name":"in works-cited lists translators","parent":1041,"ref":"23"},{"id":2051,"name":"in works-cited lists variant forms of names","parent":1041,"ref":"2.1.1"},{"id":1042,"name":"Bible abbreviations for","parent":36,"ref":"1.6.4"},{"id":2052,"name":"abbreviations for Apocrypha","parent":1042,"ref":"99–100"},{"id":2053,"name":"abbreviations for New Testament","parent":1042,"ref":"99"},{"id":2054,"name":"abbreviations for Old Testament and Hebrew Bible","parent":1042,"ref":"97–99"},{"id":1043,"name":"Bible in in-text citations","parent":36,"ref":"122–23, 1.6.4, 3.2.1"},{"id":1044,"name":"Bible treatment of titles of in text","parent":36,"ref":"69"},{"id":1045,"name":"Bible in works-cited lists","parent":36,"ref":"38, 123, 2.3"},{"id":37,"name":"referred to in text bibliographies","parent":null,"ref":"70"},{"id":1046,"name":"blogs as parts of networks of blogs","parent":38,"ref":"31"},{"id":1047,"name":"blogs republication of posts","parent":38,"ref":"3"},{"id":2055,"name":"in works-cited lists comments","parent":1048,"ref":"29, 44"},{"id":2056,"name":"in works-cited lists publishers","parent":1048,"ref":"41–42"},{"id":2057,"name":"in works-cited lists titles","parent":1048,"ref":"28, 30"},{"id":2058,"name":"in works-cited lists URLs","parent":1048,"ref":"48"},{"id":1049,"name":"book collections digital platforms for","parent":39,"ref":"31, 34"},{"id":1050,"name":"book collections gathering information on","parent":39,"ref":"16"},{"id":2059,"name":"in works-cited lists cross-references","parent":1051,"ref":"2.7.5"},{"id":2060,"name":"in works-cited lists other contributors","parent":1051,"ref":"38"},{"id":2061,"name":"in works-cited lists page numbers","parent":1051,"ref":"46"},{"id":2062,"name":"in works-cited lists prior publication","parent":1051,"ref":"50, 53"},{"id":2063,"name":"in works-cited lists publication dates for articles","parent":1051,"ref":"42"},{"id":2064,"name":"in works-cited lists titles and subtitles","parent":1051,"ref":"26–27, 30, 35"},{"id":40,"name":"untitled book reviews","parent":null,"ref":"29"},{"id":2065,"name":"in text capitalization and punctuation of titles","parent":1053,"ref":"1.2.1"},{"id":2066,"name":"in text italics for titles","parent":1053,"ref":"1.2.2"},{"id":2067,"name":"in text referring to parts of books","parent":1053,"ref":"70"},{"id":2068,"name":"in text shortened titles","parent":1053,"ref":"1.2.3"},{"id":2069,"name":"in text titles not in English","parent":1053,"ref":"1.2.5"},{"id":2070,"name":"in text titles within titles","parent":1053,"ref":"1.2.4"},{"id":2071,"name":"in works-cited lists author’s names","parent":1054,"ref":"21–25, 2.1, 2.7.2–3"},{"id":2072,"name":"in works-cited lists editions","parent":1054,"ref":"38–39"},{"id":2073,"name":"in works-cited lists other contributors","parent":1054,"ref":"37–38"},{"id":2074,"name":"in works-cited lists prior publication","parent":1054,"ref":"50, 53"},{"id":2075,"name":"in works-cited lists publication dates","parent":1054,"ref":"15, 45, 46"},{"id":2076,"name":"in works-cited lists titles and subtitles","parent":1054,"ref":"25–27, 2.2"},{"id":1055,"name":"book series titles of","parent":42,"ref":"69"},{"id":1056,"name":"book series in works-cited lists","parent":42,"ref":"52"},{"id":2077,"name":"in text parts of works","parent":1057,"ref":"70"},{"id":2078,"name":"in text titles of sources in English","parent":1057,"ref":"1.2.1"},{"id":2079,"name":"in text titles of sources not in English","parent":1057,"ref":"1.2.5"},{"id":2080,"name":"in works-cited lists editions","parent":1058,"ref":"2.3"},{"id":2081,"name":"in works-cited lists generic descriptions of sources","parent":1058,"ref":"29"},{"id":2082,"name":"in works-cited lists prefaces introductions","parent":1058,"ref":"2.2.1"},{"id":2083,"name":"in works-cited lists titles of sources","parent":1058,"ref":"25–26, 1.2.1"},{"id":2084,"name":"in works-cited lists untitled sources","parent":1058,"ref":"29"},{"id":2085,"name":"in works-cited lists versions","parent":1058,"ref":"38–39, 2.3"},{"id":47,"name":"centuries","parent":null,"ref":"1.5"},{"id":49,"name":"referred to in text chapters","parent":null,"ref":"70"},{"id":50,"name":"fictional characters","parent":null,"ref":"1.1.3"},{"id":51,"name":"<em>The</em> <em>Chicago Manual of Style</em>","parent":null,"ref":"64, 74, 105"},{"id":1059,"name":"Chinese names of persons in","parent":52,"ref":"62, 63–64, 2.1.1"},{"id":1060,"name":"Chinese quotations and titles of sources in","parent":52,"ref":"74, 1.3.8"},{"id":53,"name":"<em>circa</em>","parent":null,"ref":"2.6.1"},{"id":1061,"name":"cities of publication of books","parent":55,"ref":"51"},{"id":1062,"name":"cities of publication of newspapers","parent":55,"ref":"2.6.1"},{"id":1063,"name":"coauthors in in-text citations","parent":56,"ref":"3.1.1"},{"id":1064,"name":"coauthors in works-cited lists","parent":56,"ref":"21–23, 2.7.3"},{"id":1065,"name":"colons before block quotations","parent":57,"ref":"87, 1.3.2–3"},{"id":1066,"name":"colons with quotation marks","parent":57,"ref":"89"},{"id":1067,"name":"colons in titles","parent":57,"ref":"1.2.1"},{"id":1068,"name":"comic books titles of","parent":58,"ref":"31"},{"id":1069,"name":"comic books volume and issue numbers of","parent":58,"ref":"40"},{"id":1070,"name":"commas in in-text citations","parent":59,"ref":"3.6"},{"id":1071,"name":"commas in numbers","parent":59,"ref":"1.4.2"},{"id":1072,"name":"commas with quotation marks","parent":59,"ref":"88–89"},{"id":1073,"name":"commas in works-cited lists","parent":59,"ref":"20, 2.6"},{"id":2086,"name":"in works-cited lists authors’ names","parent":1073,"ref":"21, 22"},{"id":2087,"name":"in works-cited lists other contributors","parent":1073,"ref":"37"},{"id":60,"name":"online comments","parent":null,"ref":"29, 44"},{"id":61,"name":"documentation unneeded for common knowledge","parent":null,"ref":"10"},{"id":62,"name":"in works-cited lists compilers","parent":null,"ref":"2.1.3"},{"id":63,"name":"conference titles","parent":null,"ref":"70"},{"id":64,"name":"in titles conjunctions","parent":null,"ref":"1.2.1"},{"id":66,"name":"copublishers","parent":null,"ref":"2.4"},{"id":1074,"name":"copyright pages publication dates on","parent":67,"ref":"15, 45, 46"},{"id":1075,"name":"copyright pages publishers’ names on","parent":67,"ref":"41"},{"id":1077,"name":"copyright pages in in-text citations","parent":67,"ref":"55–56, 3.1.2"},{"id":1078,"name":"copyright pages in works-cited lists","parent":67,"ref":"25, 2.1.3"},{"id":68,"name":"course titles","parent":null,"ref":"70"},{"id":1079,"name":"in works-cited lists cross-references for varying names of authors","parent":69,"ref":"2.1.1"},{"id":1080,"name":"in works-cited lists cross-references for works in collections","parent":69,"ref":"2.7.5"},{"id":70,"name":"<em>de</em> <em>da</em>","parent":null,"ref":"65"},{"id":72,"name":"dates and times","parent":null,"ref":"1.5"},{"id":1081,"name":"dates and times abbreviations for","parent":72,"ref":"1.6"},{"id":1082,"name":"dates and times for online works of access","parent":72,"ref":"53"},{"id":73,"name":"<em>del</em> <em>de</em>","parent":null,"ref":"66"},{"id":74,"name":"<em>du</em> <em>de</em>","parent":null,"ref":"64"},{"id":1083,"name":"descriptive terms prefaces for documenting introductions","parent":75,"ref":"2.2.1"},{"id":1084,"name":"descriptive terms for editors","parent":75,"ref":"23"},{"id":1085,"name":"descriptive terms for film and television personnel","parent":75,"ref":"24"},{"id":1086,"name":"descriptive terms for other contributors","parent":75,"ref":"37–38"},{"id":1087,"name":"descriptive terms for parts of works in text","parent":75,"ref":"70"},{"id":1088,"name":"descriptive terms in place of titles in citations","parent":75,"ref":"3.2.2"},{"id":1089,"name":"descriptive terms for unexpected types of works","parent":75,"ref":"52"},{"id":1090,"name":"descriptive terms for untitled sources","parent":75,"ref":"28–29"},{"id":76,"name":"ignored in alphabetization diacritics","parent":null,"ref":"2.7.1"},{"id":1091,"name":"dialogue quotations consisting solely of","parent":77,"ref":"1.3.7"},{"id":1092,"name":"dialogue quoted from plays or screenplays","parent":77,"ref":"1.3.4"},{"id":1093,"name":"digital media dates needed for","parent":78,"ref":"42–43, 44–45"},{"id":1094,"name":"digital media gathering information on","parent":78,"ref":"17"},{"id":2088,"name":"in works-cited lists publishers","parent":1095,"ref":"41–42"},{"id":2089,"name":"in works-cited lists titles of containers","parent":1095,"ref":"31–35"},{"id":2090,"name":"in works-cited lists URLs and DOIs","parent":1095,"ref":"17, 48, 49, 128, 2.5.2"},{"id":2091,"name":"in works-cited lists versions","parent":1095,"ref":"39"},{"id":79,"name":"digital object identifiers (DOIs)","parent":null,"ref":"48, 2.5.2"},{"id":80,"name":"digital reference managers","parent":null,"ref":"12"},{"id":82,"name":"<em>Dr.</em> <em>Doctor</em>","parent":null,"ref":"1.1.2"},{"id":1096,"name":"documentation commonsense approach to","parent":83,"ref":"xii–xiii, 3–4"},{"id":1097,"name":"documentation development of MLA style of","parent":83,"ref":"x–xii"},{"id":1098,"name":"documentation evaluating sources for","parent":83,"ref":"3, 10–12"},{"id":1099,"name":"documentation gathering information for","parent":83,"ref":"13–18"},{"id":1100,"name":"documentation importance of","parent":83,"ref":"5–6"},{"id":1101,"name":"documentation in-text citations and","parent":83,"ref":"54–58"},{"id":1102,"name":"documentation organizing information for","parent":83,"ref":"19"},{"id":1103,"name":"documentation recordkeeping and","parent":83,"ref":"8, 9–10, 12"},{"id":1104,"name":"documentation in research projects in nonprint media","parent":83,"ref":"127–28"},{"id":84,"name":"DOIs (digital object identifiers)","parent":null,"ref":"48, 2.5.2"},{"id":1105,"name":"drama and plays quotations of","parent":85,"ref":"1.3.4"},{"id":1106,"name":"drama and plays titles of","parent":85,"ref":"27, 1.2.2"},{"id":1107,"name":"DVDs disc numbers in sets of","parent":86,"ref":"49"},{"id":1108,"name":"DVDs release dates of","parent":86,"ref":"44"},{"id":1109,"name":"e-books digital platforms for","parent":87,"ref":"31, 34, 47"},{"id":1110,"name":"e-books location indicators in","parent":87,"ref":"3.3.3"},{"id":88,"name":"<em>ed.","parent":null,"ref":"2.3</em>"},{"id":1111,"name":"editions publication dates of","parent":89,"ref":"45, 46"},{"id":1112,"name":"editions works in multiple","parent":89,"ref":"57, 3.3.2"},{"id":1113,"name":"in works-cited lists editors multiple works by","parent":90,"ref":"2.7.2"},{"id":1114,"name":"in works-cited lists editors multivolume works and","parent":90,"ref":"36"},{"id":1115,"name":"in works-cited lists editors as other contributors","parent":90,"ref":"37–38"},{"id":1116,"name":"in works-cited lists editors at start of entry","parent":90,"ref":"23"},{"id":1117,"name":"in works-cited lists editors three or more","parent":90,"ref":"23, 38"},{"id":1118,"name":"in works-cited lists editors two","parent":90,"ref":"23"},{"id":91,"name":"<em>e.g.</em>","parent":null,"ref":"1.6.2"},{"id":93,"name":"in quotations ellipses","parent":null,"ref":"1.3.5"},{"id":94,"name":"in works-cited lists e-mail messages","parent":null,"ref":"29"},{"id":95,"name":"use of <em>emphasis added</em>","parent":null,"ref":"1.3.6"},{"id":1119,"name":"essays in containers","parent":96,"ref":"32"},{"id":1120,"name":"essays titles of","parent":96,"ref":"27–28, 1.2.2"},{"id":97,"name":"<em>et al.</em>","parent":null,"ref":"1.6.2"},{"id":1121,"name":"<em>et al.</em> in in-text citations","parent":97,"ref":"3.1.1"},{"id":1122,"name":"<em>et al.</em> in works-cited lists","parent":97,"ref":"22, 23, 38"},{"id":98,"name":"ethics and documentation","parent":null,"ref":"6"},{"id":99,"name":"exclamation points and quotations","parent":null,"ref":"1.3.7"},{"id":101,"name":"fictional characters","parent":null,"ref":"1.1.3"},{"id":1123,"name":"television film digital platforms for","parent":102,"ref":"31, 33"},{"id":1124,"name":"television film gathering information on","parent":102,"ref":"18"},{"id":1125,"name":"television film research projects as","parent":102,"ref":"128"},{"id":1126,"name":"television film timings in","parent":102,"ref":"57"},{"id":2092,"name":"in works-cited lists contributors treated as authors","parent":1127,"ref":"24"},{"id":2093,"name":"in works-cited lists disc numbers in DVD sets","parent":1127,"ref":"49"},{"id":2094,"name":"in works-cited lists networks of airing","parent":1127,"ref":"43"},{"id":2095,"name":"in works-cited lists other contributors","parent":1127,"ref":"38"},{"id":2096,"name":"in works-cited lists production or distribution companies","parent":1127,"ref":"41"},{"id":2097,"name":"in works-cited lists release dates","parent":1127,"ref":"43–44"},{"id":2098,"name":"in works-cited lists seasons and episode numbers","parent":1127,"ref":"40"},{"id":2099,"name":"in works-cited lists series and episode titles","parent":1127,"ref":"24, 28, 30, 33"},{"id":2100,"name":"in works-cited lists URLs","parent":1127,"ref":"48"},{"id":2101,"name":"in works-cited lists versions","parent":1127,"ref":"39"},{"id":103,"name":"as titles first lines of poems","parent":null,"ref":"1.2.1"},{"id":1128,"name":"forewords documenting","parent":104,"ref":"2.2.1"},{"id":1129,"name":"forewords referred to in text","parent":104,"ref":"70"},{"id":105,"name":"online forums","parent":null,"ref":"29, 44"},{"id":1130,"name":"forward slashes for line and stanza breaks in poetry","parent":106,"ref":"1.3.3"},{"id":2102,"name":"in works-cited lists separating comparable items","parent":1131,"ref":"2.6.2"},{"id":2103,"name":"in works-cited lists separating copublishers","parent":1131,"ref":"2.4"},{"id":1132,"name":"French names of persons in","parent":108,"ref":"64"},{"id":1133,"name":"French titles of sources in","parent":108,"ref":"72"},{"id":1134,"name":"of books front matter documenting","parent":109,"ref":"2.2.1"},{"id":1135,"name":"of books front matter referred to in text","parent":109,"ref":"70"},{"id":1136,"name":"German names of persons in","parent":110,"ref":"64–65"},{"id":1137,"name":"German titles of sources in","parent":110,"ref":"72–73"},{"id":111,"name":"<em>Google</em>","parent":null,"ref":"12"},{"id":1138,"name":"Greek documenting ancient works in","parent":113,"ref":"122"},{"id":1139,"name":"Greek quotations and titles of sources in","parent":113,"ref":"74, 1.3.8"},{"id":1140,"name":"hanging indention for quoted dialogue","parent":114,"ref":"1.3.4"},{"id":1141,"name":"hanging indention for quoted poetry","parent":114,"ref":"79"},{"id":1142,"name":"hanging indention in works-cited lists","parent":114,"ref":"2.7"},{"id":115,"name":"quotations and titles of sources in Hebrew","parent":null,"ref":"74, 1.3.8"},{"id":116,"name":"names of persons in Hungarian","parent":null,"ref":"62"},{"id":1143,"name":"hyphens for authors’ names in works-cited lists","parent":117,"ref":"2.1.3, 2.7.2–3"},{"id":1144,"name":"hyphens in compound terms and capitalization","parent":117,"ref":"1.2.1"},{"id":1145,"name":"hyphens in person’s names","parent":117,"ref":"1.1.1"},{"id":118,"name":"<em>i.e.","parent":null,"ref":"1.6.2</em>"},{"id":119,"name":"publishers’ imprints","parent":null,"ref":"109"},{"id":1146,"name":"indention of quotations","parent":120,"ref":"55, 76–77"},{"id":1147,"name":"indention of quotations with translations","parent":120,"ref":"1.3.8"},{"id":1148,"name":"indention of quoted dialogue","parent":120,"ref":"1.3.4"},{"id":1149,"name":"indention in quoted poetry unusual","parent":120,"ref":"79"},{"id":121,"name":"not capitalized in titles infinitives","parent":null,"ref":"1.2.1"},{"id":1150,"name":"institutions objects in","parent":122,"ref":"49–50"},{"id":1151,"name":"institutions romanizing non-English names of","parent":122,"ref":"1.3.8"},{"id":1152,"name":"Internet finding and retrieving sources on","parent":123,"ref":"11"},{"id":1153,"name":"Internet research papers purchased on","parent":123,"ref":"7–8"},{"id":1154,"name":"Internet URLs and DOIs and","parent":123,"ref":"17, 48, 49, 128, 2.5.2"},{"id":124,"name":"in-text citations","parent":null,"ref":"54–58, 3.1–6"},{"id":2104,"name":"abbreviations in authors’ first names","parent":1155,"ref":"55"},{"id":2105,"name":"abbreviations in corporate authors","parent":1155,"ref":"3.1.2"},{"id":2106,"name":"abbreviations in indirect sources (<em>qtd. in</em>)","parent":1155,"ref":"3.4"},{"id":2107,"name":"abbreviations in three or more authors (<em>et al.</em>)","parent":1155,"ref":"3.1.1"},{"id":2108,"name":"abbreviations in titles of sources","parent":1155,"ref":"55–56, 1.6.4, 3.2.1"},{"id":1156,"name":"in-text citations coauthors in","parent":124,"ref":"3.1.1"},{"id":1157,"name":"in-text citations corporate authors in","parent":124,"ref":"55–56, 3.1.2"},{"id":1158,"name":"in-text citations descriptive terms in","parent":124,"ref":"3.2.2"},{"id":1159,"name":"in-text citations goals of","parent":124,"ref":"19, 54, 58, 116"},{"id":1160,"name":"in-text citations indirect sources in","parent":124,"ref":"3.4"},{"id":1161,"name":"in-text citations prefaces introductions","parent":124,"ref":"2.2.1"},{"id":1162,"name":"in-text citations multiple sources in","parent":124,"ref":"3.6"},{"id":1163,"name":"in-text citations multivolume works in","parent":124,"ref":"3.3.1"},{"id":2109,"name":"numbers in location indicators other than pages","parent":1164,"ref":"3.3.2–3, 3.6"},{"id":2110,"name":"numbers in style","parent":1164,"ref":"3.3.1"},{"id":2111,"name":"numbers in works in multiple editions","parent":1164,"ref":"3.3.2"},{"id":1165,"name":"in-text citations organizing information for","parent":124,"ref":"19"},{"id":1166,"name":"in-text citations punctuation and formatting of","parent":124,"ref":"54–58, 82, 1.3.2, 1.3.7, 3.6"},{"id":1167,"name":"in-text citations repeated use of sources and","parent":124,"ref":"3.5"},{"id":1168,"name":"in-text citations shortened titles of legal cases in","parent":124,"ref":"1.2.3"},{"id":1169,"name":"in-text citations translations of quotations and","parent":124,"ref":"1.3.8"},{"id":1170,"name":"introductions documenting","parent":125,"ref":"2.2.1"},{"id":1171,"name":"introductions referred to in text","parent":125,"ref":"70"},{"id":1173,"name":"introductions names of persons in","parent":125,"ref":"65"},{"id":1174,"name":"introductions titles of sources in","parent":125,"ref":"73"},{"id":2112,"name":"in text added to quotations","parent":1175,"ref":"1.3.6"},{"id":2113,"name":"in text titles of sources","parent":1175,"ref":"1.2.2"},{"id":2114,"name":"in text titles within titles","parent":1175,"ref":"1.2.4"},{"id":2115,"name":"in works-cited lists titles of containers","parent":1176,"ref":"30, 31"},{"id":2116,"name":"in works-cited lists titles of sources","parent":1176,"ref":"25–29, 1.2.2"},{"id":1177,"name":"Japanese names of persons in","parent":127,"ref":"62, 63"},{"id":1178,"name":"Japanese quotations and titles of sources in","parent":127,"ref":"74, 1.3.8"},{"id":129,"name":"research projects presented with <em>Keynote</em>","parent":null,"ref":"128"},{"id":130,"name":"Qur’an) Koran (Quran","parent":null,"ref":"69, 122–23"},{"id":131,"name":"names of persons in Korean","parent":null,"ref":"62, 63"},{"id":1179,"name":"languages other than English capitalization in","parent":133,"ref":"1.2.5"},{"id":2117,"name":"capitalization in French","parent":1179,"ref":"72"},{"id":2118,"name":"capitalization in German","parent":1179,"ref":"72–73"},{"id":2119,"name":"capitalization in Italian","parent":1179,"ref":"73"},{"id":2120,"name":"capitalization in Latin","parent":1179,"ref":"73–74"},{"id":2121,"name":"capitalization in Spanish","parent":1179,"ref":"74"},{"id":1180,"name":"languages other than English names of persons in","parent":133,"ref":"1.1.4"},{"id":2122,"name":"names of persons in Asian languages","parent":1180,"ref":"62, 63–64"},{"id":2123,"name":"names of persons in first and subsequent uses in text","parent":1180,"ref":"1.1.1"},{"id":2124,"name":"names of persons in French","parent":1180,"ref":"64"},{"id":2125,"name":"names of persons in German","parent":1180,"ref":"64–65"},{"id":2126,"name":"names of persons in Italian","parent":1180,"ref":"65"},{"id":2127,"name":"names of persons in Latin","parent":1180,"ref":"65–66"},{"id":2128,"name":"names of persons in Spanish","parent":1180,"ref":"66"},{"id":2129,"name":"names of persons in variant forms of names","parent":1180,"ref":"2.1.1"},{"id":1181,"name":"languages other than English titles of sources in","parent":133,"ref":"1.2.5"},{"id":2130,"name":"titles of sources in French","parent":1181,"ref":"72"},{"id":2131,"name":"titles of sources in German","parent":1181,"ref":"72–73"},{"id":2132,"name":"titles of sources in initial articles ignored in alphabetizing","parent":1181,"ref":"2.7.4"},{"id":2133,"name":"titles of sources in Italian","parent":1181,"ref":"73"},{"id":2134,"name":"titles of sources in Latin","parent":1181,"ref":"73–74"},{"id":2135,"name":"titles of sources in other languages","parent":1181,"ref":"75"},{"id":2136,"name":"titles of sources in romanized languages","parent":1181,"ref":"74"},{"id":2137,"name":"titles of sources in Spanish","parent":1181,"ref":"74"},{"id":2138,"name":"titles of sources in translations","parent":1181,"ref":"1.2.5, 2.2.2"},{"id":1182,"name":"Latin documenting ancient works in","parent":134,"ref":"122"},{"id":1183,"name":"Latin names of persons in","parent":134,"ref":"65–66"},{"id":1184,"name":"Latin titles of sources in","parent":134,"ref":"73–74"},{"id":135,"name":"titles of laws","parent":null,"ref":"69"},{"id":137,"name":"shortened titles of legal cases","parent":null,"ref":"1.2.3"},{"id":1185,"name":"reports legislative bills in text titles of","parent":138,"ref":"69"},{"id":1186,"name":"reports legislative bills in works-cited lists","parent":138,"ref":"53, 2.1.3"},{"id":1187,"name":"commonly studied literary works fictional characters in","parent":140,"ref":"1.1.3"},{"id":2139,"name":"in in-text citations format and punctuation","parent":1188,"ref":"1.3.2, 1.3.7, 3.6"},{"id":2140,"name":"in in-text citations numbers","parent":1188,"ref":"57, 3.3.2"},{"id":1189,"name":"live presentations research projects as","parent":141,"ref":"128"},{"id":2141,"name":"in works-cited lists descriptive terms","parent":1190,"ref":"52"},{"id":2142,"name":"in works-cited lists other contributors","parent":1190,"ref":"38"},{"id":2143,"name":"in works-cited lists city venue","parent":1190,"ref":"50"},{"id":142,"name":"locations","parent":null,"ref":"46, 48–50, 2.5"},{"id":1191,"name":"locations gathering information on","parent":142,"ref":"14"},{"id":2144,"name":"in works-cited lists disc numbers in DVD sets","parent":1192,"ref":"49"},{"id":2145,"name":"in works-cited lists objects located in places","parent":1192,"ref":"49–50"},{"id":2146,"name":"in works-cited lists page numbers","parent":1192,"ref":"46"},{"id":2147,"name":"in works-cited lists page numbers not consecutive in periodicals","parent":1192,"ref":"2.5.1"},{"id":2148,"name":"in works-cited lists URLs and DOIs","parent":1192,"ref":"17, 48, 49, 128, 2.5.2"},{"id":1193,"name":"manuscripts dates of","parent":144,"ref":"1.5"},{"id":1194,"name":"manuscripts locations of","parent":144,"ref":"50"},{"id":145,"name":"of authors married names","parent":null,"ref":"2.1.1"},{"id":146,"name":"writing of measurements","parent":null,"ref":"1.4.1"},{"id":148,"name":"documenting medieval works","parent":null,"ref":"122"},{"id":149,"name":"online messages","parent":null,"ref":"29"},{"id":150,"name":"history of <em>MLA Handbook</em>","parent":null,"ref":"x–xii"},{"id":151,"name":"abbreviations for months","parent":null,"ref":"1.5, 1.6.1"},{"id":1195,"name":"multiple authors in in-text citations","parent":152,"ref":"3.1.1"},{"id":1196,"name":"multiple authors in works-cited lists","parent":152,"ref":"21–23, 2.7.3"},{"id":1197,"name":"multivolume works in in-text citations","parent":153,"ref":"3.3.1"},{"id":1198,"name":"multivolume works in works-cited lists","parent":153,"ref":"36, 39, 3.3.1"},{"id":2149,"name":"in works-cited lists total number of volumes","parent":1198,"ref":"51–52"},{"id":154,"name":"objects in museums","parent":null,"ref":"49–50"},{"id":155,"name":"identified by form musical compositions","parent":null,"ref":"69"},{"id":1199,"name":"names of persons in fiction","parent":157,"ref":"1.1.3"},{"id":1200,"name":"names of persons initials and","parent":157,"ref":"1.6"},{"id":1201,"name":"names of persons <em>Jr.</em> and <em>Sr.</em> with","parent":157,"ref":"1.1.1, 2.1.2"},{"id":1202,"name":"names of persons in languages other than English","parent":157,"ref":"1.1.4"},{"id":2150,"name":"in languages other than English Asian languages","parent":1202,"ref":"62, 63–64"},{"id":2151,"name":"in languages other than English French","parent":1202,"ref":"64"},{"id":2152,"name":"in languages other than English German","parent":1202,"ref":"64–65"},{"id":2153,"name":"in languages other than English Italian","parent":1202,"ref":"65"},{"id":2154,"name":"in languages other than English Latin","parent":1202,"ref":"65–66"},{"id":2155,"name":"in languages other than English romanization","parent":1202,"ref":"1.3.8"},{"id":2156,"name":"in languages other than English Spanish","parent":1202,"ref":"66"},{"id":1203,"name":"names of persons order of","parent":157,"ref":"1.1.1"},{"id":1204,"name":"names of persons pseudonymous 24,<em> 1.1.3</em>,","parent":157,"ref":"2.1.1"},{"id":1205,"name":"names of persons roman numerals with","parent":157,"ref":"1.4.4, 2.1.2"},{"id":1206,"name":"names of persons simplified","parent":157,"ref":"1.1.3"},{"id":1207,"name":"names of persons first and subsequent use of in text","parent":157,"ref":"1.1.1"},{"id":1208,"name":"names of persons with titles","parent":157,"ref":"1.1.2"},{"id":160,"name":"titles abbreviated as noun phrases","parent":null,"ref":"3.2.1"},{"id":1209,"name":"nouns capitalized in titles","parent":161,"ref":"1.2.1"},{"id":1210,"name":"nouns in languages other than English","parent":161,"ref":"1.2.5"},{"id":162,"name":"titles of novellas","parent":null,"ref":"1.2.2"},{"id":1211,"name":"novels in containers","parent":163,"ref":"36"},{"id":1212,"name":"novels titles of","parent":163,"ref":"25–27, 1.2.2"},{"id":2157,"name":"in in-text citations e-books","parent":1213,"ref":"3.3.3"},{"id":2158,"name":"in in-text citations location indicators other than pages","parent":1213,"ref":"3.3.2–3, 3.6"},{"id":2159,"name":"in in-text citations sections paragraphs","parent":1213,"ref":"56–57, 78, 121"},{"id":2160,"name":"in in-text citations parts of poetry","parent":1213,"ref":"121–22, 1.3.3"},{"id":2161,"name":"in in-text citations sources without page or part numbers","parent":1213,"ref":"56"},{"id":2162,"name":"in in-text citations style","parent":1213,"ref":"3.3.1"},{"id":2163,"name":"in in-text citations works in multiple editions","parent":1213,"ref":"3.3.2"},{"id":2164,"name":"in text beginning of sentences","parent":1214,"ref":"1.4.1"},{"id":2165,"name":"in text commas","parent":1214,"ref":"1.4.2"},{"id":2166,"name":"in text inclusive ranges","parent":1214,"ref":"1.4.3"},{"id":2167,"name":"in text musical compositions","parent":1214,"ref":"69"},{"id":2168,"name":"in text sections paragraphs","parent":1214,"ref":"1.6.2"},{"id":2169,"name":"in text plurals","parent":1214,"ref":"1.4.1"},{"id":2170,"name":"in text use of numerals or words","parent":1214,"ref":"1.4.1"},{"id":2171,"name":"in works-cited lists alphabetizing titles","parent":1215,"ref":"2.7.4"},{"id":2172,"name":"in works-cited lists discs in DVD sets","parent":1215,"ref":"49"},{"id":2173,"name":"in works-cited lists editions","parent":1215,"ref":"2.3"},{"id":2174,"name":"in works-cited lists episodes","parent":1215,"ref":"40"},{"id":2175,"name":"in works-cited lists issues","parent":1215,"ref":"39–40"},{"id":2176,"name":"in works-cited lists seasons of television series","parent":1215,"ref":"40"},{"id":2177,"name":"in works-cited lists versions","parent":1215,"ref":"2.3"},{"id":2178,"name":"in works-cited lists volumes","parent":1215,"ref":"39"},{"id":1216,"name":"in works-cited lists objects generic descriptions of","parent":165,"ref":"28–29"},{"id":1217,"name":"in works-cited lists objects locations of","parent":165,"ref":"49–50"},{"id":1218,"name":"online databases journal articles in","parent":166,"ref":"3"},{"id":1219,"name":"online databases possibly incorrect dates in","parent":166,"ref":"47"},{"id":1220,"name":"online databases in works-cited lists","parent":166,"ref":"31"},{"id":167,"name":"in works-cited lists online forums","parent":null,"ref":"29, 44"},{"id":168,"name":"of authors online usernames","parent":null,"ref":"24, 2.1.1"},{"id":1221,"name":"in works-cited lists optional elements access dates as","parent":169,"ref":"53"},{"id":1222,"name":"in works-cited lists optional elements cities of publication of books as","parent":169,"ref":"51"},{"id":1223,"name":"in works-cited lists optional elements dates of prior publication as","parent":169,"ref":"50, 53"},{"id":1224,"name":"in works-cited lists optional elements decisions on including","parent":169,"ref":"50"},{"id":1225,"name":"in works-cited lists optional elements series as","parent":169,"ref":"52"},{"id":1226,"name":"in works-cited lists optional elements total numbers of volumes as","parent":169,"ref":"51–52"},{"id":1227,"name":"in works-cited lists optional elements types of works as","parent":169,"ref":"52"},{"id":170,"name":"romanizing non-English names of organizations","parent":null,"ref":"1.3.8"},{"id":171,"name":"other contributors","parent":null,"ref":"37–38"},{"id":1228,"name":"other contributors given alone last names of","parent":171,"ref":"103, 2.2.1"},{"id":1229,"name":"other contributors original authors as","parent":171,"ref":"23"},{"id":1230,"name":"page numbers abbreviation with","parent":172,"ref":"1.6.2"},{"id":1231,"name":"page numbers commas not used in","parent":172,"ref":"1.4.2"},{"id":1232,"name":"page numbers in in-text citations","parent":172,"ref":"54–58, 3.3.1"},{"id":2179,"name":"in in-text citations works in multiple editions","parent":1232,"ref":"3.3.2"},{"id":2180,"name":"in works-cited lists book collections","parent":1233,"ref":"46"},{"id":2181,"name":"in works-cited lists in periodicals consecutive","parent":1233,"ref":"46"},{"id":2182,"name":"in works-cited lists in periodicals not consecutive","parent":1233,"ref":"2.5.1"},{"id":2183,"name":"in works-cited lists plus signs","parent":1233,"ref":"2.5.1"},{"id":1234,"name":"paragraphs abbreviation with numbers for","parent":174,"ref":"1.6.2"},{"id":1235,"name":"paragraphs in block quotations","parent":174,"ref":"77"},{"id":1236,"name":"paraphrasing avoiding plagiarism in","parent":175,"ref":"9"},{"id":1237,"name":"paraphrasing integrated in text","parent":175,"ref":"1.3.1"},{"id":1238,"name":"paraphrasing sources needed for","parent":175,"ref":"57–58"},{"id":2184,"name":"with quotations alterations to sources","parent":1239,"ref":"1.3.6"},{"id":2185,"name":"with quotations ellipses in sources","parent":1239,"ref":"85"},{"id":1240,"name":"parentheses real names of pseudonymous authors in","parent":176,"ref":"2.1.1"},{"id":2186,"name":"in text full Latin names","parent":1241,"ref":"65"},{"id":2187,"name":"in text shortened titles","parent":1241,"ref":"1.2.3"},{"id":2188,"name":"in text translations of quotations","parent":1241,"ref":"1.3.8"},{"id":2189,"name":"in text translations of titles","parent":1241,"ref":"1.2.5"},{"id":178,"name":"William Riley Parker","parent":null,"ref":"x"},{"id":179,"name":"Tim Parks","parent":null,"ref":"ix, xiii"},{"id":1242,"name":"other than page numbers part numbers abbreviations with","parent":180,"ref":"1.6.2"},{"id":1243,"name":"other than page numbers part numbers in in-text citations","parent":180,"ref":"56, 3.3.2"},{"id":1244,"name":"periodicals on digital platforms back issues of","parent":182,"ref":"31"},{"id":1245,"name":"periodicals gathering information on","parent":182,"ref":"16"},{"id":1246,"name":"periodicals specialized style of page numbers in","parent":182,"ref":"3.3.1"},{"id":2190,"name":"in works-cited lists authors","parent":1247,"ref":"21"},{"id":2191,"name":"in works-cited lists cities of publication of newspapers","parent":1247,"ref":"2.6.1"},{"id":2192,"name":"in works-cited lists formats for titles","parent":1247,"ref":"27–28, 30"},{"id":2193,"name":"in works-cited lists consecutive page numbers","parent":1247,"ref":"46"},{"id":2194,"name":"in works-cited lists not consecutive page numbers","parent":1247,"ref":"2.5.1"},{"id":2195,"name":"in works-cited lists pseudonymous authors","parent":1247,"ref":"24"},{"id":2196,"name":"in works-cited lists publication dates","parent":1247,"ref":"42–43, 44–45"},{"id":2197,"name":"in works-cited lists publishers omitted","parent":1247,"ref":"42"},{"id":2198,"name":"in works-cited lists seasons","parent":1247,"ref":"1.5"},{"id":2199,"name":"in works-cited lists volume and issue numbers","parent":1247,"ref":"39–40"},{"id":1248,"name":"periods (punctuation) in abbreviations","parent":183,"ref":"1.6"},{"id":1249,"name":"periods (punctuation) ellipses with","parent":183,"ref":"1.3.5"},{"id":1250,"name":"periods (punctuation) quotation marks with","parent":183,"ref":"88–89, 1.2.4, 1.3.2"},{"id":1251,"name":"periods (punctuation) in works-cited lists","parent":183,"ref":"20"},{"id":184,"name":"permalinks","parent":null,"ref":"48"},{"id":185,"name":"pinyin","parent":null,"ref":"63–64"},{"id":1252,"name":"place-names in languages other than English","parent":186,"ref":"1.2.5"},{"id":1253,"name":"place-names romanizing","parent":186,"ref":"1.3.8"},{"id":1254,"name":"plagiarism avoiding","parent":187,"ref":"9–10"},{"id":1255,"name":"plagiarism common knowledge and","parent":187,"ref":"10"},{"id":1256,"name":"plagiarism definition of","parent":187,"ref":"6–7"},{"id":1257,"name":"plagiarism forms of","parent":187,"ref":"7–9"},{"id":1258,"name":"plagiarism of own writings","parent":187,"ref":"8"},{"id":1259,"name":"plagiarism seriousness of","parent":187,"ref":"7"},{"id":189,"name":"plus signs with page numbers","parent":null,"ref":"2.5.1"},{"id":1260,"name":"poetry gathering information on","parent":190,"ref":"16"},{"id":1261,"name":"poetry quotations of","parent":190,"ref":"1.3.3"},{"id":2200,"name":"quotations of division numbers","parent":1261,"ref":"121–22, 1.3.3, 3.3.2"},{"id":2201,"name":"quotations of ellipses","parent":1261,"ref":"83–85"},{"id":2202,"name":"quotations of line and stanza breaks","parent":1261,"ref":"1.3.3"},{"id":1262,"name":"poetry titles of works of","parent":190,"ref":"26–27, 1.2.2"},{"id":2203,"name":"titles of works of first lines as titles","parent":1262,"ref":"1.2.1"},{"id":2204,"name":"titles of works of titles within titles","parent":1262,"ref":"1.2.4"},{"id":2205,"name":"titles of works of untitled","parent":1262,"ref":"1.2.1"},{"id":192,"name":"research projects presented with <em>PowerPoint</em>","parent":null,"ref":"128"},{"id":1263,"name":"prefaces documenting","parent":193,"ref":"2.2.1"},{"id":1264,"name":"prefaces referred to in text","parent":193,"ref":"70"},{"id":194,"name":"prepositions in titles","parent":null,"ref":"1.2.1"},{"id":1265,"name":"pronouns altered in quotations","parent":195,"ref":"1.3.1, 1.3.6"},{"id":1266,"name":"pronouns capitalized in titles","parent":195,"ref":"1.2.1"},{"id":1267,"name":"pronouns in languages other than English","parent":195,"ref":"1.2.5"},{"id":196,"name":"prose style and mechanics","parent":null,"ref":"61–101"},{"id":1268,"name":"prose style and mechanics abbreviations","parent":196,"ref":"1.6"},{"id":1269,"name":"prose style and mechanics dates and times","parent":196,"ref":"1.5"},{"id":1270,"name":"prose style and mechanics names of persons","parent":196,"ref":"1.1"},{"id":1271,"name":"prose style and mechanics numbers","parent":196,"ref":"1.4"},{"id":1272,"name":"prose style and mechanics quotations","parent":196,"ref":"1.3"},{"id":1273,"name":"prose style and mechanics titles of sources","parent":196,"ref":"1.2"},{"id":1274,"name":"pseudonyms in text","parent":197,"ref":"1.1.3"},{"id":1275,"name":"pseudonyms in works-cited lists","parent":197,"ref":"24, 2.1.1"},{"id":198,"name":"publication dates","parent":null,"ref":"42–45"},{"id":1276,"name":"publication dates gathering information on","parent":198,"ref":"15, 45, 46, 47"},{"id":2206,"name":"in works-cited lists abbreviations for months","parent":1277,"ref":"1.6.1"},{"id":2207,"name":"in works-cited lists approximated","parent":1277,"ref":"2.6.1"},{"id":2208,"name":"in works-cited lists books","parent":1277,"ref":"45, 46"},{"id":2209,"name":"in works-cited lists DVDs","parent":1277,"ref":"44"},{"id":2210,"name":"in works-cited lists original","parent":1277,"ref":"50, 53"},{"id":2211,"name":"in works-cited lists periodicals","parent":1277,"ref":"45"},{"id":2212,"name":"in works-cited lists prior","parent":1277,"ref":"50, 53"},{"id":2213,"name":"in works-cited lists television episodes","parent":1277,"ref":"43"},{"id":2214,"name":"in works-cited lists Web sites","parent":1277,"ref":"42–43, 44–45"},{"id":1278,"name":"publication facts evaluating","parent":199,"ref":"12"},{"id":1279,"name":"publication facts gathering","parent":199,"ref":"13, 14–18"},{"id":1280,"name":"publication facts missing in sources","parent":199,"ref":"2.6.1"},{"id":1281,"name":"publishers definition of","parent":200,"ref":"40"},{"id":1282,"name":"publishers gathering information on","parent":200,"ref":"14, 41, 2.4"},{"id":2215,"name":"in works-cited lists abbreviations","parent":1283,"ref":"1.6.2–3"},{"id":2216,"name":"in works-cited lists copublishers","parent":1283,"ref":"40–41, 2.4, 2.6.2"},{"id":2217,"name":"in works-cited lists corporate authors as publishers","parent":1283,"ref":"25, 2.1.3"},{"id":2218,"name":"in works-cited lists imprints","parent":1283,"ref":"2.4"},{"id":2219,"name":"in works-cited lists missing in sources","parent":1283,"ref":"2.6.1"},{"id":2220,"name":"in works-cited lists multiple publishers of a source","parent":1283,"ref":"40–41"},{"id":2221,"name":"in works-cited lists omitting publishers","parent":1283,"ref":"42"},{"id":2222,"name":"in works-cited lists online media","parent":1283,"ref":"41–42"},{"id":2223,"name":"in works-cited lists parent companies and divisions","parent":1283,"ref":"2.4"},{"id":1284,"name":"punctuation in abbreviations","parent":201,"ref":"1.6"},{"id":1285,"name":"punctuation in in-text citations","parent":201,"ref":"54–58, 3.6"},{"id":2224,"name":"in text ellipses","parent":1286,"ref":"1.3.5"},{"id":1287,"name":"punctuation in works-cited lists","parent":201,"ref":"20, 2.6"},{"id":2226,"name":"in works-cited lists authors’ names","parent":1287,"ref":"21–22"},{"id":2227,"name":"in works-cited lists multiple works by same author","parent":1287,"ref":"2.7.2"},{"id":2228,"name":"in works-cited lists titles of containers","parent":1287,"ref":"30"},{"id":2229,"name":"in works-cited lists titles of sources","parent":1287,"ref":"1.2.1"},{"id":1288,"name":"question marks and quotations","parent":202,"ref":"1.3.7"},{"id":1289,"name":"question marks uncertain dates indicated by","parent":202,"ref":"1.5, 2.6.1"},{"id":1290,"name":"quotation marks in-text citations and","parent":203,"ref":"54"},{"id":1291,"name":"quotation marks with poetry quotations","parent":203,"ref":"1.3.3, 1.3.7"},{"id":1292,"name":"quotation marks with prose quotations","parent":203,"ref":"1.3.2, 1.3.7"},{"id":1293,"name":"quotation marks single and double","parent":203,"ref":"1.2.4, 1.3.7–8"},{"id":1294,"name":"quotation marks with titles of sources","parent":203,"ref":"25–29, 1.2.2"},{"id":1295,"name":"quotation marks titles within titles and","parent":203,"ref":"1.2.4"},{"id":204,"name":"quotations","parent":null,"ref":"1.3"},{"id":1296,"name":"quotations accuracy and effective use of","parent":204,"ref":"1.3.1"},{"id":1297,"name":"quotations altered for clarity","parent":204,"ref":"1.3.1, 1.3.6"},{"id":1298,"name":"quotations of drama","parent":204,"ref":"1.3.4"},{"id":1299,"name":"quotations ellipses in","parent":204,"ref":"1.3.5"},{"id":1300,"name":"quotations in-text citations and","parent":204,"ref":"54–58"},{"id":2230,"name":"in-text citations and alterations of quotations","parent":1300,"ref":"1.3.1, 1.3.6"},{"id":2231,"name":"in-text citations and location indicators other than pages","parent":1300,"ref":"3.3.2"},{"id":1301,"name":"quotations of poetry","parent":204,"ref":"1.3.3, 1.3.7"},{"id":1302,"name":"quotations of prose","parent":204,"ref":"1.3.2, 1.3.7"},{"id":1303,"name":"quotations punctuation with","parent":204,"ref":"1.3.7"},{"id":2232,"name":"punctuation with colons before block quotations","parent":1303,"ref":"1.3.2–3, 1.3.7"},{"id":2233,"name":"punctuation with retained from original source","parent":1303,"ref":"1.3.7"},{"id":1304,"name":"quotations quotations consisting solely of","parent":204,"ref":"1.3.7"},{"id":1305,"name":"quotations titles including","parent":204,"ref":"1.2.1"},{"id":1306,"name":"quotations translations of","parent":204,"ref":"1.3.8"},{"id":1307,"name":"quotations from works in multiple editions","parent":204,"ref":"3.3.2"},{"id":205,"name":"Koran) Qur’an (Quran","parent":null,"ref":"69, 122–23"},{"id":1308,"name":"audio recordings timings in","parent":206,"ref":"57"},{"id":1309,"name":"audio recordings titles of songs and albums","parent":206,"ref":"28"},{"id":1310,"name":"audio recordings in works-cited lists versions of","parent":206,"ref":"39"},{"id":207,"name":"recordkeeping in research","parent":null,"ref":"8, 9–10, 12"},{"id":208,"name":"names of persons in Renaissance","parent":null,"ref":"65–66"},{"id":210,"name":"<em>rev.","parent":null,"ref":"2.3</em>"},{"id":211,"name":"untitled reviews","parent":null,"ref":"29"},{"id":212,"name":"romanization","parent":null,"ref":"63–64"},{"id":1311,"name":"romanization of authors’ names","parent":212,"ref":"1.3.8, 2.1.1"},{"id":1312,"name":"romanization of quotations","parent":212,"ref":"74, 1.3.8"},{"id":1313,"name":"romanization of titles of sources","parent":212,"ref":"74, 1.3.8"},{"id":213,"name":"roman numerals","parent":null,"ref":"1.4.4"},{"id":1314,"name":"roman numerals arabic numerals vs.","parent":213,"ref":"1.4"},{"id":1315,"name":"roman numerals names of persons with","parent":213,"ref":"1.4.4, 2.1.2"},{"id":1316,"name":"roman numerals page numbers as","parent":213,"ref":"3.3.1"},{"id":1317,"name":"roman numerals reduced use of","parent":213,"ref":"xi"},{"id":214,"name":"ancient Roman works","parent":null,"ref":"122"},{"id":1318,"name":"Russian authors’ names in","parent":215,"ref":"2.1.1"},{"id":1319,"name":"Russian quotations and titles of sources in","parent":215,"ref":"74, 1.3.8"},{"id":216,"name":"use of title <em>Saint</em>","parent":null,"ref":"1.1.2"},{"id":1320,"name":"scripture documentation of","parent":217,"ref":"122–23"},{"id":1321,"name":"scripture titles in","parent":217,"ref":"69"},{"id":218,"name":"search engines","parent":null,"ref":"x, 12"},{"id":1322,"name":"seasons in publication dates","parent":219,"ref":"1.5"},{"id":1323,"name":"seasons of a television series","parent":219,"ref":"40"},{"id":221,"name":"self-published works","parent":null,"ref":"42"},{"id":1324,"name":"semicolons in in-text citations","parent":222,"ref":"1.3.8, 3.3.2, 3.6"},{"id":1325,"name":"semicolons with quotation marks","parent":222,"ref":"89"},{"id":223,"name":"seminar titles","parent":null,"ref":"70"},{"id":224,"name":"numbered series","parent":null,"ref":"1.4.1"},{"id":1326,"name":"William Shakespeare abbreviations for titles of","parent":225,"ref":"100–01, 3.2.1"},{"id":1327,"name":"William Shakespeare location indicators other than pages in","parent":225,"ref":"121–22"},{"id":226,"name":"<em>sic","parent":null,"ref":"1.3.6</em>"},{"id":227,"name":"use of title <em>Sir</em>","parent":null,"ref":"1.1.2"},{"id":229,"name":"research projects as slide-based presentations","parent":null,"ref":"128"},{"id":1328,"name":"software for managing information about sources","parent":230,"ref":"12"},{"id":1329,"name":"software research projects presented with","parent":230,"ref":"128"},{"id":1330,"name":"sources authority of","parent":232,"ref":"10–12"},{"id":1331,"name":"sources differences among copies of","parent":232,"ref":"31"},{"id":1332,"name":"sources evaluating","parent":232,"ref":"10–12"},{"id":1333,"name":"sources gathering information on","parent":232,"ref":"13–18"},{"id":1334,"name":"sources indirect","parent":232,"ref":"3.4"},{"id":1335,"name":"sources mobility of","parent":232,"ref":"3"},{"id":1336,"name":"sources in research tracking","parent":232,"ref":"8, 9–10, 12"},{"id":1337,"name":"Spanish names of persons in","parent":233,"ref":"66"},{"id":1338,"name":"Spanish titles of sources in","parent":233,"ref":"74"},{"id":1339,"name":"square brackets in in-text citations","parent":235,"ref":"3.6"},{"id":2234,"name":"with quotations alterations","parent":1340,"ref":"1.3.1"},{"id":2235,"name":"with quotations explanations","parent":1340,"ref":"1.3.6"},{"id":2236,"name":"in works-cited lists translations of titles","parent":1341,"ref":"2.2.2"},{"id":2237,"name":"in works-cited lists uncertain or additional information","parent":1341,"ref":"2.6.1"},{"id":1342,"name":"stories in containers","parent":236,"ref":"35"},{"id":1343,"name":"stories titles of","parent":236,"ref":"26–27, 1.2.2"},{"id":237,"name":"street addresses","parent":null,"ref":"1.4.2"},{"id":1344,"name":"subtitles capitalization and punctuation of","parent":238,"ref":"25, 27, 1.2.1"},{"id":1345,"name":"subtitles on books finding","parent":238,"ref":"14, 27"},{"id":1346,"name":"subtitles in text omitting","parent":238,"ref":"1.2.3"},{"id":239,"name":"suffixes of authors’ names","parent":null,"ref":"2.1.2"},{"id":1347,"name":"symbols and special characters @","parent":240,"ref":"24, 2.1.1, 2.7.1"},{"id":1348,"name":"symbols and special characters accents and other diacritics","parent":240,"ref":"2.7.1"},{"id":1349,"name":"symbols and special characters numbers used with","parent":240,"ref":"1.4.1"},{"id":1350,"name":"Talmud abbreviations for books in","parent":242,"ref":"97–99"},{"id":1351,"name":"Talmud in in-text citations","parent":242,"ref":"122"},{"id":1352,"name":"Talmud titles of","parent":242,"ref":"69"},{"id":246,"name":"times and time zones","parent":null,"ref":"1.5"},{"id":1353,"name":"title pages publication dates on","parent":247,"ref":"45, 47"},{"id":1354,"name":"title pages publisher information on","parent":247,"ref":"14, 41, 107–09"},{"id":1355,"name":"title pages titles and subtitles on","parent":247,"ref":"26–27"},{"id":248,"name":"omitted titles of authors","parent":null,"ref":"1.1.2, 2.1.2"},{"id":1356,"name":"titles of containers definition of","parent":249,"ref":"30–31"},{"id":1357,"name":"titles of containers italics for","parent":249,"ref":"1.2.2"},{"id":1358,"name":"titles of containers for nested containers","parent":249,"ref":"31–36"},{"id":1359,"name":"titles of sources formatting","parent":250,"ref":"1.2"},{"id":2238,"name":"formatting capitalization and punctuation","parent":1359,"ref":"1.2.1"},{"id":2239,"name":"formatting italics and quotation marks","parent":1359,"ref":"1.2.2"},{"id":2240,"name":"formatting languages other than English","parent":1359,"ref":"1.2.5"},{"id":2241,"name":"formatting quotations in titles","parent":1359,"ref":"1.2.1"},{"id":2242,"name":"formatting titles within titles","parent":1359,"ref":"1.2.4"},{"id":2243,"name":"formatting untitled poems","parent":1359,"ref":"1.2.1"},{"id":1360,"name":"titles of sources gathering information on","parent":250,"ref":"13–18, 67"},{"id":1361,"name":"titles of sources in in-text citations","parent":250,"ref":"55–56, 3.2"},{"id":2244,"name":"in in-text citations abbreviating titles","parent":1361,"ref":"1.6.4, 3.2.1"},{"id":2245,"name":"in in-text citations descriptive terms in place of titles","parent":1361,"ref":"3.2.2"},{"id":1362,"name":"titles of sources shortened forms of in text","parent":250,"ref":"1.2.3"},{"id":1363,"name":"titles of sources in works-cited lists","parent":250,"ref":"25–29, 2.2"},{"id":2246,"name":"in works-cited lists alphabetizing by titles","parent":1363,"ref":"2.7.4"},{"id":2247,"name":"in works-cited lists articles online or in print","parent":1363,"ref":"27–28"},{"id":2248,"name":"in works-cited lists prefaces introductions","parent":1363,"ref":"2.2.1"},{"id":2249,"name":"in works-cited lists songs and other parts of albums","parent":1363,"ref":"28"},{"id":2250,"name":"in works-cited lists start of entry","parent":1363,"ref":"24–25, 2.7.4"},{"id":2251,"name":"in works-cited lists translations of titles","parent":1363,"ref":"2.2.2"},{"id":2252,"name":"in works-cited lists untitled works","parent":1363,"ref":"28–29"},{"id":251,"name":"<em>to</em> in infinitives in titles","parent":null,"ref":"1.2.1"},{"id":1364,"name":"translations of quotations","parent":253,"ref":"1.3.8"},{"id":1365,"name":"translations of titles","parent":253,"ref":"72, 2.2.2"},{"id":1366,"name":"translators’ names <em>my trans</em>. in place of","parent":254,"ref":"1.3.8"},{"id":1367,"name":"translators’ names in works-cited lists","parent":254,"ref":"23, 37, 38"},{"id":255,"name":"treaty titles","parent":null,"ref":"69"},{"id":2253,"name":"names of authors of alphabetizing","parent":1368,"ref":"112"},{"id":2254,"name":"names of authors of formatting","parent":1368,"ref":"24"},{"id":2255,"name":"names of authors of real names added","parent":1368,"ref":"102"},{"id":1369,"name":"in works-cited lists tweets titles of","parent":256,"ref":"29"},{"id":258,"name":"uniform resource locators (URLs)","parent":null,"ref":"17, 48, 49, 128, 2.5.2"},{"id":259,"name":"as author United Nations","parent":null,"ref":"25, 2.1.3"},{"id":260,"name":"departments and agencies of United States","parent":null,"ref":"2.1.3, 3.1.2"},{"id":261,"name":"as author United States Congress","parent":null,"ref":"53, 2.1.3"},{"id":262,"name":"abbreviations of <em>University</em>","parent":null,"ref":"1.6.2–3"},{"id":263,"name":"names of university presses","parent":null,"ref":"1.6.3"},{"id":1370,"name":"untitled sources poems as","parent":264,"ref":"1.2.1"},{"id":1371,"name":"untitled sources in works-cited lists","parent":264,"ref":"28–29"},{"id":265,"name":"Upanishads","parent":null,"ref":"69"},{"id":266,"name":"URLs","parent":null,"ref":"17, 48, 49, 128, 2.5.2"},{"id":267,"name":"capitalized in titles verbs","parent":null,"ref":"1.2.1"},{"id":2256,"name":"in in-text citations scripture","parent":1372,"ref":"122–23"},{"id":2257,"name":"in in-text citations works in multiple editions","parent":1372,"ref":"57, 3.3.2"},{"id":1373,"name":"versions in works-cited lists","parent":268,"ref":"38–39, 2.3"},{"id":270,"name":"names of persons in Vietnamese","parent":null,"ref":"63, 1.1.1"},{"id":272,"name":"in German last names <em>von</em>","parent":null,"ref":"64–65"},{"id":273,"name":"Wade-Giles system","parent":null,"ref":"63–64"},{"id":1374,"name":"Web sites italics for titles of","parent":274,"ref":"1.2.2"},{"id":2258,"name":"in works-cited lists dates","parent":1375,"ref":"42–43, 44–45, 53"},{"id":2259,"name":"in works-cited lists publishers","parent":1375,"ref":"41–42"},{"id":2260,"name":"in works-cited lists titles","parent":1375,"ref":"28, 30"},{"id":2261,"name":"in works-cited lists URLs and DOIs","parent":1375,"ref":"17, 48, 49, 128, 2.5.2"},{"id":275,"name":"<em>Wikipedia</em>","parent":null,"ref":"12"},{"id":276,"name":"works-cited lists","parent":null,"ref":"20–54, 102–16"},{"id":1376,"name":"works-cited lists core elements of","parent":276,"ref":"20–54"},{"id":2262,"name":"core elements of authors’ names","parent":1376,"ref":"21–25, 2.1, 2.7.2–3"},{"id":2263,"name":"core elements of locations","parent":1376,"ref":"46, 48–50"},{"id":2264,"name":"core elements of multiple comparable items","parent":1376,"ref":"2.6.2"},{"id":2265,"name":"core elements of numbers","parent":1376,"ref":"39–40"},{"id":2266,"name":"core elements of other contributors","parent":1376,"ref":"37–38"},{"id":2267,"name":"core elements of publication dates","parent":1376,"ref":"42–45, 46, 1.5, 1.6.1"},{"id":2268,"name":"core elements of publishers","parent":1376,"ref":"40–42, 1.6.2–3"},{"id":2269,"name":"core elements of titles of containers","parent":1376,"ref":"30–36"},{"id":2270,"name":"core elements of titles of sources","parent":1376,"ref":"25–29, 1.2, 2.2"},{"id":2271,"name":"core elements of versions","parent":1376,"ref":"38–39"},{"id":2272,"name":"cross-references in varying names of authors","parent":1377,"ref":"2.1.1"},{"id":2273,"name":"cross-references in works in collections","parent":1377,"ref":"2.7.5"},{"id":1378,"name":"works-cited lists definition of","parent":276,"ref":"20"},{"id":1379,"name":"works-cited lists formatting and ordering","parent":276,"ref":"2.7"},{"id":2274,"name":"formatting and ordering hanging indention","parent":1379,"ref":"2.7"},{"id":2275,"name":"formatting and ordering heading","parent":1379,"ref":"20, 2.7"},{"id":2276,"name":"formatting and ordering letter-by-letter alphabetization","parent":1379,"ref":"2.7.1"},{"id":2277,"name":"formatting and ordering multiple works by coauthors","parent":1379,"ref":"2.7.2–3"},{"id":2278,"name":"formatting and ordering multiple works by one author","parent":1379,"ref":"2.1.3, 2.7.2"},{"id":2279,"name":"formatting and ordering titles used for alphabetization","parent":1379,"ref":"2.7.4"},{"id":1380,"name":"works-cited lists in-text citations in relation to","parent":276,"ref":"54"},{"id":1381,"name":"works-cited lists names in languages other than English in","parent":276,"ref":"1.1.1, 1.1.4"},{"id":1382,"name":"works-cited lists optional elements in","parent":276,"ref":"50–53"},{"id":1383,"name":"works-cited lists organizing information for","parent":276,"ref":"3–4, 19"},{"id":1384,"name":"works-cited lists in research projects in nonprint media","parent":276,"ref":"128"},{"id":1385,"name":"works-cited lists seasons in","parent":276,"ref":"1.5"},{"id":1386,"name":"works-cited lists template for","parent":276,"ref":"129"},{"id":277,"name":"workshop titles","parent":null,"ref":"70"},{"id":1387,"name":"years in works-cited list approximated","parent":278,"ref":"2.6.1"},{"id":1388,"name":"years commas not used in","parent":278,"ref":"1.4.2"},{"id":1389,"name":"years ranges of","parent":278,"ref":"1.4.3"}]

},{}],58:[function(require,module,exports){
/* FAQ module */

/*global document*/

module.exports = function ($) {

  'use strict';

  $('a.toggle-answer').each(function() {
    $(this).on('click', function(e) {
      e.preventDefault();

      $(this)
        .toggleClass('toggle')
        .siblings('.answer').toggle();
    });
  });

};

},{}],59:[function(require,module,exports){
(function (global){
/**
 * Main theme JS file driven by CommonJS and Browserify.
 */

'use strict';

var jQuery = (typeof window !== "undefined" ? window['jQuery'] : typeof global !== "undefined" ? global['jQuery'] : null);
var underscore = (typeof window !== "undefined" ? window['_'] : typeof global !== "undefined" ? global['_'] : null);
var Backbone = (typeof window !== "undefined" ? window['Backbone'] : typeof global !== "undefined" ? global['Backbone'] : null);

// Side-shim jQuery and Underscore before requiring Marionette.
Backbone.$ = jQuery;
Backbone._ = underscore;
require('backbone.marionette');

// Create the application.
var App = new Backbone.Marionette.Application();

// Add regions.
App.addRegions({
  BookRefs: '#search-book-refs',
  Content: '#citation-tool'
}); 


// Load Marionette modules.
App.module('BookIndex', require('./book-index'));
App.module('Citations', require('./citations'));

// Start the history listener.
App.on('start', function () {
  // expect DOM to be loaded at this point
  // Load generic modules.
  //require('./search-hints')(jQuery);
  require('./page-menu')(jQuery);
  require('./faq')(jQuery);
  require('./bylines')(jQuery);
  require('./teaching-resources')(jQuery);

  Backbone.history.start({
    pushState: true,
    root: '/'
  });
});

// Start the application.
App.start();

}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})

},{"./book-index":39,"./bylines":47,"./citations":49,"./faq":58,"./page-menu":60,"./teaching-resources":61,"backbone.marionette":6}],60:[function(require,module,exports){
/* Page menu module */

/*global document*/

module.exports = function ($) {

  'use strict';

  var $button = $('.page-sub-menu-link');
  var $targets = $('.page-sub-menu-link, .page-sub-menu');
  var $parent = $('.page-menu');

  var activeClass = 'page-menu-active';
  var hoverOutDelay = 250;

  $targets.on({
    mouseover: function() {
      if ($button.prop('hoverTimeout')) {
        $button.prop('hoverTimeout', clearTimeout($button.prop('hoverTimeout')));
      }
      $parent.addClass(activeClass);
    },
    mouseleave: function() {
      $button.prop('hoverTimeout', setTimeout(function() {
        $parent.removeClass(activeClass);
      }, hoverOutDelay));
    }
  });

  if ('ontouchstart' in document) {

    $button.on('touchstart', function(e) {

        e.stopPropagation();

        if ($parent.hasClass(activeClass)) {
          $parent.removeClass(activeClass);
        } else {
          $parent.addClass(activeClass);
        }

    });

  }

};

},{}],61:[function(require,module,exports){
/* Teaching Resources module */

/*global document*/

module.exports = function ($) {
	'use strict';

	$('a.toggle-category').each(function() {
    	$(this).on('click', function(e) {
      		e.preventDefault();

      		$(this).closest('section').find('.open-category').toggle();
      		$(this).closest('section').toggleClass('open');
	    });
 	});
	
};
},{}]},{},[59])

